"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[961],{

/***/ 8923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ActionButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1183);
/* harmony import */ var _Button_Button_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2256);
/* harmony import */ var _Link_Link_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1397);
/* Dependencies */ 



/**
 * Button component
 * @param props - Component props.
 */ var ActionButton = function(param) {
    var children = param.children, className = param.className, onClick = param.onClick, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _arrowDirection = param.arrowDirection, arrowDirection = _arrowDirection === void 0 ? "Right" : _arrowDirection, _type = param.type, type = _type === void 0 ? "submit" : _type, _hasIcon = param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon;
    if (variant === "Transparent") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            onClick: function() {
                return onClick();
            },
            className: "".concat(className || "", " font-display-a text-xs transition-colors lg:text-2xl ").concat(_Button_Button_model__WEBPACK_IMPORTED_MODULE_1__/* .variants */ .o[variant], " flex items-center"),
            type: type,
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "ml-1 h-5 w-5 ".concat(_Link_Link_model__WEBPACK_IMPORTED_MODULE_2__/* .iconVariants.base */ .s.base),
                    "aria-hidden": "true"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        onClick: function() {
            return onClick();
        },
        className: "".concat(className || "", " group relative inline-flex min-w-max overflow-hidden font-display-a ").concat(arrowDirection === "Right" ? "pr-[18px]" : "", " ").concat(arrowDirection === "Left" ? "pl-[18px]" : ""),
        type: type,
        children: [
            !hasIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "w-full ".concat(_Button_Button_model__WEBPACK_IMPORTED_MODULE_1__/* .variants */ .o[variant], " border-y \n          ").concat(arrowDirection === "None" ? "rounded border px-6 py-2.5" : "py-2", " \n          ").concat(arrowDirection === "Right" ? "rounded-l border-l pl-6 pr-4" : "", " \n          ").concat(arrowDirection === "Left" ? "rounded-r border-r pr-6 pl-4" : "", " \n          ").concat(_Button_Button_model__WEBPACK_IMPORTED_MODULE_1__/* .borderVariants */ .d[variant], " relative inline-flex text-xs transition-colors lg:text-2xl lg:leading-4"),
                children: children
            }),
            hasIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "w-full ".concat(_Button_Button_model__WEBPACK_IMPORTED_MODULE_1__/* .variants */ .o[variant], " border-y \n          ").concat(arrowDirection === "None" ? "rounded border p-2.5" : "py-2", " \n          ").concat(arrowDirection === "Right" ? "rounded-l border-l pl-2.5 pr-1.5" : "", " \n          ").concat(arrowDirection === "Left" ? "rounded-r border-r pr-2.5 pl-1.5" : "", " \n          ").concat(_Button_Button_model__WEBPACK_IMPORTED_MODULE_1__/* .borderVariants */ .d[variant], " relative inline-flex items-center justify-between text-xs transition-colors lg:text-15px lg:leading-4"),
                children: children
            }),
            arrowDirection !== "None" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "clip-button_".concat(arrowDirection === null || arrowDirection === void 0 ? void 0 : arrowDirection.toLowerCase(), " ").concat(_Button_Button_model__WEBPACK_IMPORTED_MODULE_1__/* .variants */ .o[variant], " rounded border ").concat(_Button_Button_model__WEBPACK_IMPORTED_MODULE_1__/* .borderVariants */ .d[variant], " transition-colors")
            })
        ]
    });
};


/***/ }),

/***/ 8496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BlockQuote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* Dependencies */ 
/**
 * Block Quote
 * @param props - Required component props.
 * @returns
 */ var BlockQuote = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
        className: "blockquote mx-auto w-full max-w-800 sm:px-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: children
        })
    });
};


/***/ }),

/***/ 9866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ Tag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Atoms/Tag/Tag.model.ts
var theme = Object.freeze({
    Transparent: "bg-fill",
    Red: "theme-red bg-fill",
    Blue: "theme-blue bg-fill",
    Plum: "theme-plum bg-fill"
});

;// CONCATENATED MODULE: ./src/components/Atoms/Tag/Tag.tsx
/* Dependencies */ 
// Models

/**
 * Link component
 * @param props - Component props.
 */ var Tag = function(param) {
    var children = param.children, className = param.className, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "Transparent" : _backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "".concat(className || "", " m-0 mt-4 mr-2 flex min-w-55 items-center justify-center rounded-md px-3 py-0.5 text-center font-display-a text-xs font-medium text-primary last:mr-0 lg:min-w-80 lg:rounded-[10px] lg:py-[3px] lg:text-small ").concat(theme[backgroundColor]),
        children: children
    });
};


/***/ }),

/***/ 23:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ UnorderedList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* Dependencies */ 
/**
 * Unordered List
 * @param props - Required component props.
 * @returns
 */ var UnorderedList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "list-unordered w-full text-2xl leading-6",
        children: children
    });
};


/***/ }),

/***/ 5153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ MapComponents; }
});

// UNUSED EXPORTS: enhanceComponents

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Atoms/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(5121);
// EXTERNAL MODULE: ./src/components/Atoms/Paragraph/Paragraph.tsx + 1 modules
var Paragraph = __webpack_require__(4609);
// EXTERNAL MODULE: ./src/components/Atoms/Link/Link.tsx + 2 modules
var Link = __webpack_require__(2601);
// EXTERNAL MODULE: ./src/components/Atoms/UnorderedList/UnorderedList.tsx
var UnorderedList = __webpack_require__(23);
// EXTERNAL MODULE: ./src/components/Atoms/LinkButton/LinkButton.tsx
var LinkButton = __webpack_require__(94);
// EXTERNAL MODULE: ./src/components/Atoms/BlockQuote/BlockQuote.tsx
var BlockQuote = __webpack_require__(8496);
// EXTERNAL MODULE: ./src/components/Molecules/ContainerArrow/ContainerArrow.tsx + 1 modules
var ContainerArrow = __webpack_require__(6911);
// EXTERNAL MODULE: ./src/components/Molecules/ComponentWrapper/ComponentWrapper.tsx + 1 modules
var ComponentWrapper = __webpack_require__(6175);
;// CONCATENATED MODULE: ./src/components/Organisms/DemoComponent/DemoComponent.tsx
/* Dependencies */ 
// Components








// Models
/**
 * Demo Components
 * @param props - Required props.
 */ var DemoComponent = function() {
    var entries = 5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "min-h-full w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
                backgroundColor: "Plum",
                className: "flex items-center overflow-hidden bg-insight-pattern bg-[length:65%] bg-right-top bg-no-repeat pt-10 pb-16 sm:bg-auto lg:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mx-auto w-full max-w-1550 lg:px-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-aos": "fade-up",
                            className: "px-10 lg:px-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* Heading */.X, {
                                    level: "h2",
                                    className: "mb-6 text-primary lg:mb-16",
                                    children: [
                                        "Insights ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " & Events"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                    level: "h3",
                                    style: "Heading 6",
                                    className: "mb-6 font-extrabold uppercase text-primary lg:mb-8",
                                    children: "Recent Posts"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-aos": "fade-up",
                            className: "".concat(entries > 1 ? "pl-10" : "px-10", " lg:px-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-flow-col gap-x-4 sm:gap-x-7 ".concat(entries > 1 ? "auto-cols-[calc(100%-12px)] grid-cols-[calc(100%-12px)] pr-10 lg:pr-0" : "auto-cols-[100%] grid-cols-[100%]", "\n          ").concat(entries >= 3 ? "sm:auto-cols-[calc(50%-27px)] sm:grid-cols-[calc(50%-27px)]" : "sm:auto-cols-[calc(50%-15px)] sm:grid-cols-[calc(50%-15px)]", " snap-x snap-proximity overflow-x-auto pb-6 lg:auto-cols-[calc(33.33%-19px)] lg:grid-cols-[calc(33.33%-19px)] xl:auto-cols-[calc(25%-21px)] xl:grid-cols-[calc(25%-21px)]")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h1",
                className: "",
                children: "FRONTEND KITCHEN SINK"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h1",
                className: "",
                children: "heading 1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h2",
                className: "",
                children: "heading 2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h3",
                className: "",
                children: "heading 3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h4",
                className: "",
                children: "subheading (h4)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h5",
                className: "",
                children: "just a spare heading 5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h6",
                className: "",
                children: "microheading (h6)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                children: "Paragraph atom: Lorem ipsum dolor sit amet consectetur adipiscing elit senectus malesuada, commodo urna himenaeos rhoncus per etiam metus in justo, dictum condimentum nam nisl penatibus sapien mi montes. Mattis feugiat ornare varius vel inceptos nunc odio luctus, massa hac tincidunt nisi fringilla habitasse netus cras, torquent ligula leo diam platea blandit gravida"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnorderedList/* UnorderedList */.Q, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            to: "https://www.google.com",
                            children: "Our services"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            to: "https://www.google.com",
                            variant: "none",
                            children: "Our services"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            to: "https://www.google.com",
                            variant: "primary",
                            children: "Contact"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            to: "https://www.google.com",
                            variant: "secondary",
                            children: "Anything else"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnorderedList/* UnorderedList */.Q, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Point 1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Point two"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Point three"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnorderedList/* UnorderedList */.Q, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Point 4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Point five"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Point 6"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "theme-red mb-3 bg-fill p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                    variant: "secondary",
                    to: "https://www.google.com",
                    children: "Link Button"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-3 bg-fill p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                    variant: "secondary",
                    to: "https://www.google.com",
                    children: "Link Button"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "theme-blue mb-3 bg-fill p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                    variant: "secondary",
                    to: "https://www.google.com",
                    children: "Link Button"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "theme-plum mb-3 bg-fill p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                    variant: "secondary",
                    arrowDirection: "Left",
                    to: "https://www.google.com",
                    children: "Link Button"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* BlockQuote */.R, {
                children: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet illum vero consequuntur fuga tempora! Modi quidem accusantium ipsam et possimus, veniam fugiat dignissimos minus optio soluta beatae repudiandae quibusdam perferendis."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex w-full items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerArrow/* ContainerArrow */.r, {
                        classNameWrapper: "w-7/12",
                        className: "flex flex-col justify-center pl-[10%] pr-[15%]",
                        arrowsSide: "Right",
                        overlap: true,
                        bgColour: "blue",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Text over the triangle"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                        classNameWrapper: "ml-auto w-7/12",
                        className: "pt-[75%]",
                        arrowsSide: "Left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "//picsum.photos/1240/1240/",
                            className: "absolute top-0 left-0 h-full w-full object-cover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex w-full items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerArrow/* ContainerArrow */.r, {
                        classNameWrapper: "w-7/12",
                        className: "flex flex-col justify-center pl-[10%] pr-[15%]",
                        arrowsSide: "Right",
                        overlap: true,
                        bgColour: "red",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Container with Border"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                        classNameWrapper: "ml-auto w-7/12",
                        className: "pt-[75%]",
                        border: true,
                        arrowsSide: "Left",
                        bgColour: "red",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "//picsum.photos/1240/1240/",
                            className: "absolute top-0 left-0 h-full w-full object-cover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex w-full items-stretch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                        classNameWrapper: "w-7/12",
                        className: "pt-[75%]",
                        arrowsSide: "Right",
                        bgColour: "red",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "//picsum.photos/1240/1240/",
                            className: "absolute top-0 left-0 h-full w-full object-cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerArrow/* ContainerArrow */.r, {
                        classNameWrapper: "w-7/12",
                        className: "flex flex-col justify-center py-16 pr-[10%] pl-[25%]",
                        arrowsSide: "Left",
                        overlap: false,
                        bgColour: "plum",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Container with Border 44"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Molecules/RichText/RichText.tsx + 1 modules
var RichText = __webpack_require__(6622);
;// CONCATENATED MODULE: ./src/components/Organisms/RichTextBlock/RichTextBlock.tsx
/* Dependencies */ 
// Components

/**
 * Rich Text Block Component
 * @params props - Required component props.
 */ var RichTextBlock = function(param) {
    var content = param.fields.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "my-12 mx-auto w-full max-w-1130 py-10 px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* RichText */.H, {
            content: content
        })
    });
};

// EXTERNAL MODULE: ./src/components/Molecules/Container/Container.tsx
var Container = __webpack_require__(6320);
;// CONCATENATED MODULE: ./src/components/Organisms/ColouredPanel/ColouredPanel.tsx
/* Dependencies */ 
// Components



/**
 * Coloured Panel
 * @param TypeBlockColouredPanel
 * @returns
 */ var ColouredPanel = function(param) {
    var _fields = param.fields, components = _fields.components, theme = _fields.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: theme.fields.colourScheme,
        className: "coloured-panel relative pt-28 pb-24 before:absolute before:-inset-0 before:block before:h-4 before:w-1/2 before:bg-white lg:pt-48 lg:before:h-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t- absolute top-0 left-1/2 -translate-x-1/2 border-x-[40px] border-t-[50px] border-solid border-x-transparent border-t-white lg:border-x-[125px] lg:border-t-[160px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "space-y-16 coloured-panel:px-0 lg:space-y-14",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapComponents, {
                    components: components
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Molecules/Image/Image.tsx
var Image_Image = __webpack_require__(3083);
// EXTERNAL MODULE: ./src/components/Atoms/PlainRichText/PlainRichText.tsx
var PlainRichText = __webpack_require__(9791);
// EXTERNAL MODULE: ./src/components/Atoms/Tag/Tag.tsx + 1 modules
var Tag = __webpack_require__(9866);
// EXTERNAL MODULE: ./src/helpers/getFormattedDate/getFormattedDate.ts
var getFormattedDate = __webpack_require__(2282);
;// CONCATENATED MODULE: ./src/components/Organisms/Con02/Con02.tsx
/* Dependencies */ 
// Components









// Helpers

/**
 * FEATURED POST - INEV06
 * @param TypeCon02
 * @returns
 */ var Con02 = function(param) {
    var _fields = param.fields, title = _fields.title, event = _fields.event, theme = _fields.theme;
    var ref, ref1;
    // Handle Circular Depenedency
    if (!event || !event.fields) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full bg-red p-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-center text-white",
                children: "The Featured event is not avialable for display. Please check the Contentful and ensure the block is not linking to itself. (Circular Dependency)"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            className: "max-w-1130 py-16 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-col rounded-md bg-white lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        to: "/events/".concat((ref = event.fields.slug) === null || ref === void 0 ? void 0 : ref.fields.slug),
                        variant: "none",
                        className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full overflow-hidden rounded-md lg:mb-4",
                        openInNewTab: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "view event"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-last w-full py-6 px-4 lg:order-first lg:w-3/5 lg:pr-24 lg:pl-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "mb-6 flex",
                                children: (ref1 = event.fields.tags) === null || ref1 === void 0 ? void 0 : ref1.map(function(param, index) {
                                    var _fields = param.fields, title = _fields.title, theme = _fields.theme;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                                        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
                                        className: "m-0 mr-2 last:mr-0",
                                        children: title
                                    }, "".concat(index));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                                style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                                className: "mb-6 font-display-s lg:mb-24",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: title === null || title === void 0 ? void 0 : title.fields.content
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col space-y-2",
                                children: event.fields.eventDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                            className: "font-display-a text-base",
                                            dateTime: "".concat(String(event.fields.eventDate)),
                                            children: (0,getFormattedDate/* getFormattedDate */.L0)(String(event.fields.eventDate))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                            className: "font-display-a text-base",
                                            dateTime: "".concat(String(event.fields.eventDate)),
                                            children: (0,getFormattedDate/* getFormattedTime */.xz)(String(event.fields.eventDate))
                                        })
                                    ]
                                })
                            }),
                            event.fields.location && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                className: "text-small",
                                children: event.fields.location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full pl-8 lg:w-2/5 lg:pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                            arrowsSide: "Left",
                            classNameWrapper: "w-full h-full overflow-hidden rounded-md",
                            children: event.fields.image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                            file: event.fields.image.fields.asset,
                                            aspectRatio: "absolute"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block lg:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                            file: event.fields.image.fields.asset
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Molecules/CTATandem/CTATandem.tsx
var CTATandem = __webpack_require__(9697);
;// CONCATENATED MODULE: ./src/components/Organisms/Con04/Con04.tsx
/* Dependencies */ 
// Components





/**
 * CONTENT FEATURED INSIGHT 2 - CON04
 * @param TypeCon04
 * @returns
 */ var Con04 = function(param) {
    var entries = param.fields.entries;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "max-w-1130 py-16 lg:py-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "lg:grid lg:grid-cols-2 lg:gap-4",
            children: entries && entries.map(function(entry, index) {
                var _fields = entry.fields, title = _fields.title, bodyCopy = _fields.bodyCopy, callToActions = _fields.callToActions, theme = _fields.theme;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    "data-aos-delay": (index % 2 * 300).toString(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComponentWrapper/* ComponentWrapper */.N, {
                        backgroundColor: theme.fields.colourScheme,
                        className: "mb-4 flex h-full flex-col justify-between rounded-md px-6 pt-14 pb-10 text-primary shadow-[0_4px_25px_0_rgba(0,0,0,0.05)] lg:px-16 lg:pt-2 lg:pb-14",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                        level: "h2",
                                        font: title.fields.fontFamily,
                                        style: title.fields.style,
                                        className: "mb-6 flex items-end text-xl lg:mb-12 lg:h-52 lg:text-3xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                            content: title.fields.content
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-5 font-display-s text-small lg:mb-12 lg:text-base",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                            content: bodyCopy
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                                callsToAction: callToActions,
                                className: "flex flex-wrap items-center"
                            })
                        ]
                    }, "entry_".concat(index))
                }, "".concat(entry.sys.id, "_").concat(index));
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con05/Con05.model.ts
var tileTheme = Object.freeze({
    Transparent: {
        false: "border-red hover:bg-red hover:text-white",
        true: "bg-red text-white"
    },
    Red: {
        false: "border-white hover:bg-white hover:text-red",
        true: "bg-white text-red"
    },
    Blue: {
        false: "border-red hover:bg-red hover:border-red hover:text-white",
        true: "bg-red border-red text-white"
    },
    Plum: {
        false: "border-white hover:bg-white hover:text-plum",
        true: "bg-white text-plum"
    }
});

;// CONCATENATED MODULE: ./src/components/Organisms/Con05/Con05.tsx
/* Dependencies */ 

// Components







/**
 * CONTENT BENEFITS GRID - CON05
 * @param TypeCon05
 * @returns
 */ var Con05 = function(param) {
    var _fields = param.fields, title = _fields.title, theme = _fields.theme, bodyCopy = _fields.bodyCopy, tiles = _fields.tiles;
    var ref = (0,react.useState)(), activeItem = ref[0], setActiveItem = ref[1];
    if (!activeItem && tiles) {
        setActiveItem(tiles[0]);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "max-w-1130 py-16 coloured-panel:py-4 lg:py-24",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h2",
                    font: "".concat(title.fields.fontFamily),
                    style: "".concat(title.fields.style),
                    className: "mb-6 text-center text-primary ".concat(bodyCopy ? "lg:mb-8" : "lg:mb-16"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: title.fields.content
                    })
                }),
                bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                    className: "text-primary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: bodyCopy.fields.content
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 md:flex md:justify-between md:gap-24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:w-4/12",
                            children: activeItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                className: "text-primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: activeItem.fields.contentToRender
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-7 grid grid-cols-2 gap-3 md:mt-0 md:w-4/5 md:gap-7",
                            children: tiles && tiles.map(function(tile, index) {
                                var _fields = tile.fields, image = _fields.image, title = _fields.title, hoverImage = _fields.hoverImage;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "group flex min-h-[75px] w-full flex-col rounded-md border border-red p-3 text-left text-primary transition md:py-8 md:px-6 ".concat(tileTheme[theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme]["".concat(activeItem === tile)]),
                                    onClick: function() {
                                        setActiveItem(tile);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-5 w-5 md:h-10 md:w-10 ".concat(hoverImage && activeItem !== tile ? "group-hover:hidden" : "", "\n                      ").concat(hoverImage && activeItem === tile ? "hidden" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                                file: image.fields.asset,
                                                aspectRatio: "fluid"
                                            })
                                        }),
                                        hoverImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-6 w-6 md:h-10 md:w-10 ".concat(activeItem !== tile ? "hidden group-hover:block" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                                file: hoverImage.fields.asset,
                                                aspectRatio: "fluid"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                            className: "mt-3 w-full text-xs md:mt-5 md:w-3/5 md:text-lg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                content: title
                                            })
                                        })
                                    ]
                                }, "tile_".concat(index));
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/helpers/getWindowWidth/getWindowWidth.ts
var getWindowWidth = __webpack_require__(3501);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 7 modules
var dialog = __webpack_require__(3825);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
;// CONCATENATED MODULE: ./src/components/Molecules/Modal/Modal.tsx
/* Dependencies */ 


/**
 * Modal
 * @param props - Required component props.
 */ var Modal = function(param) {
    var title = param.title, description = param.description, isOpen = param.isOpen, onClose = param.onClose, children = param.children, isLarge = param.isLarge;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: isOpen,
        onClose: onClose,
        className: "relative z-50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 bg-black/70",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 flex items-center justify-center py-4 px-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                    className: "mx-auto w-full ".concat(isLarge ? "max-w-2xl" : "max-w-lg", " relative max-h-full rounded bg-white px-8 py-11"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                            className: "mb-2 font-display-a text-base text-primary lg:mb-3",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Description */.V.Description, {
                            className: "text-lg leading-6 text-primary",
                            children: description
                        }),
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute -top-5 -right-6 block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "rounded-full border border-red bg-red p-2 text-white hover:bg-white hover:text-red focus:outline-none",
                                onClick: function() {
                                    return onClose();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Close"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                        className: "h-8 w-8",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Molecules/Hotspot/Hotspot.model.ts
/* Dependencies */ var hotspotThemes = Object.freeze({
    Primary: {
        background: "bg-white",
        backgroundAnimated: "bg-blue",
        icon: "fill-plum",
        iconAnimated: "fill-plum"
    },
    Secondary: {
        background: "bg-white",
        backgroundAnimated: "bg-red",
        icon: "fill-plum",
        iconAnimated: "fill-white"
    },
    Tertiary: {
        background: "bg-plum",
        backgroundAnimated: "bg-red",
        icon: "fill-white",
        iconAnimated: "fill-white"
    }
});

;// CONCATENATED MODULE: ./src/components/Molecules/Hotspot/Hotspot.tsx
/* Dependencies */ 




// Models

/**
 * Hotspot -For animated sections.
 * @param props - Required component props.
 * @returns
 */ var Hotspot = function(param) {
    var className = param.className, title = param.title, subheading = param.subheading, _side = param.side, side = _side === void 0 ? "Right" : _side, _index = param.index, index = _index === void 0 ? 0 : _index, _theme = param.theme, theme = _theme === void 0 ? "Primary" : _theme, _textSize = param.textSize, textSize = _textSize === void 0 ? "Large" : _textSize;
    var ref = (0,react.useState)(false), animated = ref[0], setanimated = ref[1];
    var ref1 = (0,react.useState)(false), openModal = ref1[0], setopenModal = ref1[1];
    var ref2 = (0,react.useState)(false), isDeskop = ref2[0], setisDeskop = ref2[1];
    var pathStyle = animated ? hotspotThemes[theme].iconAnimated : hotspotThemes[theme].icon;
    var animate = function() {
        setanimated(!animated);
    };
    var modalHandler = function() {
        if ((0,getWindowWidth/* getWindowWidth */.f)() >= 1024) {
            setisDeskop(true);
            setopenModal(false);
        } else if ((0,getWindowWidth/* getWindowWidth */.f)() <= 1024 && animated && !isDeskop) {
            setopenModal(true);
        } else {
            setopenModal(false);
            setanimated(false);
            setisDeskop(false);
        }
    };
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setTimeout(function() {
                modalHandler();
            }, 500);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0,react.useEffect)(function() {
        modalHandler();
    }, [
        animated
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[60px] lg:w-[47.5%] ".concat(className || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(side == "Right" ? "ml-auto pl-12" : "pr-12", " hidden max-w-max lg:block"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                        className: "font-display-a font-medium text-primary ".concat(textSize === "Large" ? "" : "text-[18px]", " ").concat(animated ? "animate-fadeInUp opacity-0" : "opacity-1 animate-fadeOutDown"),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                        className: "text-xs text-primary lg:text-2xl ".concat(animated ? "animate-fadeInUp opacity-0" : "opacity-1 animate-fadeOutDown"),
                        children: subheading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 bottom-8 h-px w-full bg-transparent",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "linear absolute inset-y-0 ".concat(side == "Right" ? "left-0 right-full" : "right-0 left-full", " ").concat(animated && side == "Right" ? "lg:right-0" : "", "\n            ").concat(animated && side == "Left" ? "lg:left-0" : "", " \n            block ").concat(hotspotThemes[theme].backgroundAnimated, " transition-all duration-500")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-max ".concat(side == "Left" ? "ml-auto" : ""),
                "data-aos": "zoom-in",
                "data-aos-delay": ((index + 1) * 50).toString(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return animate();
                        },
                        className: "".concat(animated ? "".concat(hotspotThemes[theme].backgroundAnimated, " hover:animate-none") : "".concat(hotspotThemes[theme].background, " hover:animate-beat"), " flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-full shadow-hotspot transition-colors duration-700 md:h-[60px] md:w-[60px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "38",
                            height: "37",
                            viewBox: "0 0 38 37",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-6 w-6 md:h-9 md:w-9",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "".concat(pathStyle, " "),
                                    d: "M32.7539 9.35615C32.4271 10.1299 32.9455 10.5689 33.7118 11.071C35.2234 12.0748 36.3891 13.499 37.0571 15.1578C37.725 16.8166 37.864 18.6329 37.456 20.3698C37.0571 22.1204 36.1295 23.7146 34.7924 24.9474C33.4553 26.1801 31.7701 26.995 29.9535 27.287C29.0023 27.4324 28.0338 27.4324 27.0826 27.287C26.877 27.2568 26.5586 27.3007 26.5502 26.966C26.5502 26.5599 26.4487 26.1428 26.6149 25.7532C26.6854 25.5913 26.8967 25.723 27.0629 25.7532C28.1783 25.9596 29.3269 25.921 30.425 25.6402C31.5231 25.3593 32.543 24.8433 33.4103 24.1298C34.2776 23.4163 34.9705 22.5233 35.4384 21.5159C35.9063 20.5084 36.1374 19.412 36.115 18.3065C36.0445 15.1648 34.4246 12.9149 31.503 11.5841C31.055 11.3811 30.8747 11.2466 31.0071 10.7006C31.3647 9.2353 31.2542 7.69856 30.6902 6.29612C30.1263 4.89368 29.136 3.69247 27.8518 2.85331C26.5797 1.99698 25.0679 1.54264 23.5215 1.55197C21.9752 1.56129 20.4693 2.03384 19.2082 2.90544C19.0883 3.01908 18.9276 3.08265 18.7602 3.08265C18.5929 3.08265 18.4322 3.01908 18.3123 2.90544C17.0431 2.02249 15.5233 1.54579 13.9636 1.54137C12.4038 1.53694 10.8812 2.00501 9.60675 2.88075C8.32301 3.73865 7.34049 4.95954 6.79184 6.37856C6.24318 7.79758 6.15481 9.34639 6.53868 10.8159C6.63447 11.2055 6.59505 11.3921 6.16963 11.5759C3.09593 12.8984 1.17451 16.0346 1.55203 19.0363C1.99435 22.5567 4.38627 25.1249 7.86003 25.7614C8.80725 25.9423 9.78323 25.9236 10.7224 25.7066C11.0746 25.6215 11.2126 25.6846 11.2267 26.0852C11.2577 27.2321 11.2605 27.2129 10.0998 27.3337C8.86627 27.4581 7.61966 27.3371 6.43561 26.978C5.25157 26.619 4.15481 26.0294 3.21185 25.245C2.2689 24.4605 1.49942 23.4977 0.950152 22.4149C0.400886 21.332 0.083256 20.1518 0.0165693 18.9458C-0.175009 15.5078 1.29845 12.7887 4.24256 10.8707C4.4493 10.7669 4.61595 10.6007 4.71753 10.3969C4.81911 10.1931 4.85015 9.96271 4.80602 9.74029C4.58345 6.32972 5.88227 3.54475 8.78412 1.61584C11.686 -0.313064 14.8104 -0.499643 17.9883 0.973788C18.222 1.10582 18.4873 1.17535 18.7574 1.17535C19.0276 1.17535 19.2929 1.10582 19.5265 0.973788C25.6542 -2.01972 32.7933 2.41155 32.7539 9.35615Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "".concat(pathStyle, " "),
                                    d: "M14.0059 29.8909C14.0059 28.0963 13.9845 26.3018 14.0059 24.5073C14.0059 24.0014 13.9017 23.6499 13.4152 23.4636C12.576 23.1414 12.306 22.5476 12.3915 21.6584C12.477 20.7691 12.3915 19.8425 12.4183 18.9346C12.4355 18.7854 12.4076 18.6344 12.338 18.5011C12.2685 18.3677 12.1605 18.2582 12.028 18.1864C11.5952 17.9257 11.2655 17.5247 11.0942 17.0506C10.9229 16.5765 10.9204 16.0582 11.0872 15.5825C11.234 15.1134 11.5338 14.7065 11.939 14.4262C12.3443 14.146 12.8318 14.0086 13.3244 14.0356C13.8055 14.0256 14.2767 14.1724 14.6665 14.4535C15.0562 14.7346 15.3433 15.1347 15.484 15.5931C15.6482 16.0696 15.643 16.5878 15.4693 17.0609C15.2956 17.534 14.9639 17.9333 14.5298 18.1918C14.3892 18.2689 14.2751 18.3862 14.2022 18.5286C14.1293 18.671 14.101 18.8319 14.1209 18.9905C14.1369 19.7653 14.1476 20.5428 14.1209 21.3176C14.1048 21.7196 14.2037 22.0072 14.5966 22.1536C15.5695 22.521 15.7754 23.2186 15.7593 24.2197C15.6925 27.9472 15.7192 31.6748 15.7593 35.389C15.7593 35.9481 15.5963 36.0999 15.0483 36.0812C14.0113 36.044 14.0113 36.0812 14.0113 35.0668L14.0059 29.8909ZM13.3431 16.8445C13.4848 16.8445 13.6208 16.7884 13.721 16.6886C13.8213 16.5887 13.8776 16.4532 13.8776 16.312C13.8848 16.2337 13.8744 16.1547 13.8473 16.0808C13.8201 16.007 13.7769 15.94 13.7207 15.8847C13.6644 15.8295 13.5966 15.7874 13.5221 15.7613C13.4475 15.7353 13.3682 15.7261 13.2896 15.7343C13.2103 15.7305 13.1312 15.7444 13.0579 15.775C12.9847 15.8055 12.9192 15.8519 12.8662 15.9108C12.8132 15.9697 12.7741 16.0396 12.7516 16.1154C12.7292 16.1913 12.7239 16.2712 12.7363 16.3493C12.7497 16.6794 12.9742 16.8419 13.3431 16.8472V16.8445Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "".concat(pathStyle, " "),
                                    d: "M21.9268 29.4059C21.9268 27.4841 21.9514 25.5596 21.9268 23.635C21.9268 23.0795 22.0473 22.6967 22.5867 22.4894C23.2986 22.2236 23.567 21.7345 23.4574 20.9955C23.4136 20.5766 23.4136 20.1544 23.4574 19.7355C23.504 18.9965 23.4164 18.4224 22.6989 17.8748C21.6392 17.0773 21.757 15.4824 22.7674 14.5999C23.0092 14.3977 23.2898 14.2441 23.5932 14.1479C23.8965 14.0518 24.2165 14.015 24.5346 14.0397C24.8527 14.0644 25.1626 14.1502 25.4463 14.292C25.7301 14.4338 25.982 14.6288 26.1875 14.8658C26.3936 15.1037 26.5457 15.381 26.6342 15.6797C26.7226 15.9784 26.7454 16.2919 26.701 16.5997C26.6566 16.9075 26.546 17.2028 26.3764 17.4665C26.2068 17.7301 25.982 17.9562 25.7165 18.13C25.5415 18.2207 25.3987 18.3605 25.3069 18.5313C25.215 18.702 25.1784 18.8957 25.2017 19.0869C25.2291 20.1236 25.1771 21.1656 25.2237 22.2023C25.2483 22.7339 25.0922 23.0928 24.5884 23.2921C23.8928 23.558 23.6929 24.0417 23.7039 24.786C23.7505 28.3001 23.7039 31.8169 23.7395 35.331C23.7395 35.9078 23.6053 36.1603 22.992 36.062C22.8331 36.0392 22.6716 36.0392 22.5128 36.062C22.0664 36.1151 21.9322 35.945 21.9377 35.5038C21.9268 33.4756 21.9268 31.4421 21.9268 29.4059ZM24.3501 15.727C23.9613 15.7695 23.7258 15.9769 23.7313 16.3277C23.7312 16.4001 23.7463 16.4717 23.7757 16.5382C23.8051 16.6047 23.8481 16.6646 23.9022 16.7144C23.9563 16.7642 24.0202 16.8027 24.0902 16.8276C24.1602 16.8526 24.2346 16.8634 24.3091 16.8594C24.3833 16.8684 24.4587 16.862 24.5302 16.8407C24.6018 16.8193 24.6678 16.7834 24.724 16.7354C24.7801 16.6874 24.8252 16.6284 24.8561 16.5623C24.887 16.4961 24.9031 16.4243 24.9033 16.3517C24.9389 15.9795 24.6815 15.7988 24.3474 15.727H24.3501Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    className: "".concat(pathStyle, " "),
                                    d: "M17.949 27.2113C17.949 24.4732 17.949 21.7377 17.949 19.0023C17.9718 18.8322 17.9411 18.6595 17.8608 18.5063C17.7806 18.3531 17.6545 18.2264 17.4987 18.1426C17.0686 17.879 16.7429 17.4847 16.5736 17.0225C16.4043 16.5603 16.4012 16.057 16.5647 15.5929C16.7099 15.136 17.006 14.7369 17.4083 14.4559C17.8106 14.1749 18.2972 14.0274 18.7945 14.0355C19.3032 14.009 19.8066 14.1455 20.2257 14.4236C20.6448 14.7016 20.9558 15.1055 21.11 15.5717C21.281 16.034 21.2842 16.5382 21.1192 17.0025C20.9542 17.4668 20.6306 17.8639 20.2009 18.1294C20.0381 18.2198 19.9066 18.3545 19.8231 18.5163C19.7395 18.6782 19.7076 18.8602 19.7312 19.0394C19.7312 24.4918 19.7312 29.9415 19.7505 35.3938C19.7505 35.959 19.5876 36.15 19.0239 36.0625C18.8646 36.0386 18.7024 36.0386 18.5431 36.0625C18.0623 36.1314 17.9242 35.9537 17.9297 35.4867C17.9711 32.7274 17.949 29.968 17.949 27.2113ZM18.8636 16.8399C18.9382 16.8431 19.0128 16.8318 19.0827 16.8066C19.1527 16.7814 19.2166 16.7428 19.2705 16.6932C19.3245 16.6436 19.3675 16.584 19.3968 16.518C19.4261 16.452 19.4412 16.381 19.4411 16.3093C19.4501 16.2308 19.4408 16.1515 19.4138 16.077C19.3869 16.0024 19.3429 15.9346 19.2852 15.8784C19.2275 15.8223 19.1575 15.7792 19.0803 15.7523C19.003 15.7254 18.9205 15.7153 18.8388 15.7229C18.7639 15.7193 18.689 15.7304 18.6188 15.7554C18.5485 15.7805 18.4843 15.819 18.43 15.8686C18.3757 15.9183 18.3325 15.978 18.303 16.0442C18.2736 16.1103 18.2584 16.1816 18.2585 16.2535C18.2519 16.3317 18.263 16.4103 18.291 16.4839C18.319 16.5576 18.3633 16.6246 18.4207 16.6802C18.4782 16.7359 18.5476 16.779 18.624 16.8066C18.7004 16.8342 18.7822 16.8455 18.8636 16.8399Z"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        title: "".concat(title),
                        description: "".concat(subheading),
                        isOpen: openModal,
                        onClose: function() {
                            return setanimated(false);
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con06/Con06.model.ts
var positions = Object.freeze([
    "top-[22.5%] left-[calc(50%+20px)] md:left-[calc(50%+45px)] md:top-[32.5%] lg:top-[30%] max-w-400 xl:max-w-500",
    "top-[47.5%] right-[calc(50%+110px)] md:top-[55%] lg:top-[50%] md:right-[calc(50%+195px)] lg:right-[calc(50%+165px)] xl:right-[calc(50%+195px)] max-w-335 xl:max-w-400",
    "top-[60%] left-[calc(50%+35px)] md:left-[calc(50%+65px)] md:top-[67%] lg:top-[62.5%] max-w-400 xl:max-w-500",
    "top-[80%] right-[calc(50%+15px)] md:top-[85%] lg:top-[80%] md:right-[calc(50%+35px)] max-w-400 xl:max-w-500",
    "top-[85%] left-[calc(50%+35px)] md:top-[90%] lg:top-[85%] md:left-[calc(50%+55px)] max-w-400 xl:max-w-500", 
]);
var sides = Object.freeze([
    "Right",
    "Left",
    "Right",
    "Left",
    "Right"
]);

;// CONCATENATED MODULE: ./src/components/Organisms/Con06/Con06.tsx
/* Dependencies */ 
// Components







/**
 * CONTENT GROWTH HOTSPOTS - Con06
 * @param TypeCon06
 * @returns
 */ var Con06 = function(param) {
    var _fields = param.fields, subheading = _fields.subheading, title = _fields.title, bodyCopy = _fields.bodyCopy, theme = _fields.theme, hotspots = _fields.hotspots;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        className: "flex items-center overflow-hidden py-16 lg:py-28",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "relative w-full sm:max-w-1270",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-aos": "fade-up",
                    className: "z-10 w-full max-w-400 md:absolute md:w-2/5",
                    children: [
                        subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            style: "Heading 6",
                            className: "mb-2.5 uppercase text-primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: subheading
                            })
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h3",
                            font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                            style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                            className: "mb-6 text-primary lg:mb-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title === null || title === void 0 ? void 0 : title.fields.content
                            })
                        }),
                        bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            className: "text-small text-primary lg:max-w-335 lg:text-base",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-full pt-8 md:pt-48",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-aos": "fade-up",
                            className: "mx-auto h-full w-full max-w-[275px] md:max-w-[480px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/svg/CON06-ourPledge.svg",
                                alt: "Central Main",
                                width: "482",
                                height: "793"
                            })
                        }),
                        hotspots === null || hotspots === void 0 ? void 0 : hotspots.map(function(param, index) {
                            var fields = param.fields;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotspot, {
                                title: "".concat(fields.title),
                                subheading: "".concat(fields.subheading),
                                className: "absolute ".concat(positions[index]),
                                side: "".concat(sides[index]),
                                index: index
                            }, "hotspot_".concat(index));
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var dist_aos = __webpack_require__(8279);
;// CONCATENATED MODULE: ./src/components/Atoms/Statistics/Statistics.tsx
/* Dependencies */ 

// importing aos


/**
 * POST CONTENT FIGURES - Statistics
 * @param TypeStatistic
 * @returns
 */ var Statistics = function(param) {
    var className = param.className, statistics = param.statistics, _size = param.size, size = _size === void 0 ? "Large" : _size;
    var gridStats = [
        "md:grid-cols-1",
        "md:grid-cols-2",
        "md:grid-cols-3"
    ];
    (0,react.useEffect)(function() {
        aos_default().init({
            throttleDelay: 5,
            offset: 50,
            duration: 750,
            delay: 150,
            once: true
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto max-w-974 ".concat(className || ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid gap-12 ".concat(size === "Large" ? "gap-x-20" : "", " ").concat(gridStats[statistics.length - 1], " justify-center"),
            children: statistics.map(function(param, index) {
                var _fields = param.fields, statistic = _fields.statistic, subheading = _fields.subheading;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-aos": "fade-up",
                    "data-aos-delay": ((index + 1) * 100).toString(),
                    className: "flex flex-col items-center space-y-2 text-center text-primary ".concat(size === "Large" ? "lg:space-y-4" : ""),
                    children: [
                        statistics && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-5xl font-normal ".concat(size === "Large" ? "md:text-6xl lg:text-7xl" : ""),
                            children: statistic
                        }),
                        subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-display-a text-sm font-medium  ".concat(size === "Large" ? "lg:text-2xl" : "lg:text-base"),
                            children: subheading
                        })
                    ]
                }, "statistic_".concat(index));
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con07/Con07.model.ts
var illustrationTypes = Object.freeze({
    BuildPlatforms: {
        url: "/assets/svg/CON07-buildplatforms.svg",
        width: "663",
        height: "675"
    },
    Partnerships: {
        url: "/assets/svg/CON07-partnerships.svg",
        width: "600",
        height: "669"
    }
});
var Con07_model_positions = Object.freeze({
    BuildPlatforms: [
        "left-[calc(50%-50px)] top-[25%] md:left-[calc(50%-50px)] lg:top-[10%] lg:left-[calc(50%-260px)] xl:left-[calc(50%-320px)] max-w-290 xl:max-w-335",
        "left-[calc(50%-110px)] top-[47%] md:left-[calc(50%-170px)] lg:top-[40%] lg:left-[calc(50%-330px)] xl:left-[calc(50%-400px)] max-w-290 xl:max-w-335",
        "left-[calc(50%+75px)] top-[65%] md:left-[calc(50%+125px)] lg:top-[55%] lg:left-[calc(50%+70px)] xl:left-[calc(50%+90px)] max-w-290 xl:max-w-335", 
    ],
    Partnerships: [
        "left-[calc(50%-140px)] top-[17.5%] md:left-[calc(50%-200px)] lg:top-[35%] lg:left-[calc(50%-340px)] xl:left-[calc(50%-450px)] max-w-290",
        "left-[calc(50%+85px)] top-[37.5%] md:left-[calc(50%+145px)] lg:top-[5%] lg:left-[calc(50%+60px)] xl:left-[calc(50%+125px)] max-w-290 xl:max-w-335",
        "left-[calc(50%+85px)] top-[72.5%] md:left-[calc(50%+145px)] lg:top-[67.5%] lg:left-[calc(50%+60px)] xl:left-[calc(50%+125px)] max-w-290 xl:max-w-335", 
    ]
});
var Con07_model_sides = Object.freeze({
    BuildPlatforms: [
        "Left",
        "Left",
        "Right"
    ],
    Partnerships: [
        "Left",
        "Right",
        "Right"
    ]
});

;// CONCATENATED MODULE: ./src/components/Organisms/Con07/Con07.tsx
/* Dependencies */ 
// Components








/**
 * CONTENT PARTNERSHIP HOTSPOTS - CON07
 * @param TypeCon07
 * @returns
 */ var Con07 = function(param) {
    var _fields = param.fields, subheading = _fields.subheading, title = _fields.title, bodyCopy = _fields.bodyCopy, theme = _fields.theme, hotspots = _fields.imagesWithHotspot, illustrationType = _fields.illustrationType, statistics = _fields.statistics, reverse = _fields.reverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        className: "flex items-center overflow-hidden py-12 coloured-panel:py-0 lg:py-28 coloured-panel:lg:py-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "relative grid w-full gap-y-12 gap-x-8 sm:max-w-1270 md:grid-cols-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full max-w-335 flex-col justify-between md:col-span-4 ".concat(reverse ? "md:order-2" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-aos": "fade-up",
                            children: [
                                subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                    level: "h2",
                                    style: "Heading 6",
                                    className: "mb-2.5 uppercase text-primary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                        content: subheading
                                    })
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                    level: "h3",
                                    font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                                    style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                                    className: "text-primary md:mb-6 lg:mb-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                        content: title === null || title === void 0 ? void 0 : title.fields.content
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden md:block",
                            "data-aos": "fade-up",
                            children: bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                className: "text-small text-primary lg:max-w-335 lg:text-base",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:col-span-8 ".concat(reverse ? "md:order-1" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative w-full xl:pr-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    className: "flex h-full max-h-[490px] w-full lg:max-h-[400px] xl:max-h-[490px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "mx-auto w-full max-w-250 md:max-w-none",
                                        src: illustrationTypes[illustrationType]["url"],
                                        alt: "Central Main",
                                        width: illustrationTypes[illustrationType]["width"],
                                        height: illustrationTypes[illustrationType]["height"]
                                    })
                                }),
                                hotspots === null || hotspots === void 0 ? void 0 : hotspots.map(function(param, index) {
                                    var fields = param.fields;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Hotspot, {
                                        title: "".concat(fields.title),
                                        subheading: "".concat(fields.subheading),
                                        className: "absolute ".concat(Con07_model_positions[illustrationType][index]),
                                        side: "".concat(Con07_model_sides[illustrationType][index]),
                                        index: index,
                                        theme: (theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme) === "Blue" ? "Tertiary" : "Secondary",
                                        textSize: "Small"
                                    }, "hotspot_".concat(index));
                                })
                            ]
                        }),
                        statistics && /*#__PURE__*/ (0,jsx_runtime.jsx)(Statistics, {
                            statistics: statistics,
                            size: "Small",
                            className: "mt-16 hidden sm:max-w-550 lg:block"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:hidden",
                    "data-aos": "fade-up",
                    children: bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                        className: "text-small text-primary lg:max-w-335 lg:text-base",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con08/Con08.tsx
/* Dependencies */ 
// Components






/**
 * CONTENT SPLIT - CON08
 * @param TypeCon08
 * @returns
 */ var Con08 = function(param) {
    var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy, image = _fields.image, listItems = _fields.listItems, callsToAction = _fields.callsToAction, Reverse = _fields.Reverse, hideArrow = _fields.hideArrow, theme = _fields.theme;
    // Set the background color of the component
    var bgColor = "transparent";
    if (theme) {
        bgColor = theme.fields.colourScheme.toLowerCase();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden lg:flex lg:justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(!Reverse && "order-last", " lg:w-1/2 lg:flex-shrink-0 lg:flex-grow-0"),
                children: !hideArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerArrow/* ContainerArrow */.r, {
                    arrowsSide: Reverse ? "Right" : "Left",
                    bgColour: bgColor,
                    className: "relative ".concat(Reverse ? "mr-5" : "ml-5", " flex min-h-[380px] items-center pl-10 lg:mx-0 lg:min-h-[610px] ").concat(Reverse ? "lg:pr-[30%] lg:pl-40" : "lg:pl-[30%] lg:pr-40"),
                    animation: Reverse ? "fade-right" : "fade-left",
                    border: !!image,
                    children: [
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-0 h-full w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                file: image.fields.asset,
                                aspectRatio: "absolute"
                            })
                        }),
                        !image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            style: title.fields.style,
                            font: title.fields.fontFamily,
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex min-h-[380px] \n          items-center lg:min-h-[610px]",
                    children: [
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-0 h-full w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                className: "lg:p-12",
                                file: image.fields.asset,
                                aspectRatio: "absolute",
                                objectFit: "contain"
                            })
                        }),
                        !image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            style: title.fields.style,
                            font: title.fields.fontFamily,
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                className: "px-10 pt-10 lg:w-1/2 lg:flex-shrink-0 lg:flex-grow-0 lg:".concat(Reverse ? "pr" : "pl", "-40 lg:").concat(Reverse ? "pl" : "pr", "-[10%]"),
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        style: title.fields.style,
                        font: title.fields.fontFamily,
                        className: "mb-9 lg:mb-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title.fields.content
                        })
                    }),
                    bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                        variant: "base",
                        className: "mb-8 text-primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: bodyCopy.fields.content
                        })
                    }),
                    listItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-unordered list-blue grid w-full list-none grid-cols-2 text-small leading-6 lg:text-2xl",
                        children: listItems.map(function(param, index) {
                            var content = param.fields.content;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: content
                                })
                            }, "listItem_".concat(index));
                        })
                    }),
                    callsToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                        callsToAction: callsToAction,
                        className: "mt-9 flex flex-wrap items-center justify-start"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Molecules/VideoThumbnail/VideoThumbnail.tsx
/* Dependencies */ 
// Components

/**
 * VideoThumbnail - Thumbnail image, translucent overlay, and play button for videos.
 * @param props - Required component props.
 * @returns
 */ var VideoThumbnail = function(param) {
    var image = param.image, cutOffMobile = param.cutOffMobile, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                file: image,
                aspectRatio: "absolute"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 top-0 h-full w-full bg-video-thumbnail-overlay",
                children: onClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "absolute left-1/2 ".concat(cutOffMobile ? "top-[calc(50%-10vh)] lg:top-1/2" : "top-1/2", " flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 rotate-90 items-center justify-center rounded-full bg-white after:pb-1.5 after:text-[51px] after:text-red after:content-['▲'] lg:right-[40%]"),
                    onClick: function() {
                        onClick();
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/XIcon.js
var esm_XIcon = __webpack_require__(8163);
;// CONCATENATED MODULE: ./src/helpers/getVideoUrl/getVideoUrl.ts
/**
 * Get video url
 * @param url - video url.
 * @returns
 */ var getVideoUrl = function(url) {
    if (!url) {
        return "";
    }
    if (url.includes("youtube")) {
        var urlString = new URL(url);
        return urlString.searchParams.get("v") || "";
    }
    if (url.includes("vimeo")) {
        var urlString1 = new URL(url);
        var urlParts = urlString1.pathname.split("/");
        if (urlParts.length > 2) {
            return "".concat(urlParts[1], "?h=").concat(urlParts[2]);
        } else {
            return "".concat(urlParts[1]);
        }
    }
    return url;
};

;// CONCATENATED MODULE: ./src/components/Atoms/VideoEmbed/VideoEmbed.model.ts
/* Dependencies */ var embedUrlFormats = Object.freeze({
    youTube: function(videoId, autoplay, controls, loop, mute) {
        return "https://www.youtube.com/embed/".concat(videoId, "?autoplay=").concat(autoplay ? 1 : 0, "&mute=").concat(mute ? 1 : 0, "&loop=").concat(loop ? 1 : 0, "&controls=").concat(controls ? 1 : 0);
    },
    vimeo: function(videoId, autoplay, controls, loop, mute) {
        return "https://player.vimeo.com/video/".concat(videoId, "&autoplay=").concat(autoplay ? 1 : 0, "&muted=").concat(mute ? 1 : 0, "&loop=").concat(loop ? 1 : 0, "&controls=").concat(controls ? 1 : 0);
    }
});

;// CONCATENATED MODULE: ./src/components/Atoms/VideoEmbed/VideoEmbed.tsx
/* Dependencies */ 



// Models

/**
 * Video Embed
 * @param props - Required component props.
 * @returns
 */ var VideoEmbed = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var video = param.video, closeButtonClick = param.closeButtonClick, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _controls = param.controls, controls = _controls === void 0 ? true : _controls, _loop = param.loop, loop = _loop === void 0 ? false : _loop, _mute = param.mute, mute = _mute === void 0 ? false : _mute;
    var type = "youTube";
    var videoId = video.fields.youtubeVideoId || "";
    if (video.fields.vimeoVideoId) {
        type = "vimeo";
        videoId = video.fields.vimeoVideoId;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute top-0 left-0 hidden h-full w-full items-center justify-center bg-black opacity-0",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                allowFullScreen: true,
                "data-src": embedUrlFormats[type](getVideoUrl(videoId), autoplay, controls, loop, mute),
                className: "aspect-[16/9] max-h-full w-full lg:h-full",
                allow: "autoplay; fullscreen; picture-in-picture"
            }),
            closeButtonClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "absolute top-2 right-2 flex h-8 w-8 items-center justify-center",
                onClick: function() {
                    return closeButtonClick();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_XIcon/* default */.Z, {
                    className: "z-20 h-6 w-6 text-white",
                    "aria-hidden": "true"
                })
            })
        ]
    });
});
// Set Display Name
VideoEmbed.displayName = "VideoEmbed";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/animejs/lib/anime.es.js
var anime_es = __webpack_require__(6030);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(2222);
;// CONCATENATED MODULE: ./src/helpers/animateVideo/animateVideo.ts



var baseAnimation = {
    easing: "easeInOutQuad",
    duration: 1000
};
function getAnimation(targets, specificAnimation, reverse) {
    if (!targets) return {};
    if (reverse) specificAnimation = reverseAnimation(specificAnimation);
    var animation = (0,_object_spread/* default */.Z)({}, baseAnimation, specificAnimation);
    animation.targets = targets;
    return animation;
}
function reverseAnimation(animation) {
    var reverseAnimation = (0,_object_spread/* default */.Z)({}, animation);
    Object.keys(animation).forEach(function(key) {
        if ((0,_type_of/* default */.Z)(animation[key]) != (typeof String === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(String))) {
            reverseAnimation[key] = (0,_to_consumable_array/* default */.Z)(animation[key]).reverse();
        }
    });
    return reverseAnimation;
}
var fadeIn = {
    opacity: [
        0,
        1
    ]
};
var fadeOut = {
    opacity: [
        1,
        0
    ]
};
var flattenLeftArrow = {
    clipPath: [
        "polygon(30% 0%, 100% 0%, 100% 100%, 30% 100%, 0% 50%)",
        "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 50%)", 
    ],
    left: [
        "18px",
        0
    ]
};
var flattenRightArrow = {
    clipPath: [
        "polygon(0% 0%, 70% 0%, 100% 50%, 70% 100%, 0% 100%)",
        "polygon(0% 0%, 100% 0%, 100% 50%, 100% 100%, 0% 100%)", 
    ],
    right: [
        "18px",
        0
    ]
};
var flattenLeftArrowBorder = {
    clipPath: [
        "polygon(calc(30% + -4px) 0%, 100% 0%, 100% 100%, calc(30% + -4px) 100%, 0% 50%)",
        "polygon(calc(0% + 0px) 0%, 100% 0%, 100% 100%, calc(0% + 0px) 100%, 0% 50%)", 
    ]
};
var flattenRightArrowBorder = {
    clipPath: [
        "polygon(0% 0%, calc(70% + 4px) 0%, 100% 50%, calc(70% + 4px) 100%, 0% 100%)",
        "polygon(0% 0%, calc(100% + 0px) 0%, 100% 50%, calc(100% + 0px) 100%, 0% 100%)", 
    ]
};
var slideVideoIntoCentre = {
    width: [
        "60%",
        "100%"
    ],
    right: [
        0,
        "50vw"
    ],
    translateX: [
        0,
        "50%"
    ],
    paddingTop: [
        0,
        "64px"
    ],
    paddingBottom: [
        0,
        "64px"
    ]
};
var slideTextArrowOut = {
    opacity: [
        1,
        0
    ],
    translateX: [
        0,
        "-100%"
    ]
};
var animations = {
    fadeIn: fadeIn,
    fadeOut: fadeOut,
    flattenLeftArrow: flattenLeftArrow,
    flattenRightArrow: flattenRightArrow,
    flattenLeftArrowBorder: flattenLeftArrowBorder,
    flattenRightArrowBorder: flattenRightArrowBorder,
    slideVideoIntoCentre: slideVideoIntoCentre,
    slideTextArrowOut: slideTextArrowOut
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con09/Con09.model.ts




function openAndPlayVideo(initialContent, videoContent, videoContainer, iframeReady) {
    var timeline = anime_es/* default.timeline */.Z.timeline();
    timeline.add(getAnimation(initialContent, animations.fadeOut));
    var video = videoContent === null || videoContent === void 0 ? void 0 : videoContent.querySelector("iframe");
    if (videoContent && video && iframeReady) {
        timeline.add(getAnimation(videoContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.fadeIn), {
            begin: function() {
                videoContent.style.display = "flex";
                video.dataset.src && (video.src = video.dataset.src);
            }
        })), "-=1000");
    }
    if (videoContainer) {
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_left"), animations.flattenLeftArrow), "-=1000");
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_right"), animations.flattenRightArrow), "-=1000");
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_left_border"), animations.flattenLeftArrowBorder), "-=1000");
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_right_border"), animations.flattenRightArrowBorder), "-=1000");
    }
    timeline.play();
}
function closeAndStopVideo(initialContent, videoContent, videoContainer) {
    var timeline = anime_es/* default.timeline */.Z.timeline();
    timeline.add(getAnimation(initialContent, animations.fadeIn));
    var video = videoContent === null || videoContent === void 0 ? void 0 : videoContent.querySelector("iframe");
    if (videoContent && video) {
        timeline.add(getAnimation(videoContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.fadeOut), {
            complete: function() {
                videoContent.style.display = "";
                video.src = "";
            }
        })), "-=1000");
    }
    if (videoContainer) {
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_left"), animations.flattenLeftArrow, true), "-=1000");
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_right"), animations.flattenRightArrow, true), "-=1000");
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_left_border"), animations.flattenLeftArrowBorder, true), "-=1000");
        timeline.add(getAnimation(videoContainer.querySelector(".clip-container_right_border"), animations.flattenRightArrowBorder, true), "-=1000");
    }
    timeline.play();
}

;// CONCATENATED MODULE: ./src/components/Organisms/Con09/Con09.tsx
/* Dependencies */ 

// Components








/**
 * CONTENT SPLIT - CON09
 * @param TypeCon09
 * @returns
 */ var Con09 = function(param) {
    var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy, image = _fields.image, video = _fields.video, callsToAction = _fields.callsToAction, reverse = _fields.reverse, theme = _fields.theme;
    var ref, ref1, ref2, ref3, ref4;
    var initialContentRef = (0,react.useRef)(null);
    var videoContentRef = (0,react.useRef)(null);
    var videoContainerRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), mountIframe = ref5[0], setMountIframe = ref5[1];
    (0,react.useEffect)(function() {
        video && mountIframe && openAndPlayVideo(initialContentRef.current, videoContentRef.current, videoContainerRef.current, mountIframe);
    }, [
        mountIframe
    ]);
    // Set the background color of the component
    var bgColor = "transparent";
    if (theme) {
        bgColor = theme.fields.colourScheme.toLowerCase();
    }
    var ref6;
    var titleId = (ref6 = (ref3 = (ref2 = title === null || title === void 0 ? void 0 : (ref = title.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.content[0]) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) !== null && ref6 !== void 0 ? ref6 : "";
    if (titleId.includes(" ")) titleId = titleId.replace(/\s+/g, "-");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden py-11 lg:flex lg:justify-between",
        id: titleId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(reverse ? "mr-5" : "order-last ml-5", " lg:mx-0 lg:w-1/2 lg:flex-shrink-0 lg:flex-grow-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerArrow/* ContainerArrow */.r, {
                    arrowsSide: reverse ? "Right" : "Left",
                    bgColour: bgColor,
                    className: "flex min-h-[380px] items-center pl-10 lg:min-h-[610px] ".concat(reverse ? "lg:pr-[30%] lg:pl-40" : "lg:pl-[30%] lg:pr-40"),
                    animation: reverse ? "fade-right" : "fade-left",
                    border: true,
                    ref: videoContainerRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: initialContentRef,
                            children: image && video && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnail, {
                                image: image.fields.asset,
                                onClick: function() {
                                    return setMountIframe(true);
                                }
                            })
                        }),
                        video && mountIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoEmbed, {
                            video: video,
                            autoplay: true,
                            controls: true,
                            loop: false,
                            mute: false,
                            closeButtonClick: function() {
                                closeAndStopVideo(initialContentRef.current, videoContentRef.current, videoContainerRef.current);
                                setMountIframe(false);
                            },
                            ref: videoContentRef
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                className: "px-10 pt-10 lg:w-1/2 lg:flex-shrink-0 lg:flex-grow-0 lg:".concat(reverse ? "pr" : "pl", "-40 lg:").concat(reverse ? "pl" : "pr", "-[10%]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        style: title.fields.style,
                        font: title.fields.fontFamily,
                        className: "mb-9 lg:mb-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title.fields.content
                        })
                    }),
                    bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                        className: "mb-8 text-primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: bodyCopy.fields.content
                        })
                    }),
                    callsToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                        callsToAction: callsToAction,
                        className: "mt-9 flex flex-wrap items-center justify-start"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Atoms/Logo/Logo.tsx
var Logo = __webpack_require__(3424);
;// CONCATENATED MODULE: ./src/components/Organisms/Con10/Con10.tsx
/* Dependencies */ 
// Components






/**
 * CONTENT SPLIT - CON10
 * @param TypeCon10
 * @returns
 */ var Con10 = function(param) {
    var _fields = param.fields, title = _fields.title, subheading = _fields.subheading, bodyCopy = _fields.bodyCopy, image = _fields.image, callsToAction = _fields.callsToAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        className: "mx-auto max-w-1130 items-stretch justify-between space-y-24 py-10 text-plum lg:flex lg:space-y-0 lg:space-x-16 lg:space-x-reverse lg:py-16 odd:lg:pr-28",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto w-full max-w-400 lg:flex lg:items-end",
                "data-aos": "fade-up",
                "data-aos-delay": "300",
                children: (image === null || image === void 0 ? void 0 : image.fields.asset) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                    file: image.fields.asset,
                    className: "h-full max-h-[500px] w-full object-contain object-center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "justify-between lg:order-first lg:flex lg:min-w-[270px] lg:basis-5/12 lg:flex-col",
                "data-aos": "fade-up",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                style: "Heading 6",
                                className: "mb-2.5 uppercase text-primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: subheading
                                })
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h3",
                                font: title.fields.fontFamily,
                                style: title.fields.style,
                                className: "mb-9 lg:mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: title.fields.content
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: bodyCopy.fields.content
                                })
                            }),
                            callsToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                                callsToAction: callsToAction,
                                className: "mt-6"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(8494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(8770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(3971);
// EXTERNAL MODULE: ./src/helpers/getLinkUrl/getLinkUrl.ts
var getLinkUrl = __webpack_require__(1180);
;// CONCATENATED MODULE: ./src/components/Organisms/Con11/Con11.tsx
/* Dependencies */ 

// Import Swiper styles



// Import Swiper Modules

// Helpers

// Components






/**
 * CONTENT LOGO GRID - CON11 and CON12
 * CMS toggle for carousel or static
 * @param TypeCon11
 * @returns
 */ var Con11 = function(param) {
    var _fields = param.fields, title = _fields.title, logos = _fields.logos, isCarousel = _fields.isCarousel, numPerSlide = _fields.numPerSlide;
    if (!logos) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        className: "my-[70px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        style: "".concat(title.fields.style),
                        className: "mb-6 text-center lg:mb-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title.fields.content
                        })
                    }),
                    isCarousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            className: "swiper-con11",
                            navigation: true,
                            slidesPerView: "auto",
                            centeredSlides: true,
                            spaceBetween: 0,
                            loop: true,
                            modules: [
                                swiper_esm/* Navigation */.W_,
                                swiper_esm/* A11y */.s5
                            ],
                            breakpoints: {
                                768: {
                                    slidesPerView: 4,
                                    centeredSlides: false,
                                    spaceBetween: 8
                                },
                                1024: {
                                    slidesPerView: numPerSlide,
                                    spaceBetween: 16,
                                    centeredSlides: false
                                }
                            },
                            children: logos.map(function(param, index) {
                                var _fields = param.fields, link = _fields.link, image = _fields.image;
                                // Handle missing image
                                if (!image) {
                                    return null;
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                    className: "relative mx-auto max-w-[50%] px-4",
                                    children: [
                                        link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            variant: "none",
                                            to: (0,getLinkUrl/* getLinkUrl */.U)(link),
                                            openInNewTab: link === null || link === void 0 ? void 0 : link.fields.openInNewTab,
                                            className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full min-w-[100px] overflow-hidden rounded-md lg:mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "view company"
                                            })
                                        }),
                                        image.fields.asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                                            file: image === null || image === void 0 ? void 0 : image.fields.asset,
                                            className: "mx-auto object-contain object-center"
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-wrap justify-center gap-12 px-8 md:gap-20 lg:gap-24 lg:px-10",
                            children: logos.map(function(param, index) {
                                var _fields = param.fields, link = _fields.link, image = _fields.image;
                                // Handle missing image
                                if (!image) {
                                    return null;
                                }
                                return(// link
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "basis-[43%] md:basis-[24.6%] xl:basis-[18.4%]",
                                    children: [
                                        link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            variant: "none",
                                            to: (0,getLinkUrl/* getLinkUrl */.U)(link),
                                            className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full overflow-hidden rounded-md lg:mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "view company"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "min-w-80",
                                            children: image.fields.asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                                                file: image === null || image === void 0 ? void 0 : image.fields.asset,
                                                className: "mx-auto object-contain object-center"
                                            })
                                        })
                                    ]
                                }, index));
                            })
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con13/Con13.tsx
/* Dependencies */ 
// Components





/**
 * CONTENT CONTACT CTA - CON13
 * @param TypeCon13
 * @returns
 */ var Con13 = function(param) {
    var _fields = param.fields, title = _fields.title, theme = _fields.theme, callsToAction = _fields.callsToAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        className: "flex min-h-290 items-center py-16 lg:min-h-550",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "sm:max-w-800",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                        style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                        className: "mb-6 text-center text-primary lg:mb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title === null || title === void 0 ? void 0 : title.fields.content
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                    callsToAction: callsToAction
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con14/Con14.tsx
/* Dependencies */ 
// Components







/**
 * CONTENT GENERAL CTA - CON14
 * @param TypeCon14
 * @returns
 */ var Con14 = function(param) {
    var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy, callToAction = _fields.callToAction, theme = _fields.theme, image = _fields.image;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                classNameWrapper: "w-11/12 md:w-8/12 min-h-375 lg:min-h-550 xl:min-h-650 z-10",
                className: "flex flex-col justify-center py-8 pr-[22.5%] pl-10 lg:pb-20 lg:pt-24 xl:pb-32 xl:pt-36",
                arrowsSide: "Right",
                arrowsSize: "Small",
                overlap: false,
                bgColour: theme.fields.colourScheme.toLowerCase(),
                animation: "fade-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-aos": "fade-up",
                    "data-aos-delay": "350",
                    className: "ml-auto max-w-550",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            font: title.fields.fontFamily,
                            style: title.fields.style,
                            className: "mb-6 text-primary lg:mb-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        }),
                        bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            variant: "base",
                            className: "mb-6 text-primary lg:mb-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                            })
                        }),
                        callToAction && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkButton/* LinkButton */.Q, {
                            variant: (ref = callToAction.fields.theme) === null || ref === void 0 ? void 0 : ref.fields.colourScheme,
                            openInNewTab: callToAction.fields.openInNewTab,
                            to: (0,getLinkUrl/* getLinkUrl */.U)(callToAction),
                            hasIcon: callToAction.fields.assetLink && callToAction.fields.assetLink.fields ? true : false,
                            arrowDirection: callToAction.fields.arrowDirection,
                            children: [
                                callToAction.fields.title,
                                callToAction.fields.assetLink && callToAction.fields.assetLink.fields && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: 1.5,
                                    stroke: "currentColor",
                                    className: "ml-1 h-3 w-3 lg:h-4 lg:w-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-y-0 right-0 z-0 h-full w-6/12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                    file: image.fields.asset,
                    aspectRatio: "absolute"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Molecules/Image/Image.model.ts
var Image_model = __webpack_require__(1439);
;// CONCATENATED MODULE: ./src/components/Organisms/Con15/Con15.tsx
/* Dependencies */ 
// Components






/**
 * CONTENT TEAM GRID - CON15
 * @param TypeCon15
 * @returns
 */ var Con15 = function(param) {
    var _fields = param.fields, title = _fields.title, subheading = _fields.subheading, bodyCopy = _fields.bodyCopy, teamMembers = _fields.teamMembers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "bg-team-pattern bg-[length:65%] bg-[right_-65px_top] bg-no-repeat text-plum sm:bg-auto lg:mb-44 lg:bg-right-top",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-1130 pt-12 pb-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h2",
                    font: title.fields.fontFamily,
                    style: title.fields.style,
                    className: "mb-6 max-w-290 lg:mb-8 lg:max-w-500",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: title.fields.content
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                    className: "mb-4 max-w-290 pr-16 text-sm lg:max-w-500 lg:text-base",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: subheading
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                    className: "mb-4 max-w-[70%] text-sm lg:text-base",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-[-16px] mt-12 grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:mt-16 lg:gap-4",
                    children: teamMembers === null || teamMembers === void 0 ? void 0 : teamMembers.map(function(param, index) {
                        var fields = param.fields;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "overflow-hidden rounded-md shadow-extra-light",
                            "data-aos": "fade-up",
                            children: [
                                fields.photo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                    file: fields.photo.fields.asset,
                                    aspectRatio: "12x16"
                                }),
                                !fields.photo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full ".concat(Image_model/* imageAspectRatioClasses.12x16 */.c["12x16"], " bg-white")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bg-white p-3 lg:p-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-1 font-display-a text-sm font-extrabold lg:text-base",
                                            children: fields.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-1 font-display-s text-xs lg:mb-3 lg:text-15px",
                                            children: fields.role
                                        })
                                    ]
                                })
                            ]
                        }, "teamMember_".concat(index));
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con16/Con16.model.ts
var sectionBgColours = Object.freeze([
    "red",
    "blue",
    "plum"
]);

;// CONCATENATED MODULE: ./src/components/Organisms/Con16/Con16.tsx
/* Dependencies */ 
// Components






/**
 * CONTENT STRATEGY HORIZONTAL SCROLL - CON16
 * @param TypeCon16
 * @returns
 */ var Con16 = function(param) {
    var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy, sections = _fields.sections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": "fade-up",
        className: "overflow-hidden pb-5 lg:pb-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-[#ff0044] relative w-screen overflow-x-scroll pt-24 pl-10 lg:pt-20 lg:pb-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative z-10 mb-80 max-w-290 pr-11 text-plum lg:mb-96 lg:max-w-400 lg:pr-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            font: title.fields.fontFamily,
                            style: title.fields.style,
                            className: "mb-6 lg:mb-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            className: "text-small lg:text-base",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 left-0 flex h-full flex-nowrap px-10 pb-24 lg:pb-20",
                    children: sections === null || sections === void 0 ? void 0 : sections.map(function(param, index) {
                        var fields = param.fields;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "group flex flex-nowrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                                    className: "flex flex-col justify-center pl-4 pr-12 lg:pl-7 lg:pr-24",
                                    classNameWrapper: "h-48 w-56 lg:h-64 lg:w-80 self-end mr-4 group-last-of-type:mr-0 ".concat(index % 2 === 1 && "mb-52 lg:mb-80", " text-xs lg:text-2xl lg:leading-5"),
                                    arrowsSide: "Right",
                                    overlap: false,
                                    bgColour: sectionBgColours[index % sectionBgColours.length],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-aos": "fade-up",
                                        children: fields.label
                                    })
                                }),
                                index < sections.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    className: "relative -mr-20 mb-24 h-24 w-36 self-end lg:-mr-28 lg:mb-32 lg:h-44 lg:w-60 ".concat(index % 2 === 0 ? "border-b-2 after:top-0 after:-translate-y-1/2 after:content-['▲']" : "bottom-28 border-t-2 after:bottom-0 after:translate-y-1/2 after:content-['▼'] lg:bottom-36", " border-r-2 border-dotted border-plum after:absolute after:left-full after:-translate-x-1/2 after:pl-0.5 after:text-small after:text-plum")
                                })
                            ]
                        }, "section_".concat(index));
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con17/Con17.model.ts
var Con17_model_illustrationTypes = Object.freeze({
    Sustainability: {
        url: "/assets/svg/CON17-sustainability.svg",
        width: "292",
        height: "772"
    },
    EmployeePerks: {
        url: "/assets/svg/CON17-employeeperks.svg",
        width: "490",
        height: "685"
    }
});
var Con17_model_positions = Object.freeze({
    Sustainability: [
        "top-[5%] left-[calc(50%-5px)] md:top-[10%] md:left-[calc(50%+10px)] lg:top-[3%] max-w-500",
        "top-[25%] left-[calc(50%+10px)] md:top-[30%] lg:top-[25%] lg:left-[calc(50%+25px)] max-w-500",
        "top-[60%] right-[calc(50%+30px)] md:top-[62.5%] lg:top-[57%] max-w-500",
        "top-[75%] left-[calc(50%+35px)] md:top-[75%] lg:top-[70%] lg:left-[calc(50%+60px)] max-w-500",
        "top-[92.5%] right-[calc(50%+60px)] md:top-[92.5%] lg:top-[87.5%] max-w-500", 
    ],
    EmployeePerks: [
        "top-[20%] left-[calc(50%-60px)] md:left-[calc(50%-65px)] lg:top-[10%] max-w-500",
        "top-[32%] left-[calc(50%+50px)] md:left-[calc(50%+110px)] lg:top-[25%] lg:left-[calc(50%+60px)] xl:left-[calc(50%+80px)] max-w-450 xl:max-w-500",
        "top-[47%] left-[calc(50%+125px)] md:left-[calc(50%+160px)] lg:top-[42%] lg:left-[calc(50%+110px)] xl:left-[calc(50%+150px)] 2xl:left-[calc(50%+200px)] max-w-400 xl:max-w-500",
        "top-[55%] right-[calc(50%+60px)] md:right-[calc(50%+100px)] lg:top-[55%] lg:right-[calc(50%+50px)] xl:right-[calc(50%+65px)] max-w-450 xl:max-w-500",
        "top-[65%] left-[calc(50%+60px)] md:left-[calc(50%+130px)] lg:left-[calc(50%+90px)] xl:left-[calc(50%+130px)] 2xl:left-[calc(50%+175px)] max-w-400 xl:max-w-500",
        "top-[85%] right-[calc(50%-5px)] md:right-[calc(50%-30px)] lg:top-[82%] max-w-500",
        "top-[90%] left-[calc(50%+50px)] md:left-[calc(50%+100px)] lg:top-[85%] lg:left-[calc(50%+60px)] xl:left-[calc(50%+110px)] max-w-450 xl:max-w-500", 
    ]
});
var Con17_model_sides = Object.freeze({
    Sustainability: [
        "Right",
        "Right",
        "Left",
        "Right",
        "Left"
    ],
    EmployeePerks: [
        "Right",
        "Right",
        "Right",
        "Left",
        "Right",
        "Left",
        "Right"
    ]
});

;// CONCATENATED MODULE: ./src/components/Organisms/Con17/Con17.tsx
/* Dependencies */ 
// Components







/**
 * CONTENT GROWTH HOTSPOTS - CON17
 * @param TypeCon17
 * @returns
 */ var Con17 = function(param) {
    var _fields = param.fields, subheading = _fields.subheading, title = _fields.title, bodyCopy = _fields.bodyCopy, theme = _fields.theme, hotspots = _fields.hotspots, illustrationType = _fields.illustrationType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        className: "flex items-center overflow-hidden py-16 lg:py-28",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "relative w-full sm:max-w-1270",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-aos": "fade-up",
                    className: "z-10 w-full max-w-400 md:absolute md:w-2/5",
                    children: [
                        subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            style: "Heading 6",
                            className: "mb-2.5 uppercase text-primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: subheading
                            })
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h3",
                            font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                            style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                            className: "mb-6 text-primary lg:mb-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title === null || title === void 0 ? void 0 : title.fields.content
                            })
                        }),
                        bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            className: "text-small text-primary lg:max-w-335 lg:text-base",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-full pt-8 md:pt-20 md:pl-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-aos": "fade-up",
                            className: "mx-auto flex h-full max-h-[400px] w-full md:max-h-775 md:max-w-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: Con17_model_illustrationTypes[illustrationType]["url"],
                                alt: "Central Main",
                                width: Con17_model_illustrationTypes[illustrationType]["width"],
                                height: Con17_model_illustrationTypes[illustrationType]["height"],
                                className: "mx-auto"
                            })
                        }),
                        hotspots === null || hotspots === void 0 ? void 0 : hotspots.map(function(param, index) {
                            var fields = param.fields;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Hotspot, {
                                title: "".concat(fields.title),
                                subheading: "".concat(fields.subheading),
                                className: "absolute ".concat(Con17_model_positions[illustrationType][index]),
                                side: "".concat(Con17_model_sides[illustrationType][index]),
                                index: index,
                                theme: (theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme) === "Blue" ? "Tertiary" : "Primary"
                            }, "hotspot_".concat(index));
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Atoms/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(8923);
;// CONCATENATED MODULE: ./src/components/Organisms/Con18/Con18.model.ts

var textTheme = Object.freeze({
    Transparent: "text-primary",
    Red: "theme-red text-primary",
    Blue: "theme-blue text-primary",
    Plum: "theme-plum text-primary"
});
function playVideo(initialContent, videoContent, iframeReady) {
    var video = videoContent === null || videoContent === void 0 ? void 0 : videoContent.querySelector("iframe");
    if (iframeReady) {
        anime_es/* default.timeline */.Z.timeline({
            autoplay: true
        }).add({
            targets: initialContent,
            opacity: 0,
            easing: "easeInOutQuad",
            duration: 1000,
            complete: function() {
                initialContent && (initialContent.style.zIndex = "-1");
            }
        }).add({
            targets: videoContent,
            opacity: 1,
            easing: "easeInOutQuad",
            duration: 1000,
            begin: function() {
                videoContent && (videoContent.style.display = "flex");
                (video === null || video === void 0 ? void 0 : video.dataset.src) && (video.src = video.dataset.src);
            }
        }, "-=1000");
    }
}

;// CONCATENATED MODULE: ./src/components/Organisms/Con18/Con18.tsx
/* Dependencies */ 

// Components






// Models

/**
 * CONTENT VIDEO LINK - CON18
 * @param TypeCon18
 * @returns
 */ var Con18 = function(param) {
    var _fields = param.fields, title = _fields.title, subheading = _fields.subheading, bodyCopy = _fields.bodyCopy, image = _fields.image, video = _fields.video, theme = _fields.theme;
    var videoContentRef = (0,react.useRef)(null);
    var initialContentRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), mountIframe = ref[0], setMountIframe = ref[1];
    var buttonVariant = theme.fields.colourScheme;
    (0,react.useEffect)(function() {
        playVideo(initialContentRef.current, videoContentRef.current, mountIframe);
    }, [
        mountIframe
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "my-24 rich-text:px-0 md:max-w-1130 lg:my-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-aos": "fade-up",
            className: "relative ".concat(textTheme[theme.fields.colourScheme], " pl-7 pt-64 pb-8 pr-14 lg:min-h-550 lg:px-14 lg:pb-14 lg:pt-16"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: initialContentRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnail, {
                            image: image === null || image === void 0 ? void 0 : image.fields.asset
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative max-w-400",
                            children: [
                                subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                    level: "h2",
                                    style: "Heading 6",
                                    className: "mb-2.5 uppercase",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                        content: subheading
                                    })
                                }),
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                    level: "h3",
                                    font: title.fields.fontFamily,
                                    style: title.fields.style,
                                    className: "mb-10 lg:mb-14",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                        content: title.fields.content
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-10 text-small lg:mb-16 lg:text-base",
                                    children: bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                        content: bodyCopy.fields.content
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* ActionButton */.K, {
                                    onClick: function() {
                                        setMountIframe(true);
                                    },
                                    variant: buttonVariant,
                                    children: "Play video"
                                })
                            ]
                        })
                    ]
                }),
                video && mountIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoEmbed, {
                    video: video,
                    ref: videoContentRef
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con19/Con19.tsx
/* Dependencies */ 

// Components



/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon19
 * @returns
 */ var Con19 = function(param) {
    var fields = param.fields;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        className: "mb-32 overflow-hidden py-4 lg:mb-40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            className: "relative w-full sm:max-w-1130",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                "data-aos": "fade-up",
                className: "min-w-full divide-y divide-plum border-b border-plum",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: "text-left font-display-a text-xs font-black text-primary lg:text-base",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "py-4",
                                    children: "Job Role"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "hidden py-4 md:table-cell",
                                    children: "Location"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "hidden py-4 md:table-cell",
                                    children: "Duration"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "py-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Sign up"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        className: "divide-y divide-plum",
                        children: (ref = fields.jobs) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                            var _fields = param.fields, jobRole = _fields.jobRole, location = _fields.location, duration = _fields.duration, callToAction = _fields.callToAction;
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: "text-sm leading-normal text-primary lg:text-[18px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-5",
                                        children: jobRole
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "hidden py-5 md:table-cell",
                                        children: location
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "hidden py-5 md:table-cell",
                                        children: duration
                                    }),
                                    callToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-5 text-right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                                            variant: (ref = callToAction.fields.theme) === null || ref === void 0 ? void 0 : ref.fields.colourScheme,
                                            openInNewTab: callToAction.fields.openInNewTab,
                                            to: (0,getLinkUrl/* getLinkUrl */.U)(callToAction),
                                            children: callToAction.fields.title
                                        })
                                    })
                                ]
                            }, "statistic_".concat(index));
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
;// CONCATENATED MODULE: ./src/components/Molecules/AccordionList/AccordionList.tsx
/* Dependencies */ 

// Components



// Helpers

/**
 * Accordion List
 * @param props - Component props
 */ var AccordionList = function(param) {
    var entries = param.entries;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
        className: "accordion",
        children: entries.map(function(param, index) {
            var _fields = param.fields, locationName = _fields.locationName, addressTitle = _fields.addressTitle, addressLine1 = _fields.addressLine1, addressLine2 = _fields.addressLine2, addressLine3 = _fields.addressLine3, city = _fields.city, postCode = _fields.postCode, emailTitle = _fields.emailTitle, email = _fields.email, phoneTitle = _fields.phoneTitle, phone = _fields.phone, officeHoursTitle = _fields.officeHoursTitle, officeHours = _fields.officeHours, viewMapCallToAction = _fields.viewMapCallToAction;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                as: "div",
                defaultOpen: index === 0 ? true : false,
                className: "group border-t border-black/50 first:border-none",
                children: function(param) {
                    var open = param.open;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                className: "py-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                    className: "flex w-full items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                            level: "h2",
                                            style: "Heading 5",
                                            children: locationName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2 mr-3 flex h-9 w-9 items-center justify-center rounded-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                className: "transition-transform ".concat(open ? "rotate-90" : "rotate-0", " text-midnight-black h-3 w-3 transform"),
                                                "aria-hidden": "true",
                                                width: "12",
                                                height: "12",
                                                viewBox: "0 0 12 12",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "6",
                                                        cy: "6",
                                                        r: "6",
                                                        transform: "rotate(-90 6 6)",
                                                        fill: "#330523"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                        x1: "4.64645",
                                                        y1: "9.64645",
                                                        x2: "8.64645",
                                                        y2: "5.64645",
                                                        stroke: "white"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                        x1: "8.64645",
                                                        y1: "6.35355",
                                                        x2: "4.64645",
                                                        y2: "2.35355",
                                                        stroke: "white"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                as: "dd",
                                className: "pb-4 pr-4 lg:py-7 lg:pr-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid gap-7 lg:grid-cols-2 lg:gap-x-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid max-w-800 gap-y-7",
                                            children: [
                                                addressLine1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                                            level: "h3",
                                                            style: "Heading 6",
                                                            children: addressTitle
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                                            className: "flex flex-col not-italic leading-6 lg:leading-7",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: addressLine1
                                                                }),
                                                                addressLine2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: addressLine2
                                                                }),
                                                                addressLine3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: addressLine3
                                                                }),
                                                                city && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: city
                                                                }),
                                                                postCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: postCode
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                email && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                                            level: "h3",
                                                            style: "Heading 6",
                                                            children: emailTitle
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                            className: "font-display-s",
                                                            variant: "none",
                                                            to: "mailTo:".concat(email),
                                                            openInNewTab: false,
                                                            children: email
                                                        })
                                                    ]
                                                }),
                                                phone && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                                            level: "h3",
                                                            style: "Heading 6",
                                                            children: phoneTitle
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                            className: "font-display-s",
                                                            variant: "none",
                                                            to: "tel:".concat(phone),
                                                            openInNewTab: false,
                                                            children: phone
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid gap-y-7",
                                            children: [
                                                officeHours && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                                            level: "h3",
                                                            style: "Heading 6",
                                                            children: officeHoursTitle
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                            content: officeHours
                                                        })
                                                    ]
                                                }),
                                                viewMapCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: ((viewMapCallToAction === null || viewMapCallToAction === void 0 ? void 0 : viewMapCallToAction.fields.internalLink) || (viewMapCallToAction === null || viewMapCallToAction === void 0 ? void 0 : viewMapCallToAction.fields.externalLink)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                                        openInNewTab: viewMapCallToAction.fields.openInNewTab,
                                                        to: (0,getLinkUrl/* getLinkUrl */.U)(viewMapCallToAction),
                                                        variant: "none",
                                                        className: "flex items-center font-display-a text-xs font-extrabold leading-snug lg:text-2xl lg:leading-tight",
                                                        children: [
                                                            viewMapCallToAction.fields.title,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "flex h-9 w-9 items-center justify-center rounded-full",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    className: "text-midnight-black h-3 w-3 transform transition-transform",
                                                                    "aria-hidden": "true",
                                                                    width: "12",
                                                                    height: "12",
                                                                    viewBox: "0 0 12 12",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                                            cx: "6",
                                                                            cy: "6",
                                                                            r: "6",
                                                                            transform: "rotate(-90 6 6)",
                                                                            fill: "#330523"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                                            x1: "4.64645",
                                                                            y1: "9.64645",
                                                                            x2: "8.64645",
                                                                            y2: "5.64645",
                                                                            stroke: "white"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                                            x1: "8.64645",
                                                                            y1: "6.35355",
                                                                            x2: "4.64645",
                                                                            y2: "2.35355",
                                                                            stroke: "white"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, "".concat(index))
                            })
                        ]
                    });
                }
            }, index);
        })
    });
};

// EXTERNAL MODULE: ./src/components/Organisms/Forms/RenderForm/RenderForm.tsx + 17 modules
var RenderForm = __webpack_require__(6336);
;// CONCATENATED MODULE: ./src/components/Organisms/Con20/Con20.tsx
/* Dependencies */ 
// Components






/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon20
 * @returns
 */ var Con20 = function(param) {
    var _fields = param.fields, form = _fields.form, title = _fields.title, locations = _fields.locations, formTitle = _fields.formTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        className: "my-16 text-primary lg:mb-24 lg:mt-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            className: "max-w-1130",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid lg:grid-cols-2 lg:gap-x-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                style: "Heading 3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: title.fields.content
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionList, {
                                entries: locations
                            })
                        ]
                    }),
                    form && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-1/2 w-full",
                        children: [
                            formTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                style: "Heading 3",
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: formTitle.fields.content
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderForm/* RenderForm */.X, {
                                form: form
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con22/Con22.tsx
/* Dependencies */ 
// Components




/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon22
 * @returns
 */ var Con22 = function(param) {
    var _fields = param.fields, title = _fields.title, people = _fields.people;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "my-24 max-w-1130 text-plum",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-aos": "fade-up",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h2",
                    style: title.fields.style,
                    font: title.fields.fontFamily,
                    className: "mb-6 lg:mb-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: title.fields.content
                    })
                }),
                people && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "-m-2 flex flex-wrap justify-center font-display-a",
                    children: people.map(function(param, index) {
                        var _fields = param.fields, photo = _fields.photo, name = _fields.name, role = _fields.role, emailAddress = _fields.emailAddress;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "m-0 w-full p-2 lg:w-1/3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "h-full w-full rounded-md border border-red bg-fill py-8 px-12 text-center",
                                children: [
                                    photo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative mx-auto h-32 w-32 overflow-hidden rounded-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                            file: photo.fields.asset,
                                            aspectRatio: "absolute"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "mt-4 mb-2 text-base",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 text-15px",
                                        children: role
                                    }),
                                    emailAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 text-15px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:".concat(emailAddress),
                                            children: emailAddress
                                        })
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con23/Con23.tsx
/* Dependencies */ 


// Import Swiper styles

// Components







/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon23
 * @returns
 */ var Con23 = function(param) {
    var _fields = param.fields, title = _fields.title, testimonials = _fields.testimonials, image = _fields.image, theme = _fields.theme;
    var swiperRef = (0,react.useRef)();
    var ref = (0,react.useState)(testimonials[0].fields.logo ? false : true), isLogo = ref[0], setIsLogo = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.on("slideChange", function() {
            var ref;
            var index = (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.realIndex;
            if (testimonials[index].fields.logo) setIsLogo(false);
            else setIsLogo(true);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                classNameWrapper: "w-11/12 md:w-8/12 min-h-375 lg:min-h-550 xl:min-h-650 z-10",
                className: "flex flex-col justify-center py-10 pr-[22.5%] pl-10 lg:pb-20 lg:pt-24",
                arrowsSide: "Right",
                arrowsSize: "Small",
                overlap: false,
                bgColour: theme.fields.colourScheme.toLowerCase(),
                animation: "fade-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-aos": "fade-up",
                    "data-aos-delay": "350",
                    className: "relative ml-auto w-full max-w-550",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            font: title.fields.fontFamily,
                            style: "Heading 6",
                            className: "mb-7 tracking-widest text-primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        }),
                        testimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                className: "swiper-con23",
                                slidesPerView: "auto",
                                onBeforeInit: function(swiper) {
                                    swiperRef.current = swiper;
                                },
                                spaceBetween: 8,
                                loop: true,
                                breakpoints: {
                                    1024: {
                                        slidesPerView: 1,
                                        spaceBetween: 16
                                    }
                                },
                                children: [
                                    testimonials.map(function(param, index) {
                                        var _fields = param.fields, quote = _fields.quote, logo = _fields.logo, companyName = _fields.companyName, personName = _fields.personName;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                            className: "flex flex-col justify-between",
                                            children: [
                                                quote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                                    variant: "base",
                                                    className: "mb-24 text-primary lg:mb-32",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                        content: quote
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mb-6 h-12 max-w-80",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                                                                file: logo,
                                                                className: "h-full w-full object-contain object-left"
                                                            })
                                                        }),
                                                        personName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                                            variant: "base",
                                                            className: "text-primary",
                                                            font: "font-display-a",
                                                            children: personName
                                                        }),
                                                        companyName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                                            variant: "small",
                                                            className: "text-primary",
                                                            children: companyName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "slider_".concat(index));
                                    }),
                                    testimonials.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute z-10 space-x-2.5 lg:space-x-6 ".concat(isLogo ? "bottom-16 lg:bottom-24" : "bottom-32 lg:bottom-36"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* ActionButton */.K, {
                                                onClick: function() {
                                                    var ref;
                                                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                                                },
                                                variant: "".concat(theme.fields.colourScheme === "Red" ? "secondary" : "primary"),
                                                hasIcon: true,
                                                arrowDirection: "Left",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 12 12",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    className: "h-2.5 w-2.5 lg:m-0.5 lg:h-3 lg:w-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "".concat(theme.fields.colourScheme === "Red" ? "fill-button-secondary hover-hover:group-hover:fill-button-secondary-hover" : "fill-button-primary hover-hover:group-hover:fill-button-primary-hover"),
                                                        d: "M6.58 11.06C6.47333 10.0467 6.12 9.13333 5.52 8.32C4.90667 7.50667 4.2 6.98 3.4 6.74H11.6V5.18H3.4C4.2 4.94 4.90667 4.41333 5.52 3.6C6.12 2.78667 6.47333 1.88 6.58 0.879999L4.72 0.46C4.65333 1.87333 4.23333 2.98667 3.46 3.8C2.67333 4.61333 1.65333 5.07333 0.399999 5.18V6.74C1.65333 6.84667 2.67333 7.30667 3.46 8.12C4.23333 8.93333 4.65333 10.0467 4.72 11.46L6.58 11.06Z"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* ActionButton */.K, {
                                                onClick: function() {
                                                    var ref;
                                                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                                                },
                                                variant: "".concat(theme.fields.colourScheme === "Red" ? "secondary" : "primary"),
                                                hasIcon: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 12 12",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    className: "h-2.5 w-2.5 lg:m-0.5 lg:h-3 lg:w-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M5.42 11.06C5.52667 10.0467 5.88 9.13333 6.48 8.32C7.09333 7.50667 7.8 6.98 8.6 6.74H0.4V5.18H8.6C7.8 4.94 7.09333 4.41333 6.48 3.6C5.88 2.78667 5.52667 1.88 5.42 0.879999L7.28 0.46C7.34667 1.87333 7.76667 2.98667 8.54 3.8C9.32667 4.61333 10.3467 5.07333 11.6 5.18V6.74C10.3467 6.84667 9.32667 7.30667 8.54 8.12C7.76667 8.93333 7.34667 10.0467 7.28 11.46L5.42 11.06Z",
                                                        className: "".concat(theme.fields.colourScheme === "Red" ? "fill-button-secondary hover-hover:group-hover:fill-button-secondary-hover" : "fill-button-primary hover-hover:group-hover:fill-button-primary-hover")
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-y-0 right-0 z-0 h-full w-6/12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                    file: image.fields.asset,
                    aspectRatio: "absolute"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con25/Con25.tsx
/* Dependencies */ 
// Components





/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon25
 * @returns
 */ var Con25 = function(param) {
    var _fields = param.fields, title = _fields.title, statistics = _fields.statistics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        className: "mt-28 mb-14 lg:my-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "sm:max-w-1130",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                        style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                        className: "mb-8 text-center text-primary lg:mb-14",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title === null || title === void 0 ? void 0 : title.fields.content
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Statistics, {
                    statistics: statistics
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(4394);
;// CONCATENATED MODULE: ./src/components/Molecules/Services/ServiceListItem/ServiceListItem.tsx






var ServiceListItem = function(param) {
    var link = param.link, title = param.title, body = param.body, image = param.image, _imageRollover = param.imageRollover, imageRollover = _imageRollover === void 0 ? image : _imageRollover, animated = param.animated, serviceItemBoxDefaultColourWhite = param.serviceItemBoxDefaultColourWhite;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isHovered = ref2[0], setIsHovered = ref2[1];
    // Preload rollover image silently
    (0,react.useEffect)(function() {
        if (imageRollover) {
            var img = new Image();
            img.src = imageRollover.fields.file.url;
            img.onload = function() {}; // Image preloaded silently
            img.onerror = function() {}; // Failed to preload image silently
        }
    }, [
        imageRollover
    ]);
    var getBackgroundClass = function() {
        if (serviceItemBoxDefaultColourWhite) {
            return isHovered ? "bg-red text-white" : "bg-white text-primary";
        }
        return isHovered ? "bg-fill text-primary" : "bg-red text-white";
    };
    var getImage = function() {
        if (serviceItemBoxDefaultColourWhite) {
            return isHovered ? imageRollover : image;
        }
        return isHovered ? image : imageRollover;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
        condition: animated,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "relative m-0 w-full transform rounded-xl border-3 border-red px-12 pt-6 pb-9 text-center transition md:flex-[0_0_46%] md:px-11 md:pt-[60px] md:pb-[90px] lg:flex-[0_0_30%] ".concat(getBackgroundClass()),
                    onMouseEnter: function() {
                        return setIsHovered(true);
                    },
                    onMouseLeave: function() {
                        return setIsHovered(false);
                    },
                    children: [
                        link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            className: "absolute top-0 left-0 z-10 h-full w-full",
                            variant: "none",
                            to: (0,getLinkUrl/* getLinkUrl */.U)(link),
                            openInNewTab: link === null || link === void 0 ? void 0 : (ref = link.fields) === null || ref === void 0 ? void 0 : ref.openInNewTab,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "sr-only",
                                children: [
                                    "view service: ",
                                    title
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-aos": "fade-up",
                            "data-aos-duration": "800",
                            "data-aos-delay": "300",
                            "data-aos-offset": "75",
                            children: [
                                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                    file: getImage(),
                                    aspectRatio: "auto",
                                    priority: true,
                                    className: "transform transition-transform duration-300 ".concat(isHovered ? "translate-y-2" : "translate-y-0", " md:pb-8")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "my-9 font-display-a text-4xl sm:text-4xl md:text-4xl",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-22px",
                                    children: body
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "relative m-0 w-full transform rounded-md border border-red py-9 px-12 text-center transition hover:-translate-y-1 hover:scale-105 md:flex-[0_0_45%] md:py-[90px] md:px-11 lg:flex-[0_0_30%] ".concat(getBackgroundClass()),
                    onMouseEnter: function() {
                        return setIsHovered(true);
                    },
                    onMouseLeave: function() {
                        return setIsHovered(false);
                    },
                    children: [
                        link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            className: "absolute top-0 left-0 z-10 h-full w-full",
                            variant: "none",
                            to: (0,getLinkUrl/* getLinkUrl */.U)(link),
                            openInNewTab: link === null || link === void 0 ? void 0 : (ref1 = link.fields) === null || ref1 === void 0 ? void 0 : ref1.openInNewTab,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "sr-only",
                                children: [
                                    "view service:",
                                    title
                                ]
                            })
                        }),
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                            file: getImage(),
                            aspectRatio: "auto",
                            priority: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "my-9 font-display-a text-base md:my-3",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[15px]",
                            children: body
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Molecules/Services/ServiceList/ServiceList.tsx



var ServiceList = function(param) {
    var services = param.services, animated = param.animated, serviceItemBoxDefaultColourWhite = param.serviceItemBoxDefaultColourWhite;
    var hrRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-[70px] flex flex-wrap justify-between gap-4 md:gap-5",
                children: services.map(function(param, index) {
                    var _fields = param.fields, link = _fields.link, title = _fields.title, body = _fields.body, image = _fields.image, _imageRollover = _fields.imageRollover, imageRollover = _imageRollover === void 0 ? image : _imageRollover;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceListItem, {
                        link: link,
                        title: title,
                        body: body,
                        image: image,
                        imageRollover: imageRollover,
                        animated: animated,
                        serviceItemBoxDefaultColourWhite: serviceItemBoxDefaultColourWhite
                    }, index);
                })
            }),
            animated && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-aos": "flip-left",
                "data-aos-duration": "800",
                "data-aos-delay": "500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    ref: hrRef,
                    className: "mt-10 border-t-3 border-red-500 pt-2"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con26/Con26.tsx
/* Dependencies */ 
// Components






/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon26
 * @returns
 */ var Con26 = function(param) {
    var _fields = param.fields, title = _fields.title, callToAction = _fields.callToAction, services = _fields.services, animated = _fields.animated, _serviceItemBoxDefaultColourWhite = _fields.serviceItemBoxDefaultColourWhite, serviceItemBoxDefaultColourWhite = _serviceItemBoxDefaultColourWhite === void 0 ? true : _serviceItemBoxDefaultColourWhite;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        className: "my-16 flex min-h-290 items-center lg:my-32 lg:min-h-550",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "pb-14 md:max-w-1450 lg:pb-0",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        font: (title === null || title === void 0 ? void 0 : (ref = title.fields) === null || ref === void 0 ? void 0 : ref.fontFamily) || "",
                        style: (title === null || title === void 0 ? void 0 : (ref1 = title.fields) === null || ref1 === void 0 ? void 0 : ref1.style) || "",
                        className: "mb-6 text-center text-primary lg:mb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: (title === null || title === void 0 ? void 0 : (ref2 = title.fields) === null || ref2 === void 0 ? void 0 : ref2.content) || ""
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                    callsToAction: callToAction
                }),
                services && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceList, {
                        services: services,
                        animated: animated,
                        serviceItemBoxDefaultColourWhite: serviceItemBoxDefaultColourWhite
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con27/Con27.tsx
/* Dependencies */ 
// Components



/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeTestimonial
 * @returns
 */ var Con27 = function(param) {
    var fields = param.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "CON27"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: fields.quote
                    }),
                    fields.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                        file: fields.logo
                    }),
                    fields.companyName,
                    fields.personName
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/context/PageContext.tsx
var PageContext = __webpack_require__(3032);
// EXTERNAL MODULE: ./src/helpers/prefixSlug/prefixSlug.ts
var prefixSlug = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/Organisms/Con28/Con28.tsx
/* Dependencies */ 


// Components



/**
 * CONTENT CHILD NAV - CON28
 * @param TypeBlockContentChildNav
 * @returns
 */ var Con28 = function(param) {
    var _fields = param.fields, navigationItems = _fields.navigationItems, callToAction = _fields.callToAction;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContext/* PageContext.Consumer */.z.Consumer, {
        children: function(param) {
            var pageTitle = param.pageTitle;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                className: "py-12 text-base text-plum lg:py-16 lg:text-3xl",
                children: [
                    navigationItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mx-auto flex flex-col items-center lg:flex-row lg:justify-around",
                        children: navigationItems.map(function(navItem, index) {
                            if (router.asPath.includes(navItem.fields.page.fields.slug)) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "px-4 transition-opacity hover:opacity-100",
                                    children: navItem.fields && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "border-b-[2px] border-plum",
                                        children: navItem.fields.title
                                    })
                                }, "navItem_".concat(index));
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "px-4 opacity-50 transition-opacity hover:opacity-100",
                                    children: navItem.fields && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (0,prefixSlug/* prefixSlug */.O)(navItem.fields.page.fields.slug),
                                        className: "border-b-[2pxm",
                                        children: navItem.fields.title
                                    })
                                }, "navItem_".concat(index));
                            }
                        })
                    }),
                    callToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                        callsToAction: [
                            callToAction
                        ],
                        className: "mt-6 flex justify-center lg:mt-12"
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con29/Con29.tsx
/* Dependencies */ 
// Components


/**
 * CONTENT ICON LIST - CON29
 * @param TypeCon29
 * @returns
 */ var Con29 = function(param) {
    var fields = param.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: fields.icons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto my-16 max-w-974 lg:my-32 lg:grid lg:grid-cols-2 lg:gap-x-6 lg:gap-y-4",
            children: fields.icons.map(function(param, index) {
                var _fields = param.fields, image = _fields.image, title = _fields.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-5 rounded-md border-x-[1px] border-y-[1px] border-solid border-red py-6 px-10 text-plum lg:mb-0 lg:py-8 lg:px-24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto mb-4 w-9",
                            children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                file: image.fields.asset
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center font-display-a text-base",
                            children: title
                        })
                    ]
                }, "icon_".concat(index));
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/Organisms/Con30/Con30.tsx
/* Dependencies */ 

// Components







/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon30
 * @returns
 */ var Con30 = function(param) {
    var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy, callToAction = _fields.callToAction;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        className: "my-24 lg:my-40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "mx-auto max-w-1270 text-center text-plum",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h2",
                    font: title.fields.fontFamily,
                    style: title.fields.style,
                    className: "mb-6 lg:mb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: title.fields.content
                    })
                }),
                bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                    className: "mx-auto mb-8 mt-6 max-w-800 text-sm lg:text-base",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                    })
                }),
                callToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-5 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkButton/* LinkButton */.Q, {
                        variant: (ref = callToAction.fields.theme) === null || ref === void 0 ? void 0 : ref.fields.colourScheme,
                        openInNewTab: callToAction.fields.openInNewTab,
                        to: (0,getLinkUrl/* getLinkUrl */.U)(callToAction),
                        hasIcon: callToAction.fields.assetLink && callToAction.fields.assetLink.fields ? true : false,
                        children: [
                            callToAction.fields.title,
                            callToAction.fields.assetLink && callToAction.fields.assetLink.fields && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 1.5,
                                stroke: "currentColor",
                                className: "ml-1 h-3 w-3 lg:h-4 lg:w-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: "https://apps.elfsight.com/p/platform.js"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-20 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "elfsight-app-8851d9fd-98af-4268-bd88-80b6e1a8a31b"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con31/Con31.tsx
/* Dependencies */ 
// Components







/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeCon31
 * @returns
 */ var Con31 = function(param) {
    var _fields = param.fields, columnContent = _fields.columnContent, callToAction = _fields.callToAction;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        className: "my-20 overflow-hidden lg:my-36",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "relative grid w-full gap-y-14 sm:max-w-1130 md:grid-cols-2 md:gap-x-10 md:gap-y-36",
            children: [
                columnContent.map(function(param, index) {
                    var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h3",
                                font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                                style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                                className: "mb-10 text-primary lg:mb-8 ".concat((title === null || title === void 0 ? void 0 : title.fields.style) === "Heading 2" ? "lg:text-[50px]" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: title === null || title === void 0 ? void 0 : title.fields.content
                                })
                            }),
                            bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                variant: "base",
                                className: "text-primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                                })
                            })
                        ]
                    }, "column_".concat(index));
                }),
                callToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:col-span-2 md:mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkButton/* LinkButton */.Q, {
                        to: (0,getLinkUrl/* getLinkUrl */.U)(callToAction),
                        variant: (ref = callToAction.fields.theme) === null || ref === void 0 ? void 0 : ref.fields.colourScheme,
                        openInNewTab: callToAction.fields.openInNewTab,
                        hasIcon: callToAction.fields.assetLink && callToAction.fields.assetLink.fields ? true : false,
                        children: [
                            callToAction.fields.title,
                            callToAction.fields.assetLink && callToAction.fields.assetLink.fields && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 1.5,
                                stroke: "currentColor",
                                className: "ml-1 h-3 w-3 lg:h-4 lg:w-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Con32/Con32.tsx
/* Dependencies */ 
// Components




/**
 * CONTENT FULL PAGE IMAGE - CON32
 * @param TypeCon32
 * @returns
 */ var Con32 = function(param) {
    var _fields = param.fields, title = _fields.title, height = _fields.height, image = _fields.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-aos": "fade-up",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h2",
                    style: "".concat(title.fields.style),
                    className: "text-center mb-6 lg:mb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: title.fields.content
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                    file: image.fields.asset,
                    height: height,
                    aspectRatio: "fluid",
                    className: "object-cover"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Organisms/Hb01/Hb01.tsx + 1 modules
var Hb01 = __webpack_require__(9616);
;// CONCATENATED MODULE: ./src/components/Molecules/Awards/Awards.tsx
/* Dependencies */ 
// Components

var Awards = function(param) {
    var awards = param.awards;
    return awards && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-".concat(awards.fields.theme.fields.colourScheme.toLowerCase(), " py-16"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-1130 justify-between px-12 brightness-0 invert filter lg:flex",
            children: awards.fields.logos.map(function(logo, index) {
                if (logo.fields.asset) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-12 flex h-20 flex-col items-center last:mr-0 lg:mr-24 lg:mb-0 lg:h-32",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                            file: logo.fields.asset
                        })
                    }, index);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Hb02/Hb02.tsx
/* Dependencies */ 


// Components








/**
 *  HERO BANNER IMAGE - HB02
 * @param TypeHb02 - Contentful model
 * @returns
 */ var Hb02 = function(param) {
    var _fields = param.fields, title = _fields.title, subheading = _fields.subheading, bodyCopy = _fields.bodyCopy, theme = _fields.theme, callsToAction = _fields.callsToAction, image = _fields.image, awards = _fields.awards;
    var leftContainerRef = (0,react.useRef)(null);
    var leftContainerContentRef = (0,react.useRef)(null);
    var rightContainerRef = (0,react.useRef)(null);
    // Set the background color of the component
    var bgColor = "transparent";
    if (theme) {
        bgColor = theme.fields.colourScheme.toLowerCase();
    }
    // Animate the component on mount.
    (0,react.useEffect)(function() {
        // Query the content elements.
        var containerElements = [];
        if (leftContainerContentRef.current) {
            containerElements = Array.from(leftContainerContentRef.current.querySelectorAll(".content-item")) || [];
        }
        // Animate the content elements on a timeline.
        anime_es/* default.timeline */.Z.timeline({
            autoplay: true
        }).add({
            targets: leftContainerRef.current,
            translateX: [
                "-20%",
                0
            ],
            scale: [
                0.8,
                1
            ],
            easing: "easeInOutQuad",
            duration: 1000
        }).add({
            targets: rightContainerRef.current,
            translateX: [
                "20%",
                0
            ],
            easing: "easeInOutQuad",
            duration: 1000
        }, "-=1000").add({
            targets: containerElements,
            translateY: [
                "20px",
                0
            ],
            opacity: [
                0,
                1
            ],
            easing: "linear",
            delay: anime_es/* default.stagger */.Z.stagger(50)
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComponentWrapper/* ComponentWrapper */.N, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto lg:overflow-hidden lg:pb-0 ".concat(awards ? "before:absolute before:top-0 before:bottom-0 before:left-0 before:right-0 before:bg-".concat(awards.fields.theme.fields.colourScheme.toLowerCase(), " lg:before:top-1/2") : "pb-[15vh]"),
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative h-[60vh] w-full overflow-hidden lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                file: image.fields.asset,
                                aspectRatio: "absolute"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full ".concat(awards ? "-mt-[20vh]" : "absolute -translate-y-1/2 transform lg:transform-none", " flex-row lg:static lg:mt-0 lg:py-16"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                                arrowsSide: "Left",
                                bgColour: "transparent",
                                classNameWrapper: "hidden lg:block w-[60%] absolute top-0 right-0 h-full translate-x-[20%] transform",
                                ref: rightContainerRef,
                                children: image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full lg:block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                                file: image.fields.asset,
                                                aspectRatio: "absolute"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full lg:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                                file: image.fields.asset,
                                                aspectRatio: "1x1"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "z-2 relative w-full -translate-x-[20%] transform lg:w-3/5",
                                ref: leftContainerRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                                    arrowsSide: "Right",
                                    arrowsSize: awards ? "None" : "",
                                    bgColour: bgColor,
                                    className: "flex flex-row items-center justify-start lg:min-h-[70vh]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full max-w-[90%] py-16 px-8 lg:py-32 lg:px-28 xl:max-w-[80%]",
                                        ref: leftContainerContentRef,
                                        children: [
                                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "content-item mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-base",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                        content: subheading
                                                    })
                                                })
                                            }),
                                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                                level: "h1",
                                                style: title.fields.style,
                                                font: title.fields.fontFamily,
                                                className: "content-item whitespace-pre opacity-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                    content: title.fields.content
                                                })
                                            }),
                                            bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                                className: "content-item mt-9 opacity-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                    content: bodyCopy.fields.content
                                                })
                                            }),
                                            callsToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "content-item mt-9 flex w-full flex-row opacity-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                                                    callsToAction: callsToAction,
                                                    className: "itmes-center flex flex-wrap justify-start"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            awards && /*#__PURE__*/ (0,jsx_runtime.jsx)(Awards, {
                awards: awards
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Hb03/Hb03.model.ts





function animate(leftContainer, leftContainerContent, rightContainer) {
    // Query the content elements.
    var containerElements = [];
    if (leftContainerContent) {
        containerElements = Array.from(leftContainerContent.querySelectorAll(".content-item")) || [];
    }
    // Animate the content elements on a timeline.
    anime_es/* default.timeline */.Z.timeline({
        autoplay: true
    }).add(getAnimation(leftContainer, {
        translateX: [
            "-20%",
            0
        ],
        scale: [
            0.8,
            1
        ]
    })).add(getAnimation(rightContainer, {
        translateX: [
            "20%",
            0
        ]
    }), "-=1000").add(getAnimation(containerElements, {
        translateY: [
            "20px",
            0
        ],
        opacity: [
            0,
            1
        ],
        easing: "linear",
        delay: anime_es/* default.stagger */.Z.stagger(50)
    }));
}
function Hb03_model_openAndPlayVideo(initialContent, videoContent, leftContainer, rightContainer, iframeReady) {
    var video = videoContent === null || videoContent === void 0 ? void 0 : videoContent.querySelector("iframe");
    if (videoContent && video && iframeReady) {
        anime_es/* default.timeline */.Z.timeline({
            autoplay: true
        }).add(getAnimation(initialContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.fadeOut), {
            complete: function() {
                initialContent && (initialContent.style.zIndex = "-1");
            }
        }))).add(getAnimation(videoContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.fadeIn), {
            begin: function() {
                videoContent.style.display = "flex";
                (video === null || video === void 0 ? void 0 : video.dataset.src) && (video.src = video.dataset.src);
            }
        })), "-=1000").add(getAnimation(leftContainer, animations.slideTextArrowOut), "-=1000").add(getAnimation(rightContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.slideVideoIntoCentre), {
            maxWidth: [
                "".concat((0,getWindowWidth/* getWindowWidth */.f)()),
                "1130px"
            ]
        })), "-=500").add(getAnimation(rightContainer === null || rightContainer === void 0 ? void 0 : rightContainer.querySelector(".clip-container_left"), animations.flattenLeftArrow), "-=1000").add(getAnimation(rightContainer === null || rightContainer === void 0 ? void 0 : rightContainer.querySelector(".clip-container_right"), animations.flattenRightArrow), "-=1000");
    }
}
function stopAndCloseVideo(initialContent, videoContent, leftContainer, rightContainer) {
    var video = videoContent === null || videoContent === void 0 ? void 0 : videoContent.querySelector("iframe");
    anime_es/* default.timeline */.Z.timeline({
        autoplay: true
    }).add(getAnimation(rightContainer === null || rightContainer === void 0 ? void 0 : rightContainer.querySelector(".clip-container_left"), animations.flattenLeftArrow, true)).add(getAnimation(rightContainer === null || rightContainer === void 0 ? void 0 : rightContainer.querySelector(".clip-container_right"), animations.flattenRightArrow, true), "-=1000").add(getAnimation(rightContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.slideVideoIntoCentre), {
        maxWidth: [
            "".concat((0,getWindowWidth/* getWindowWidth */.f)()),
            "1130px"
        ]
    }), true), "-=1000").add(getAnimation(videoContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.fadeOut), {
        begin: function() {
            (video === null || video === void 0 ? void 0 : video.dataset.src) && (video.src = "");
        },
        complete: function() {
            videoContent && (videoContent.style.display = "");
        }
    })), "-=500").add(getAnimation(leftContainer, animations.slideTextArrowOut, true), "-=1000").add(getAnimation(initialContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animations.fadeIn), {
        complete: function() {
            initialContent && (initialContent.style.zIndex = "");
        }
    })), "-=1000");
}

;// CONCATENATED MODULE: ./src/components/Organisms/Hb03/Hb03.tsx
/* Dependencies */ 

// Components











/**
 * HERO BANNER VIDEO - HB03
 * @param TypeHb03
 * @returns
 */ var Hb03 = function(param) {
    var _fields = param.fields, title = _fields.title, subheading = _fields.subheading, bodyCopy = _fields.bodyCopy, theme = _fields.theme, callsToAction = _fields.callsToAction, image = _fields.image, video = _fields.video, awards = _fields.awards;
    var leftContainerRef = (0,react.useRef)(null);
    var leftContainerContentRef = (0,react.useRef)(null);
    var rightContainerRef = (0,react.useRef)(null);
    var initialContentRefSm = (0,react.useRef)(null);
    var initialContentRefLg = (0,react.useRef)(null);
    var videoContentRefSm = (0,react.useRef)(null);
    var videoContentRefLg = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), mountIframeLg = ref[0], setMountIframeLg = ref[1];
    var ref1 = (0,react.useState)(false), mountIframeSm = ref1[0], setMountIframeSm = ref1[1];
    (0,react.useEffect)(function() {
        if (video && mountIframeLg) {
            Hb03_model_openAndPlayVideo(initialContentRefLg.current, videoContentRefLg.current, leftContainerRef.current, rightContainerRef.current, mountIframeLg);
        }
    }, [
        mountIframeLg
    ]);
    (0,react.useEffect)(function() {
        if (video && mountIframeSm) {
            Hb03_model_openAndPlayVideo(initialContentRefSm.current, videoContentRefSm.current, leftContainerRef.current, rightContainerRef.current, mountIframeSm);
        }
    }, [
        mountIframeSm
    ]);
    // Set the background color of the component
    var bgColor = "transparent";
    if (theme) {
        bgColor = theme.fields.colourScheme.toLowerCase();
    }
    // Animate the component on mount.
    (0,react.useEffect)(function() {
        animate(leftContainerRef.current, leftContainerContentRef.current, rightContainerRef.current);
    }, []);
    var flattenArrow = false;
    if (awards || video) {
        flattenArrow = true;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComponentWrapper/* ComponentWrapper */.N, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto overflow-hidden ".concat(awards && "before:absolute before:top-0 before:bottom-0 before:left-0 before:right-0 before:bg-plum lg:before:top-1/2", " ").concat(!flattenArrow && "pb-[45vh]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative h-[60vh] w-full lg:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                ref: initialContentRefSm,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnail, {
                                    image: image.fields.asset,
                                    cutOffMobile: true,
                                    onClick: function() {
                                        return setMountIframeSm(true);
                                    }
                                })
                            }),
                            video && mountIframeSm && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoEmbed, {
                                video: video,
                                autoplay: true,
                                controls: true,
                                loop: false,
                                mute: false,
                                closeButtonClick: function() {
                                    stopAndCloseVideo(initialContentRefSm.current, videoContentRefSm.current, leftContainerRef.current, rightContainerRef.current);
                                    setTimeout(function() {
                                        setMountIframeSm(false);
                                    }, 2500);
                                },
                                ref: videoContentRefSm
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full ".concat(flattenArrow ? "-mt-[20vh]" : "absolute -translate-y-1/2 transform lg:transform-none", " flex-row lg:static lg:mt-0 lg:py-16"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerArrow/* ContainerArrow */.r, {
                                arrowsSide: "Left",
                                bgColour: "transparent",
                                classNameWrapper: "hidden lg:block w-[60%] absolute top-0 right-0 h-full translate-x-[20%] transform",
                                ref: rightContainerRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        ref: initialContentRefLg,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full lg:block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnail, {
                                                    image: image.fields.asset,
                                                    onClick: function() {
                                                        return setMountIframeLg(true);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full lg:hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                                    file: image.fields.asset,
                                                    aspectRatio: "1x1"
                                                })
                                            })
                                        ]
                                    }),
                                    video && mountIframeLg && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoEmbed, {
                                        video: video,
                                        autoplay: true,
                                        controls: true,
                                        loop: false,
                                        mute: false,
                                        closeButtonClick: function() {
                                            stopAndCloseVideo(initialContentRefLg.current, videoContentRefLg.current, leftContainerRef.current, rightContainerRef.current);
                                            setTimeout(function() {
                                                setMountIframeLg(false);
                                            }, 2500);
                                        },
                                        ref: videoContentRefLg
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "z-2 relative w-full -translate-x-[20%] transform lg:w-3/5",
                                ref: leftContainerRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                                    arrowsSide: "Right",
                                    arrowsSize: flattenArrow ? "None" : "",
                                    bgColour: bgColor,
                                    className: "flex flex-row items-center justify-start lg:min-h-[70vh]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full max-w-[90%] py-16 px-8 lg:py-32 lg:px-28 xl:max-w-[80%]",
                                        ref: leftContainerContentRef,
                                        children: [
                                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "content-item mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-base",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                        content: subheading
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-aos": "fade-up",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                                    level: "h1",
                                                    style: title.fields.style,
                                                    font: title.fields.fontFamily,
                                                    className: "content-item whitespace-pre opacity-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                        content: title.fields.content
                                                    })
                                                })
                                            }),
                                            bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-aos": "fade-up",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                                    className: "content-item mt-9 opacity-0",
                                                    variant: "base",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                                        content: bodyCopy.fields.content
                                                    })
                                                })
                                            }),
                                            callsToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "content-item mt-9 flex w-full flex-row opacity-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                                                    callsToAction: callsToAction,
                                                    className: "itmes-center flex flex-wrap justify-start"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            awards && /*#__PURE__*/ (0,jsx_runtime.jsx)(Awards, {
                awards: awards
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./src/services/httpClient.ts + 7 modules
var httpClient = __webpack_require__(7296);
;// CONCATENATED MODULE: ./src/components/Molecules/InsightCard/InsightCard.tsx
// Dependencies

// Components





/**
 * PostCard Component
 * @params props - Required component props.
 */ var InsightCard = function(param) {
    var link = param.link, image = param.image, tags = param.tags, title = param.title, publishedDate = param.publishedDate, author = param.author;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex h-full flex-col rounded-md bg-white p-3 pb-4 shadow-light transition hover:shadow-lg lg:p-4 lg:pb-6 lg:hover:scale-105",
        children: [
            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                to: link,
                variant: "none",
                title: title,
                className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full overflow-hidden rounded-md lg:mb-4",
                openInNewTab: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [
                        "view service:",
                        title
                    ]
                })
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                    file: image,
                    aspectRatio: "16x9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-grow flex-col",
                children: [
                    tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-wrap",
                        children: tags === null || tags === void 0 ? void 0 : tags.map(function(tag, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                                backgroundColor: tag === null || tag === void 0 ? void 0 : tag.theme.fields.colourScheme,
                                children: tag === null || tag === void 0 ? void 0 : tag.title
                            }, "".concat(index));
                        })
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h4",
                        className: "mt-4 ".concat(publishedDate || author ? "mb-8 lg:mb-9" : "mb-2", " text-2xl font-normal leading-5 text-plum sm:font-display-s lg:text-24px"),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-auto",
                        children: [
                            publishedDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                className: "font-display-a text-small font-medium text-plum lg:text-base",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                    dateTime: "".concat(publishedDate),
                                    children: publishedDate
                                })
                            }),
                            author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                className: "text-small text-plum lg:text-base",
                                children: author
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Molecules/EventCard/EventCard.tsx
// Dependencies

// Components






/**
 * PostCard Component
 * @params props - Required component props.
 */ var EventCard = function(param) {
    var link = param.link, image = param.image, tags = param.tags, title = param.title, location = param.location, eventDate = param.eventDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex h-full flex-col rounded-md bg-white p-3 pb-4 shadow-light transition hover:scale-105 hover:shadow-lg lg:p-4 lg:pb-6",
        children: [
            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                to: link,
                variant: "none",
                className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full overflow-hidden rounded-md lg:mb-4",
                openInNewTab: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [
                        "view event:",
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title.content
                        })
                    ]
                })
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full overflow-hidden rounded-md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                    file: image,
                    aspectRatio: "16x9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-grow flex-col",
                children: [
                    tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-wrap",
                        children: tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
                            return tag;
                        }).map(function(tag, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                                backgroundColor: tag === null || tag === void 0 ? void 0 : tag.theme.fields.colourScheme,
                                children: tag === null || tag === void 0 ? void 0 : tag.title
                            }, "".concat(index));
                        })
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h4",
                        className: "mt-4 mb-8 text-2xl font-normal leading-5 text-plum sm:font-display-s lg:mb-9 lg:text-24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title.content
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-auto",
                        children: [
                            eventDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                className: "font-display-a text-small font-medium text-plum lg:text-base",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                    dateTime: "".concat(eventDate),
                                    children: eventDate
                                })
                            }),
                            location && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                className: "text-small text-plum lg:text-base",
                                children: location
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Inev03/Inev03.tsx
/* Dependencies */ 


// Services

// Helpers

// Components





/**
 * INSIGHT & EVENT & Case Study POST CAROUSEL - INEV03
 * @param TypeInev03
 * @returns
 */ var Inev03 = function(param) {
    var _fields = param.fields, articles = _fields.articles, events = _fields.events, caseStudies = _fields.caseStudies, title = _fields.title, subheading = _fields.subheading;
    var entries = 5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Plum",
        className: "flex items-center overflow-hidden bg-insight-pattern bg-[length:65%] bg-right-top bg-no-repeat pt-10 pb-16 sm:bg-auto lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative mx-auto w-full lg:max-w-1550 lg:px-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-aos": "fade-up",
                    className: "px-10 lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            className: "mb-6 text-primary lg:mb-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h3",
                            style: "Heading 6",
                            className: "mb-6 font-extrabold uppercase text-primary lg:mb-8",
                            children: subheading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    className: "".concat(entries > 1 ? "pl-10" : "px-10", " lg:px-0"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-flow-col gap-x-4 sm:gap-x-7 ".concat(entries > 1 ? "auto-cols-[calc(100%-12px)] grid-cols-[calc(100%-12px)] pr-10 lg:pr-2 lg:pl-2" : "auto-cols-[100%] grid-cols-[100%]", "\n          ").concat(entries >= 3 ? "sm:auto-cols-[calc(50%-27px)] sm:grid-cols-[calc(50%-27px)]" : "sm:auto-cols-[calc(50%-15px)] sm:grid-cols-[calc(50%-15px)]", " snap-x snap-proximity overflow-x-auto py-6 scrollbar-none lg:auto-cols-[calc(33.33%-19px)] lg:grid-cols-[calc(33.33%-19px)] xl:auto-cols-[calc(25%-21px)] xl:grid-cols-[calc(25%-21px)]"),
                        children: [
                            articles && articles.map(function(param, index) {
                                var _fields = param.fields, slug = _fields.slug, image = _fields.image, tags = _fields.tags, title = _fields.title, author = _fields.author, publishedDate = _fields.publishedDate;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightCard, {
                                    link: "/insights/".concat(slug.fields.slug),
                                    image: image === null || image === void 0 ? void 0 : image.fields.asset,
                                    tags: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                                        return tag.fields;
                                    }),
                                    title: title,
                                    publishedDate: publishedDate ? (0,getFormattedDate/* getFormattedDate */.L0)(publishedDate) : undefined,
                                    author: author.fields.name
                                }, "".concat(index));
                            }),
                            caseStudies && caseStudies.map(function(param, index) {
                                var _fields = param.fields, slug = _fields.slug, image = _fields.image, tags = _fields.tags, title = _fields.title;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightCard, {
                                    link: "/case-studies/".concat(slug.fields.slug),
                                    image: image === null || image === void 0 ? void 0 : image.fields.asset,
                                    tags: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                                        return tag.fields;
                                    }),
                                    title: title
                                }, "".concat(index));
                            }),
                            events && events.map(function(param, index) {
                                var _fields = param.fields, slug = _fields.slug, image = _fields.image, tags = _fields.tags, title = _fields.title, eventDate = _fields.eventDate, location = _fields.location;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard, {
                                    link: "/events/".concat(slug.fields.slug),
                                    image: image === null || image === void 0 ? void 0 : image.fields.asset,
                                    tags: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                                        return tag.fields;
                                    }),
                                    title: title.fields,
                                    eventDate: eventDate ? (0,getFormattedDate/* getFormattedDateTime */.e1)(eventDate) : undefined,
                                    location: location
                                }, "".concat(index));
                            })
                        ]
                    })
                })
            ]
        })
    });
};
// Store Cache
var articlesCache;
var eventsCache;
var caseStudiesCache;
var displayLimitCache;
/**
 * Get Enhanced Props for INEV03
 * @param component - INEV03 Component
 * @param preview - Preview Mode
 * @returns
 */ function getInev03EnhancedProps(component) {
    return _getInev03EnhancedProps.apply(this, arguments);
}
function _getInev03EnhancedProps() {
    _getInev03EnhancedProps = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(component) {
        var preview, componentData, articlePages, eventPages, caseStudyPages, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    preview = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    componentData = component;
                    if (!(componentData.sys.contentType.sys.id !== "blockCaseStudyPostCarousel")) {
                        _ctx.next = 25;
                        break;
                    }
                    ;
                    if (!(articlesCache && displayLimitCache === componentData.fields.displayLimit)) {
                        _ctx.next = 8;
                        break;
                    }
                    {
                        articlePages = articlesCache;
                    }
                    _ctx.next = 12;
                    break;
                case 8:
                    _ctx.next = 10;
                    return httpClient/* httpClient.contentful.retrieveLatestInsights */.M.contentful.retrieveLatestInsights({
                        limit: componentData.fields.displayLimit,
                        locale: "en-GB"
                    }, preview);
                case 10:
                    articlePages = _ctx.sent;
                    articlesCache = articlePages;
                case 12:
                    // Set Article Pages
                    component.fields.articles = articlePages.items;
                    ;
                    if (!(eventsCache && displayLimitCache === componentData.fields.displayLimit)) {
                        _ctx.next = 18;
                        break;
                    }
                    {
                        eventPages = eventsCache;
                    }
                    _ctx.next = 22;
                    break;
                case 18:
                    _ctx.next = 20;
                    return httpClient/* httpClient.contentful.retrieveLatestEvents */.M.contentful.retrieveLatestEvents({
                        limit: componentData.fields.displayLimit,
                        locale: "en-GB"
                    }, preview);
                case 20:
                    eventPages = _ctx.sent;
                    eventsCache = eventPages;
                case 22:
                    // Set Event Pages
                    component.fields.events = eventPages.items;
                    _ctx.next = 35;
                    break;
                case 25:
                    ;
                    if (!(caseStudiesCache && displayLimitCache === componentData.fields.displayLimit)) {
                        _ctx.next = 30;
                        break;
                    }
                    {
                        caseStudyPages = caseStudiesCache;
                    }
                    _ctx.next = 34;
                    break;
                case 30:
                    _ctx.next = 32;
                    return httpClient/* httpClient.contentful.retrieveLatestCaseStudies */.M.contentful.retrieveLatestCaseStudies({
                        limit: componentData.fields.displayLimit,
                        locale: "en-GB"
                    }, preview);
                case 32:
                    caseStudyPages = _ctx.sent;
                    caseStudiesCache = caseStudyPages;
                case 34:
                    // Set Event Pages
                    component.fields.caseStudies = caseStudyPages.items;
                case 35:
                    return _ctx.abrupt("return", component);
                case 36:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getInev03EnhancedProps.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/components/Organisms/Inev06/Inev06.tsx
/* Dependencies */ 
// Components









// Helpers

/**
 * FEATURED POST - INEV06
 * @param TypeInev06
 * @returns
 */ var Inev06 = function(param) {
    var _fields = param.fields, preTitle = _fields.preTitle, title = _fields.title, article = _fields.article;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            className: "relative max-w-1130 py-16 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        to: "/insights/".concat(article.fields.slug.fields.slug),
                        variant: "none",
                        className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full overflow-hidden rounded-md lg:mb-4",
                        openInNewTab: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "view article"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        style: "Heading 6",
                        className: "uppercase",
                        children: preTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col rounded-md bg-white lg:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "order-last w-full py-6 px-4 lg:order-first lg:w-3/5 lg:pr-24 lg:pl-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "mb-6 flex",
                                        children: (ref = article.fields.tags) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                                            var _fields = param.fields, title = _fields.title, theme = _fields.theme;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                                                backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
                                                className: "m-0 mr-2 last:mr-0",
                                                children: title
                                            }, "".concat(index));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                        level: "h2",
                                        font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                                        style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                                        className: "mb-6 font-display-s text-primary lg:mb-24",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                            content: title === null || title === void 0 ? void 0 : title.fields.content
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        className: "font-display-a text-base text-primary",
                                        dateTime: "".concat(String(article.fields.publishedDate)),
                                        children: (0,getFormattedDate/* getFormattedDate */.L0)(String(article.fields.publishedDate))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                        className: "text-small text-primary",
                                        children: article.fields.author.fields.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full pl-8 lg:w-2/5 lg:pl-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                                    arrowsSide: "Left",
                                    classNameWrapper: "w-full h-full overflow-hidden rounded-md",
                                    children: article.fields.image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden lg:block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                                    file: article.fields.image.fields.asset,
                                                    aspectRatio: "absolute"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "block lg:hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                                    file: article.fields.image.fields.asset
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(1358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
;// CONCATENATED MODULE: ./src/components/Molecules/LatestPostFilters/LatestPostFilters.tsx

var LatestPostFilters = function(param) {
    var activeTag = param.activeTag, tags = param.tags, handleFilter = param.handleFilter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-8 grid grid-cols-2 gap-y-7 md:mb-16 md:flex md:items-center md:justify-center md:gap-x-[72px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-primary lg:text-3xl ".concat(!activeTag ? "underline" : "opacity-50"),
                onClick: function() {
                    return handleFilter(undefined);
                },
                children: "All"
            }),
            tags.map(function(tag, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "text-primary lg:text-3xl ".concat(activeTag === tag ? "underline" : "opacity-50"),
                    onClick: function() {
                        return handleFilter(tag);
                    },
                    children: tag.fields.title
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/FeaturedArticle/FeaturedArticle.tsx
/* Dependencies */ 
/* Components */ 






/**
 * Featured Article
 * @param FeaturedArticleViewModel
 * @returns
 */ var FeaturedArticle = function(param) {
    var _fields = param.fields, tags = _fields.tags, title = _fields.title, publishedDate = _fields.publishedDate, author = _fields.author, image = _fields.image, slug = _fields.slug, preTitle = param.preTitle, _pageType = param.pageType, pageType = _pageType === void 0 ? "insights" : _pageType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-24 lg:mb-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h2",
                style: "Heading 6",
                className: "mb-8 uppercase lg:mb-6",
                children: preTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-col rounded-md bg-white lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        to: "/".concat(pageType, "/").concat(slug === null || slug === void 0 ? void 0 : slug.fields.slug),
                        variant: "none",
                        className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full overflow-hidden rounded-md lg:mb-4",
                        openInNewTab: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "view event"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-last w-full py-6 px-4 lg:order-first lg:w-3/5 lg:pr-24 lg:pl-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "mb-6 flex",
                                children: tags === null || tags === void 0 ? void 0 : tags.map(function(param, index) {
                                    var _fields = param.fields, title = _fields.title, theme = _fields.theme;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                                        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
                                        className: "m-0 mr-2 last:mr-0",
                                        children: title
                                    }, "".concat(index));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                className: "mb-6 font-display-s text-plum lg:mb-24",
                                children: title
                            }),
                            pageType === "insights" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        className: "font-display-a text-base text-plum",
                                        dateTime: "".concat(String(publishedDate)),
                                        children: (0,getFormattedDate/* getFormattedDate */.L0)(String(publishedDate))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                        className: "text-small text-plum",
                                        children: author === null || author === void 0 ? void 0 : author.fields.name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full pl-8 lg:w-2/5 lg:pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                            arrowsSide: "Left",
                            classNameWrapper: "w-full h-full overflow-hidden rounded-md",
                            children: image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                            file: image.fields.asset,
                                            aspectRatio: "absolute"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block lg:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                            file: image.fields.asset
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/InsightPostGrid/InsightPostGrid.tsx
/* Dependencies */ 






// Services

// Components







/**
 * INSIGHT & EVENT POST GRID - INEV07
 * @param InsightPostGridViewModel
 * @returns
 */ var InsightPostGrid = function(param) {
    var _fields = param.fields, title = _fields.title, displayLimit = _fields.displayLimit, articles = _fields.articles, filterTags = _fields.filterTags;
    var ref = (0,react.useState)(), activeTag = ref[0], setActiveTag = ref[1];
    var ref1 = (0,react.useState)(), featuredArticle = ref1[0], setFeaturedArticle = ref1[1];
    var ref2 = (0,react.useState)([]), currentItems = ref2[0], setCurrentItems = ref2[1];
    var ref3 = (0,react.useState)(0), pageCount = ref3[0], setPageCount = ref3[1];
    var ref4 = (0,react.useState)(1), itemOffset = ref4[0], setItemOffset = ref4[1];
    var ref5 = (0,react.useState)(1), currentPage = ref5[0], setCurrentPage = ref5[1];
    var postGrid = (0,react.useRef)();
    var handlePageClick = function(event) {
        var newOffset = (event.selected * displayLimit + 1) % articles.length;
        setItemOffset(newOffset);
        postGrid.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        // Store items to use
        var articlesToUse;
        // Handle Active Tag
        if (activeTag) {
            articlesToUse = articles.filter(function(item) {
                if (item.fields.tags) {
                    var tagIds = item.fields.tags.map(function(tag) {
                        return tag.sys.id;
                    });
                    return tagIds.includes(activeTag.sys.id);
                }
                return false;
            });
        } else {
            articlesToUse = articles;
        }
        // Set Featured Article
        if (currentPage === 1) {
            setFeaturedArticle(articlesToUse[0]);
        }
        var endOffset = itemOffset + displayLimit;
        setCurrentItems(articlesToUse.slice(itemOffset, endOffset));
        setPageCount(Math.ceil((articlesToUse.length - 1) / displayLimit));
        // Set Current Page
        setCurrentPage(Math.floor(itemOffset / displayLimit));
    }, [
        itemOffset,
        displayLimit,
        activeTag
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Plum",
        className: "text-primary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "py-9 sm:max-w-1130 lg:py-[72px]",
            children: [
                filterTags && /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestPostFilters, {
                    activeTag: activeTag,
                    handleFilter: function(tag) {
                        setActiveTag(tag);
                        setItemOffset(1);
                        setCurrentPage(1);
                    },
                    tags: filterTags
                }),
                featuredArticle && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedArticle, {
                    fields: featuredArticle.fields,
                    preTitle: "FEATURED NEWS",
                    sys: featuredArticle.sys,
                    metadata: featuredArticle.metadata,
                    toPlainObject: featuredArticle.toPlainObject,
                    update: featuredArticle.update
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            style: "Heading 6",
                            className: "mb-6 uppercase",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-5 md:grid-cols-2 lg:grid-cols-3",
                            ref: postGrid,
                            children: currentItems.map(function(param, index) {
                                var _fields = param.fields, slug = _fields.slug, image = _fields.image, tags = _fields.tags, title = _fields.title, author = _fields.author, publishedDate = _fields.publishedDate;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightCard, {
                                        link: "/insights/".concat(slug.fields.slug),
                                        image: image === null || image === void 0 ? void 0 : image.fields.asset,
                                        tags: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                                            return tag.fields;
                                        }),
                                        title: title,
                                        publishedDate: publishedDate ? new Date(publishedDate).toLocaleDateString("en-GB") : undefined,
                                        author: author.fields.name
                                    })
                                }, "insight_".concat(index));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    nextLabel: "NEXT",
                    previousLabel: "PREV",
                    onPageChange: handlePageClick,
                    pageCount: pageCount,
                    forcePage: currentPage,
                    pageRangeDisplayed: 2,
                    marginPagesDisplayed: 1,
                    containerClassName: "pagination mt-9 lg:mt-16 flex justify-center font-display-a font-extrabold text-primary lg:text-2xl",
                    activeClassName: "opacity-50",
                    disabledClassName: "hidden",
                    renderOnZeroPageCount: function() {
                        return null;
                    }
                })
            ]
        })
    });
};
// Cache for the response
var responseCache;
/**
 * Get Insight Post Grid Enhanced Props
 * @param component - Component.
 * @param preview - Preview mode status.
 * @returns
 */ function getInsightPostGridEnhancedProps(component) {
    return _getInsightPostGridEnhancedProps.apply(this, arguments);
}
function _getInsightPostGridEnhancedProps() {
    _getInsightPostGridEnhancedProps = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(component) {
        var preview, insightPages, resultsFound, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    preview = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    ;
                    if (!responseCache) {
                        _ctx.next = 6;
                        break;
                    }
                    {
                        insightPages = responseCache;
                    }
                    _ctx.next = 10;
                    break;
                case 6:
                    _ctx.next = 8;
                    return httpClient/* httpClient.contentful.retrieveLatestInsights */.M.contentful.retrieveLatestInsights({
                        limit: 999,
                        locale: "en-GB"
                    }, preview);
                case 8:
                    insightPages = _ctx.sent;
                    responseCache = insightPages;
                case 10:
                    resultsFound = insightPages.items.length > 0;
                    component.fields.articles = [];
                    if (resultsFound) {
                        component.fields.articles = insightPages.items.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                fields: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.fields), {
                                    tags: item.fields.tags ? item.fields.tags.filter(function(tag) {
                                        return tag.fields;
                                    }) : []
                                })
                            });
                        });
                    }
                    return _ctx.abrupt("return", component);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getInsightPostGridEnhancedProps.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/components/Organisms/Inev10/Inev10.tsx
/* Dependencies */ 
// Components



/**
 * POST CONTENT IMAGE QUOTE - INEV10
 * @param TypeInev10
 * @returns
 */ var Inev10 = function(param) {
    var _fields = param.fields, author = _fields.author, quote = _fields.quote;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto max-w-974",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid gap-y-9 gap-x-8 sm:grid-cols-12 lg:gap-x-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sm:col-span-5",
                    children: author.fields.photo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-hidden rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                            aspectRatio: "12x16",
                            file: author.fields.photo.fields.asset
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sm:col-span-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            className: "blockquote mb-8 sm:mb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: quote
                            })
                        }),
                        author.fields.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            variant: "base",
                            className: "mb-1 font-medium",
                            children: author.fields.name
                        }),
                        author.fields.role && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            variant: "medium",
                            children: author.fields.role
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Inev11/Inev11.tsx
/* Dependencies */ 
// Components

/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeInev11
 * @returns
 */ var Inev11 = function(param) {
    var fields = param.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Statistics, {
        statistics: fields.statistics
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Inev12/Inev12.tsx
/* Dependencies */ 
// Components





/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeInev12
 * @returns
 */ var Inev12 = function(param) {
    var _fields = param.fields, title = _fields.title, people = _fields.people;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "my-16 text-plum sm:max-w-1130 lg:my-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-aos": "fade-up",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h2",
                    font: "".concat(title.fields.fontFamily),
                    style: "".concat(title.fields.style),
                    className: "mb-10 text-center uppercase lg:mb-14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                        content: title === null || title === void 0 ? void 0 : title.fields.content
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-wrap justify-center gap-5",
                    children: people.map(function(param, index) {
                        var _fields = param.fields, photo = _fields.photo, name = _fields.name, role = _fields.role, companyName = _fields.companyName;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "m-0 flex flex-[0_1_300px] flex-col items-center rounded-md border border-red p-5 text-center lg:px-4 lg:pb-8",
                            children: [
                                photo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-5 h-24 w-24 overflow-hidden rounded-full lg:h-[120px] lg:w-[120px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                        file: photo.fields.asset,
                                        aspectRatio: "1x1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex grow flex-col justify-between",
                                    children: [
                                        name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                            level: "h3",
                                            style: "Heading 5",
                                            className: "mb-3 font-display-a font-normal",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                role && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                                    className: "mb-2 text-2xl leading-5",
                                                    children: role
                                                }),
                                                companyName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                                    className: "text-2xl",
                                                    children: companyName
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, "".concat(index));
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Inev16/Inev16.tsx
/* Dependencies */ 
// Components






/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeInev16
 * @returns
 */ var Inev16 = function(param) {
    var _fields = param.fields, theme = _fields.theme, title = _fields.title, columns = _fields.columns, callToAction = _fields.callToAction;
    var gridColumns = [
        "md:grid-cols-1",
        "md:grid-cols-2",
        "md:grid-cols-3"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        className: "py-10 lg:py-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "sm:max-w-1270",
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                        style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                        className: "mb-14 text-center text-primary lg:mb-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title === null || title === void 0 ? void 0 : title.fields.content
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid gap-10 lg:gap-20 ".concat(gridColumns[columns.length - 1], " justify-center ").concat(callToAction ? "mb-6" : ""),
                    children: columns.map(function(param, index) {
                        var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            "data-aos": "fade-up",
                            "data-aos-delay": ((index + 1) * 100).toString(),
                            className: "text-primary",
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                        level: "h3",
                                        font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                                        style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                                        className: "".concat(bodyCopy ? "mb-6 lg:mb-10" : "", " text-primary"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                            content: title === null || title === void 0 ? void 0 : title.fields.content
                                        })
                                    })
                                }),
                                bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* RichText */.H, {
                                        content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                                    })
                                })
                            ]
                        }, "column_".concat(index));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                    callsToAction: callToAction
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/FeaturedEvent/FeaturedEvent.tsx
/* Dependencies */ 
/* Components */ 






// Helpers

/**
 * Featured Event
 * @param FeaturedEventViewModel
 * @returns
 */ var FeaturedEvent = function(param) {
    var _fields = param.fields, tags = _fields.tags, title = _fields.title, eventDate = _fields.eventDate, eventEndDate = _fields.eventEndDate, location = _fields.location, image = _fields.image, slug = _fields.slug, preTitle = param.preTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-24 lg:mb-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: "h2",
                style: "Heading 6",
                className: "mb-8 uppercase lg:mb-6",
                children: preTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-col rounded-md bg-white lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        to: "/events/".concat(slug === null || slug === void 0 ? void 0 : slug.fields.slug),
                        variant: "none",
                        className: "absolute top-0 left-0 z-10 mb-2.5 h-full w-full overflow-hidden rounded-md lg:mb-4",
                        openInNewTab: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "view event"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-last w-full py-6 px-4 lg:order-first lg:w-3/5 lg:pr-24 lg:pl-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "mb-6 flex",
                                children: tags === null || tags === void 0 ? void 0 : tags.map(function(param, index) {
                                    var _fields = param.fields, title = _fields.title, theme = _fields.theme;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                                        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
                                        className: "m-0 mr-2 last:mr-0",
                                        children: title
                                    }, "".concat(index));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                className: "mb-6 font-display-s text-plum lg:mb-24",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: title.fields.content
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-2",
                                children: [
                                    eventDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("time", {
                                                className: "font-display-a text-base text-plum",
                                                dateTime: "".concat(String(eventDate)),
                                                children: [
                                                    (0,getFormattedDate/* getFormattedDate */.L0)(String(eventDate)),
                                                    eventDate && " - ",
                                                    (0,getFormattedDate/* getFormattedDate */.L0)(String(eventEndDate))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("time", {
                                                className: "font-display-a text-base text-plum",
                                                dateTime: "".concat(String(eventDate)),
                                                children: [
                                                    (0,getFormattedDate/* getFormattedTime */.xz)(String(eventDate)),
                                                    " ",
                                                    eventDate && " - ",
                                                    (0,getFormattedDate/* getFormattedTime */.xz)(String(eventEndDate))
                                                ]
                                            })
                                        ]
                                    }),
                                    location && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                        className: "text-small text-plum",
                                        children: location
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full pl-8 lg:w-2/5 lg:pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                            arrowsSide: "Left",
                            classNameWrapper: "w-full h-full overflow-hidden rounded-md",
                            children: image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                            file: image.fields.asset,
                                            aspectRatio: "absolute"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block lg:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                            file: image.fields.asset
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/EventPostGrid/EventPostGrid.tsx
/* Dependencies */ 






// Services

// Components







/**
 * INSIGHT & EVENT POST GRID - INEV07
 * @param EventPostGridViewModel
 * @returns
 */ var EventPostGrid = function(param) {
    var _fields = param.fields, title = _fields.title, displayLimit = _fields.displayLimit, events = _fields.events, filterTags = _fields.filterTags;
    var ref = (0,react.useState)(), activeTag = ref[0], setActiveTag = ref[1];
    var ref1 = (0,react.useState)(), featuredEvent = ref1[0], setFeaturedEvent = ref1[1];
    var ref2 = (0,react.useState)([]), currentItems = ref2[0], setCurrentItems = ref2[1];
    var ref3 = (0,react.useState)(0), pageCount = ref3[0], setPageCount = ref3[1];
    var ref4 = (0,react.useState)(1), itemOffset = ref4[0], setItemOffset = ref4[1];
    var ref5 = (0,react.useState)(1), currentPage = ref5[0], setCurrentPage = ref5[1];
    var postGrid = (0,react.useRef)();
    var handlePageClick = function(event) {
        var newOffset = (event.selected * displayLimit + 1) % events.length;
        setItemOffset(newOffset);
        postGrid.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        // Store items to use
        var eventsToUse;
        // Handle Active Tag
        if (activeTag) {
            eventsToUse = events.filter(function(item) {
                if (item.fields.tags) {
                    var tagIds = item.fields.tags.map(function(tag) {
                        return tag.sys.id;
                    });
                    return tagIds.includes(activeTag.sys.id);
                }
                return false;
            });
        } else {
            eventsToUse = events;
        }
        // Set Featured Event
        if (currentPage === 1) {
            setFeaturedEvent(eventsToUse[0]);
        }
        var endOffset = itemOffset + displayLimit;
        setCurrentItems(eventsToUse.slice(itemOffset, endOffset));
        setPageCount(Math.ceil((eventsToUse.length - 1) / displayLimit));
        // Set Current Page
        setCurrentPage(Math.floor(itemOffset / displayLimit));
    }, [
        itemOffset,
        displayLimit,
        activeTag
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Plum",
        className: "text-primary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "py-9 sm:max-w-1130 lg:py-[72px]",
            children: [
                filterTags && /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestPostFilters, {
                    activeTag: activeTag,
                    handleFilter: function(tag) {
                        setActiveTag(tag);
                        setItemOffset(1);
                        setCurrentPage(1);
                    },
                    tags: filterTags
                }),
                featuredEvent && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedEvent, {
                    fields: featuredEvent.fields,
                    preTitle: "FEATURED EVENT",
                    sys: featuredEvent.sys,
                    metadata: featuredEvent.metadata,
                    toPlainObject: featuredEvent.toPlainObject,
                    update: featuredEvent.update
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            style: "Heading 6",
                            className: "my-6 uppercase text-primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-5 md:grid-cols-2 lg:grid-cols-3",
                            ref: postGrid,
                            children: currentItems.map(function(param, index) {
                                var _fields = param.fields, slug = _fields.slug, image = _fields.image, tags = _fields.tags, title = _fields.title, eventDate = _fields.eventDate;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard, {
                                        link: "/events/".concat(slug.fields.slug),
                                        image: image === null || image === void 0 ? void 0 : image.fields.asset,
                                        tags: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                                            return tag.fields;
                                        }),
                                        title: title.fields,
                                        publishedDate: eventDate ? new Date(eventDate).toLocaleDateString("en-GB") : undefined
                                    })
                                }, "event_".concat(index));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    nextLabel: "NEXT",
                    previousLabel: "PREV",
                    onPageChange: handlePageClick,
                    pageCount: pageCount,
                    forcePage: currentPage,
                    pageRangeDisplayed: 2,
                    marginPagesDisplayed: 1,
                    containerClassName: "pagination mt-9 lg:mt-16 flex justify-center font-display-a font-extrabold text-primary lg:text-2xl",
                    activeClassName: "opacity-50",
                    disabledClassName: "hidden",
                    renderOnZeroPageCount: function() {
                        return null;
                    }
                })
            ]
        })
    });
};
// Cache for the response
var EventPostGrid_responseCache;
/**
 * Get Event Post Grid Enhanced Props
 * @param component - Component.
 * @param preview - Preview mode status.
 * @returns
 */ function getEventPostGridEnhancedProps(component) {
    return _getEventPostGridEnhancedProps.apply(this, arguments);
}
function _getEventPostGridEnhancedProps() {
    _getEventPostGridEnhancedProps = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(component) {
        var preview, eventPages, resultsFound, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    preview = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    ;
                    if (!EventPostGrid_responseCache) {
                        _ctx.next = 6;
                        break;
                    }
                    {
                        eventPages = EventPostGrid_responseCache;
                    }
                    _ctx.next = 10;
                    break;
                case 6:
                    _ctx.next = 8;
                    return httpClient/* httpClient.contentful.retrieveLatestEvents */.M.contentful.retrieveLatestEvents({
                        limit: 999,
                        locale: "en-GB"
                    }, preview);
                case 8:
                    eventPages = _ctx.sent;
                    EventPostGrid_responseCache = eventPages;
                case 10:
                    // Set the events
                    component.fields.events = [];
                    resultsFound = eventPages.items.length > 0;
                    if (resultsFound) {
                        component.fields.events = eventPages.items.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                fields: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.fields), {
                                    tags: item.fields.tags ? item.fields.tags.filter(function(tag) {
                                        return tag.fields;
                                    }) : []
                                })
                            });
                        });
                    }
                    return _ctx.abrupt("return", component);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getEventPostGridEnhancedProps.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/components/Organisms/CaseStudyPostGrid/CaseStudyPostGrid.tsx
/* Dependencies */ 






// Services

// Components







/**
 * CASE STUDY POST GRID - INEV07
 * @param CaseStudyPostGridViewModel
 * @returns
 */ var CaseStudyPostGrid = function(param) {
    var _fields = param.fields, title = _fields.title, displayLimit = _fields.displayLimit, caseStudies = _fields.caseStudies, filterTags = _fields.filterTags;
    var ref = (0,react.useState)(), activeTag = ref[0], setActiveTag = ref[1];
    var ref1 = (0,react.useState)(), featuredCaseStudy = ref1[0], setFeaturedCaseStudy = ref1[1];
    var ref2 = (0,react.useState)([]), currentItems = ref2[0], setCurrentItems = ref2[1];
    var ref3 = (0,react.useState)(0), pageCount = ref3[0], setPageCount = ref3[1];
    var ref4 = (0,react.useState)(1), itemOffset = ref4[0], setItemOffset = ref4[1];
    var ref5 = (0,react.useState)(1), currentPage = ref5[0], setCurrentPage = ref5[1];
    var postGrid = (0,react.useRef)();
    var handlePageClick = function(event) {
        var newOffset = (event.selected * displayLimit + 1) % caseStudies.length;
        setItemOffset(newOffset);
        postGrid.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        // Store items to use
        var caseStudiesToUse;
        // Handle Active Tag
        if (activeTag) {
            caseStudiesToUse = caseStudies.filter(function(item) {
                if (item.fields.tags) {
                    var tagIds = item.fields.tags.map(function(tag) {
                        return tag.sys.id;
                    });
                    return tagIds.includes(activeTag.sys.id);
                }
                return false;
            });
        } else {
            caseStudiesToUse = caseStudies;
        }
        // Set Featured Case Study
        if (currentPage === 1) {
            setFeaturedCaseStudy(caseStudiesToUse[0]);
        }
        var endOffset = itemOffset + displayLimit;
        setCurrentItems(caseStudiesToUse.slice(itemOffset, endOffset));
        setPageCount(Math.ceil((caseStudiesToUse.length - 1) / displayLimit));
        // Set Current Page
        setCurrentPage(Math.floor(itemOffset / displayLimit));
    }, [
        itemOffset,
        displayLimit,
        activeTag
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Red",
        className: "text-primary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "py-9 sm:max-w-1130 lg:py-[72px]",
            children: [
                filterTags && /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestPostFilters, {
                    activeTag: activeTag,
                    handleFilter: function(tag) {
                        setActiveTag(tag);
                        setItemOffset(1);
                        setCurrentPage(1);
                    },
                    tags: filterTags
                }),
                featuredCaseStudy && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedArticle, {
                    pageType: "case-studies",
                    fields: featuredCaseStudy.fields,
                    preTitle: "FEATURED Case Study",
                    sys: featuredCaseStudy.sys,
                    metadata: featuredCaseStudy.metadata,
                    toPlainObject: featuredCaseStudy.toPlainObject,
                    update: featuredCaseStudy.update
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            level: "h2",
                            style: "Heading 6",
                            className: "mb-6 uppercase",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: title.fields.content
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-5 md:grid-cols-2 lg:grid-cols-3",
                            ref: postGrid,
                            children: currentItems.map(function(param, index) {
                                var _fields = param.fields, slug = _fields.slug, image = _fields.image, tags = _fields.tags, title = _fields.title;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-aos": "fade-up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightCard, {
                                        link: "/case-studies/".concat(slug.fields.slug),
                                        image: image === null || image === void 0 ? void 0 : image.fields.asset,
                                        tags: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                                            return tag.fields;
                                        }),
                                        title: title
                                    })
                                }, "caseStudy_".concat(index));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    nextLabel: "NEXT",
                    previousLabel: "PREV",
                    onPageChange: handlePageClick,
                    pageCount: pageCount,
                    forcePage: currentPage,
                    pageRangeDisplayed: 2,
                    marginPagesDisplayed: 1,
                    containerClassName: "pagination mt-9 lg:mt-16 flex justify-center font-display-a font-extrabold text-primary lg:text-2xl",
                    activeClassName: "opacity-50",
                    disabledClassName: "hidden",
                    renderOnZeroPageCount: function() {
                        return null;
                    }
                })
            ]
        })
    });
};
// Cache for the response
var CaseStudyPostGrid_responseCache;
/**
 * Get Case Study Post Grid Enhanced Props
 * @param component - Component.
 * @param preview - Preview mode status.
 * @returns
 */ function getCaseStudyPostGridEnhancedProps(component) {
    return _getCaseStudyPostGridEnhancedProps.apply(this, arguments);
}
function _getCaseStudyPostGridEnhancedProps() {
    _getCaseStudyPostGridEnhancedProps = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(component) {
        var preview, caseStudyPages, resultsFound, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    preview = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    ;
                    if (!CaseStudyPostGrid_responseCache) {
                        _ctx.next = 6;
                        break;
                    }
                    {
                        caseStudyPages = CaseStudyPostGrid_responseCache;
                    }
                    _ctx.next = 10;
                    break;
                case 6:
                    _ctx.next = 8;
                    return httpClient/* httpClient.contentful.retrieveLatestCaseStudies */.M.contentful.retrieveLatestCaseStudies({
                        limit: 999,
                        locale: "en-GB"
                    }, preview);
                case 8:
                    caseStudyPages = _ctx.sent;
                    CaseStudyPostGrid_responseCache = caseStudyPages;
                case 10:
                    resultsFound = caseStudyPages.items.length > 0;
                    component.fields.caseStudies = [];
                    if (resultsFound) {
                        component.fields.caseStudies = caseStudyPages.items.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                fields: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.fields), {
                                    tags: item.fields.tags ? item.fields.tags.filter(function(tag) {
                                        return tag.fields;
                                    }) : []
                                })
                            });
                        });
                    }
                    return _ctx.abrupt("return", component);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCaseStudyPostGridEnhancedProps.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/components/Organisms/Con24/Con24.tsx
/* Dependencies */ 
// Components





/**
 * Form- CON024
 * @param TypeCon24
 * @returns
 */ var Con24 = function(param) {
    var _fields = param.fields, form = _fields.form, subheading = _fields.subheading, bodyCopy = _fields.bodyCopy, title = _fields.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "Transparent",
        className: "my-8 text-primary lg:my-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            className: "max-w-1270 pb-10 lg:px-14 lg:pb-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-y-8 gap-x-5 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:max-w-335",
                        children: [
                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                style: "Heading 6",
                                className: "mb-3 uppercase lg:mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: subheading
                                })
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h3",
                                style: "Heading 2",
                                className: "mb-14 text-plum lg:mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: title.fields.content
                                })
                            }),
                            bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                content: bodyCopy.fields.content
                            })
                        ]
                    }),
                    form && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full bg-fill",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderForm/* RenderForm */.X, {
                            form: form
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/inev17/Inev17.tsx
/* Dependencies */ 
// Components





/**
 * POST CONTENT FIGURES - INEV11
 * @param TypeInev17
 * @returns
 */ var Inev17 = function(param) {
    var _fields = param.fields, theme = _fields.theme, title = _fields.title, bodyCopy = _fields.bodyCopy, form = _fields.form;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "my-12 flex flex-col items-center justify-between lg:flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex max-w-1130 flex-col px-10 pt-0 pb-16 lg:order-first lg:w-5/12 lg:py-16 lg:pl-32",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h2",
                        font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                        style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                        className: "mb-6 font-display-s lg:mb-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title === null || title === void 0 ? void 0 : title.fields.content
                        })
                    }),
                    bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                        variant: "base",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: bodyCopy.fields.content
                        })
                    })
                ]
            }),
            form && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:w-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerArrow/* ContainerArrow */.r, {
                    arrowsSide: "Left",
                    arrowsSize: "None",
                    bgColour: theme.fields.colourScheme.toLowerCase(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-10 py-12 lg:ml-auto lg:w-4/5 lg:py-16 lg:px-14",
                        children: [
                            form.fields.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                level: "h2",
                                font: "".concat((ref = form.fields.title) === null || ref === void 0 ? void 0 : ref.fields.fontFamily),
                                style: "".concat((ref1 = form.fields.title) === null || ref1 === void 0 ? void 0 : ref1.fields.style),
                                className: "mb-6 font-display-s lg:mb-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                                    content: (ref2 = form.fields.title) === null || ref2 === void 0 ? void 0 : ref2.fields.content
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderForm/* RenderForm */.X, {
                                form: form
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/components.ts
// Components












































var componentMap = {
    demoComponent: DemoComponent,
    richTextBlock: RichTextBlock,
    blockRichText: RichTextBlock,
    blockColouredPanel: ColouredPanel,
    con02: Con02,
    con04: Con04,
    con05: Con05,
    con06: Con06,
    con07: Con07,
    con08: Con08,
    con09: Con09,
    con10: Con10,
    con11: Con11,
    con13: Con13,
    con14: Con14,
    con15: Con15,
    con16: Con16,
    con17: Con17,
    con18: Con18,
    con19: Con19,
    con20: Con20,
    con22: Con22,
    con23: Con23,
    con24: Con24,
    con25: Con25,
    con26: Con26,
    testimonial: Con27,
    blockContentChildNav: Con28,
    con29: Con29,
    con30: Con30,
    con31: Con31,
    con32: Con32,
    hb01: Hb01/* Hb01 */.C,
    hb02: Hb02,
    hb03: Hb03,
    inev03: Inev03,
    blockCaseStudyPostCarousel: Inev03,
    inev06: Inev06,
    inev07: InsightPostGrid,
    blockEventPostGrid: EventPostGrid,
    blockCaseStudyPostGrid: CaseStudyPostGrid,
    inev10: Inev10,
    inev11: Inev11,
    inev12: Inev12,
    inev16: Inev16,
    inev17: Inev17
};
var components_componentEnhancers = {
    inev03: getInev03EnhancedProps,
    blockCaseStudyPostCarousel: getInev03EnhancedProps,
    inev07: getInsightPostGridEnhancedProps,
    blockEventPostGrid: getEventPostGridEnhancedProps,
    blockCaseStudyPostGrid: getCaseStudyPostGridEnhancedProps
};

;// CONCATENATED MODULE: ./src/components/Mappers/MapComponents/MapComponents.tsx
/* Dependencies */ 





// Models
/**
 * Map the desired components and render.
 * @param components - Components returned from Contentful.
 * @returns
 */ var MapComponents = function(param) {
    var components = param.components;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: components && components.map(function(component) {
            if (!component || !component.sys || !component.sys.contentType) {
                return;
            }
            var Element = componentMap[component.sys.contentType.sys.id];
            if (!Element) {
                console.log("Component not found", component.sys.contentType.sys.id);
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread/* default */.Z)({}, component), component.sys.id);
        })
    });
};
function enhanceComponents(components, preview) {
    return _enhanceComponents.apply(this, arguments);
}
function _enhanceComponents() {
    _enhanceComponents = _async_to_generator(regeneratorRuntime.mark(function _callee(components, preview) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, component, enhancer;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!components) {
                        _ctx.next = 30;
                        break;
                    }
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _ctx.prev = 2;
                    _iterator = components[Symbol.iterator]();
                case 4:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _ctx.next = 16;
                        break;
                    }
                    component = _step.value;
                    if (!(!component || !component.sys || !component.sys.contentType)) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 8:
                    enhancer = componentEnhancers[component.sys.contentType.sys.id];
                    if (!enhancer) {
                        _ctx.next = 13;
                        break;
                    }
                    console.log("Enhancing", component.sys.contentType.sys.id);
                    _ctx.next = 13;
                    return enhancer(component, preview);
                case 13:
                    _iteratorNormalCompletion = true;
                    _ctx.next = 4;
                    break;
                case 16:
                    _ctx.next = 22;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](2);
                    _didIteratorError = true;
                    _iteratorError = _ctx.t0;
                case 22:
                    _ctx.prev = 22;
                    _ctx.prev = 23;
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                case 25:
                    _ctx.prev = 25;
                    if (!_didIteratorError) {
                        _ctx.next = 28;
                        break;
                    }
                    throw _iteratorError;
                case 28:
                    return _ctx.finish(25);
                case 29:
                    return _ctx.finish(22);
                case 30:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                18,
                22,
                30
            ],
            [
                23,
                ,
                25,
                29
            ]
        ]);
    }));
    return _enhanceComponents.apply(this, arguments);
}


/***/ }),

/***/ 6911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ ContainerArrow; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var dist_aos = __webpack_require__(8279);
;// CONCATENATED MODULE: ./src/components/Molecules/ContainerArrow/ContainerArrow.model.ts
/* Dependencies */ var backgroundColor = Object.freeze({
    transparent: "",
    red: "theme-red",
    blue: "theme-blue",
    plum: "theme-plum"
});

;// CONCATENATED MODULE: ./src/components/Molecules/ContainerArrow/ContainerArrow.tsx
/* Dependencies */ 



// importing aos


// Models

/**
 * ContainerArrow - Creates a section wrapper.
 * @param props - Required component props.
 * @returns
 */ var ContainerArrow = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, classNameWrapper = param.classNameWrapper, _className = param.className, className = _className === void 0 ? "" : _className, _arrowsSide = param.arrowsSide, arrowsSide = _arrowsSide === void 0 ? "Right" : _arrowsSide, _arrowsSize = param.arrowsSize, arrowsSize = _arrowsSize === void 0 ? "" : _arrowsSize, _border = param.border, border = _border === void 0 ? false : _border, _bgColour = param.bgColour, bgColour = _bgColour === void 0 ? "transparent" : _bgColour, _overlap = param.overlap, overlap = _overlap === void 0 ? false : _overlap, _animation = param.animation, animation = _animation === void 0 ? undefined : _animation;
    (0,react.useEffect)(function() {
        if (animation) {
            aos_default().init({
                throttleDelay: 5,
                offset: 50,
                duration: 750,
                delay: 150,
                once: true
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "".concat(classNameWrapper, " ").concat(overlap ? "absolute z-10 h-[calc(100%-100px)] " : "", " ").concat(backgroundColor[bgColour]),
        ref: ref
    }, animation ? {
        "data-aos": animation
    } : {}), {
        children: [
            border && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(className, " clip-container_").concat(arrowsSide.toLowerCase(), "_border").concat(arrowsSize ? "_" + arrowsSize.toLocaleLowerCase() : "", " relative h-full w-full bg-fill"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "clip-container_".concat(arrowsSide.toLowerCase()).concat(arrowsSize ? "_" + arrowsSize.toLocaleLowerCase() : "", " absolute top-0 bottom-0 h-full ").concat(arrowsSide == "Right" ? "left-0 right-[18px]" : "left-[18px] right-0", " flex flex-col justify-center overflow-hidden p-8 text-primary"),
                    children: children
                })
            }),
            !border && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(className, " clip-container_").concat(arrowsSide.toLowerCase()).concat(arrowsSize ? "_" + arrowsSize.toLocaleLowerCase() : "", " relative h-full overflow-hidden bg-fill text-primary"),
                children: children
            })
        ]
    }));
});
// Set Display Name
ContainerArrow.displayName = "ContainerArrow";


/***/ }),

/***/ 6622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ RichText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/helpers/prefixSlug/prefixSlug.ts
var prefixSlug = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/helpers/getSlugUrl/getSlugUrl.ts
var getSlugUrl = __webpack_require__(4912);
// EXTERNAL MODULE: ./src/components/Molecules/Image/Image.tsx
var Image = __webpack_require__(3083);
// EXTERNAL MODULE: ./src/components/Atoms/Link/Link.tsx + 2 modules
var Link = __webpack_require__(2601);
// EXTERNAL MODULE: ./src/components/Atoms/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(5121);
// EXTERNAL MODULE: ./src/components/Atoms/Paragraph/Paragraph.tsx + 1 modules
var Paragraph = __webpack_require__(4609);
// EXTERNAL MODULE: ./src/components/Atoms/BlockQuote/BlockQuote.tsx
var BlockQuote = __webpack_require__(8496);
// EXTERNAL MODULE: ./src/components/Atoms/UnorderedList/UnorderedList.tsx
var UnorderedList = __webpack_require__(23);
;// CONCATENATED MODULE: ./src/components/Atoms/OrderedList/OrderedList.tsx
/* Dependencies */ 
/**
 * Ordered List
 * @param props - Required component props.
 * @returns
 */ var OrderedList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        className: "w-full list-decimal pl-5",
        children: children
    });
};

// EXTERNAL MODULE: ./src/components/Mappers/MapComponents/MapComponents.tsx + 70 modules
var MapComponents = __webpack_require__(5153);
// EXTERNAL MODULE: ./src/components/Atoms/LinkButton/LinkButton.tsx
var LinkButton = __webpack_require__(94);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(6437);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(4129);
;// CONCATENATED MODULE: ./src/components/Molecules/RichText/RichText.tsx
/* Dependencies */ 

// Helpers


// Components









// Contentful


/**
 * Rich Text Component
 * @params props - Required component props.
 */ var RichText = function(param) {
    var content = param.content;
    var _obj, _obj1;
    // Optiopns
    var renderOptions = {
        renderMark: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.MARKS.BOLD, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: text
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.MARKS.ITALIC, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                children: text
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.MARKS.UNDERLINE, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                children: text
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.MARKS.CODE, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                children: text
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, dist.INLINES.HYPERLINK, function(node, children) {
            var ref, ref1;
            if ((ref = node.data) === null || ref === void 0 ? void 0 : ref.uri.startsWith("/")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    to: (0,prefixSlug/* prefixSlug */.O)(node.data.uri),
                    className: "underline underline-offset-2",
                    variant: "none",
                    children: children
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                to: (ref1 = node.data) === null || ref1 === void 0 ? void 0 : ref1.uri,
                className: "underline underline-offset-2",
                variant: "none",
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.INLINES.ENTRY_HYPERLINK, function(node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                variant: "none",
                to: (0,getSlugUrl/* getSlugUrl */.q)(node.data.target),
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.INLINES.ASSET_HYPERLINK, function(node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                variant: "none",
                to: node.data.target.fields.file.url,
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_1, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-8 w-full last:mb-0 lg:mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h1",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_2, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-8 w-full last:mb-0 lg:mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    className: "lg:text-[50px]",
                    level: "h2",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_3, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-6 w-full last:mb-0 lg:mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h3",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_4, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-6 w-full last:mb-0 lg:mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h4",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_5, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-6 w-full last:mb-0 lg:mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h5",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_6, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-6 w-full last:mb-0 lg:mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    level: "h6",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.QUOTE, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-16 w-full last:mb-0 lg:my-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* BlockQuote */.R, {
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.OL_LIST, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-8 w-full last:mb-0 lg:mb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderedList, {
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.UL_LIST, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-8 w-full last:mb-0 lg:mb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnorderedList/* UnorderedList */.Q, {
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.PARAGRAPH, function(_node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-8 w-full last:mb-0 lg:mb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                    variant: "base",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.EMBEDDED_ENTRY, function(node) {
            if (node.data.target.sys.contentType.sys.id === "link") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mb-16 w-full last:mb-0 lg:mb-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                        to: node.data.target.fields.url,
                        children: node.data.target.fields.title
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-16 w-full last:mb-0 lg:my-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapComponents/* MapComponents */.n, {
                    components: [
                        node.data.target
                    ]
                })
            });
        }), (0,_define_property/* default */.Z)(_obj1, dist.BLOCKS.EMBEDDED_ASSET, function(node) {
            // Image
            if (node.data.target.fields.file.contentType.includes("image")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mb-16 w-full last:mb-0 lg:my-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        file: node.data.target,
                        aspectRatio: "fluid"
                    })
                });
            } else if (node.data.target.fields.file.contentType.includes("video")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mb-16 w-full last:mb-0 lg:my-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        controls: true,
                        src: node.data.target.fields.file.url
                    })
                });
            } else if (node.data.target.fields.file.contentType.includes("pdf") || node.data.target.fields.file.contentType.includes("application")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mb-16 w-full last:mb-0 lg:mb-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkButton/* LinkButton */.Q, {
                        to: node.data.target.fields.file.url,
                        children: [
                            "Download: ",
                            node.data.target.fields.title
                        ]
                    })
                });
            } else {
                console.log("Unsupported asset type", node.data.target.fields.file);
                return null;
            }
        }), _obj1)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rich-text whitespace-pre-line",
        children: content && (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)({
            data: content.data,
            nodeType: dist.BLOCKS.DOCUMENT,
            content: content.content
        }, renderOptions)
    });
};


/***/ }),

/***/ 6336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ RenderForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(196);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/helpers/getLinkUrl/getLinkUrl.ts
var getLinkUrl = __webpack_require__(1180);
;// CONCATENATED MODULE: ./src/helpers/handleFieldError/handleFieldError.ts
/* Dependencies */ 
/**
 * Handle Field errors.
 * @param errors - Formik Errors
 * @param touched - Formik Touched
 * @param property - Property to check
 * @returns
 */ var handleFieldError = function(errors, touched, property) {
    return (0,formik_esm/* getIn */.u9)(errors, property) && (0,formik_esm/* getIn */.u9)(touched, property) ? (0,formik_esm/* getIn */.u9)(errors, property) : undefined;
};

// EXTERNAL MODULE: ./src/components/Atoms/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(8923);
// EXTERNAL MODULE: ./src/components/Atoms/Paragraph/Paragraph.tsx + 1 modules
var Paragraph = __webpack_require__(4609);
// EXTERNAL MODULE: ./src/components/Atoms/Link/Link.tsx + 2 modules
var Link = __webpack_require__(2601);
;// CONCATENATED MODULE: ./src/helpers/uniqueId/uniqueId.ts
/**
 * Generates a unique id.
 */ var uniqueId = function() {
    return "_" + Math.random().toString(36).substr(2, 9);
};

;// CONCATENATED MODULE: ./src/helpers/getDescribedBy/getDescribedBy.ts
/**
 * Sets the described by values for the field.
 * @param props - The props to be used.
 * @returns
 */ var getDescribedBy = function(props) {
    var describedBy = "";
    if (props.toolTip) {
        describedBy += "".concat(props.id, "_").concat(props.name, "-tooltip ");
    }
    if (props.error || props.supportText) {
        describedBy += "".concat(props.id, "_").concat(props.name, "-help");
    }
    return describedBy;
};

;// CONCATENATED MODULE: ./src/components/Molecules/Forms/Checkbox/Checkbox.tsx
/* Dependencies */ var _this = undefined;


// Helpers


/**
 * Input Component
 */ var Checkbox = function(param) {
    var checked = param.checked, disabled = param.disabled, error = param.error, label = param.label, name = param.name, onChange = param.onChange, onBlur = param.onBlur, readOnly = param.readOnly, required = param.required, supportText = param.supportText, value = param.value;
    // Set The Initial State
    var ref = (0,react.useState)(uniqueId()), id = ref[0];
    var ref1 = (0,react.useState)(""), describedBy = ref1[0], setDescribedBy = ref1[1];
    // Set the Tool tip on ID Change
    (0,react.useEffect)(function() {
        setDescribedBy(getDescribedBy({
            error: error,
            id: id,
            name: name,
            supportText: supportText
        }));
    }, [
        id,
        error,
        name,
        supportText
    ]);
    // Render the component.
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: id,
                className: "relative flex cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: id,
                        type: "checkbox",
                        name: name,
                        onChange: onChange.bind(_this),
                        onBlur: onBlur.bind(_this),
                        "aria-invalid": error ? true : false,
                        "aria-describedby": describedBy,
                        required: required,
                        readOnly: readOnly,
                        disabled: disabled,
                        value: value,
                        defaultChecked: checked,
                        className: "peer invisible absolute opacity-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "relative pl-8 font-display-s text-2xl leading-5 ".concat(error && "text-red-600", " before:absolute before:left-0 before:h-4 before:w-4 before:rounded-sm before:border before:border-primary before:bg-center before:bg-no-repeat peer-checked:before:bg-white\n          peer-checked:before:bg-tick-plum peer-checked:before:bg-[length:80%] ").concat(error ? "before:text-primary" : "before:focus:ring-plum", "\n          "),
                        children: label
                    })
                ]
            }),
            supportText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 flex w-full flex-row flex-wrap items-start",
                children: supportText && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    className: "text-sm",
                    id: "".concat(id, "_").concat(name, "-help"),
                    children: supportText
                })
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Molecules/Forms/Input/Input.tsx
/* Dependencies */ var Input_this = undefined;


// Helpers


// Functions
/**
 * References input event and default value to return char count.
 * @param event - The input event if available.
 * @param defaultValue - The default component value.
 */ var characterCount = function(defaultValue, event) {
    return !event ? defaultValue.length : event.target.value.length;
};
/**
 * Input Component
 */ var Input = function(param) {
    var autoFocus = param.autoFocus, autoComplete = param.autoComplete, disabled = param.disabled, error = param.error, inputMode = param.inputMode, label = param.label, max = param.max, maxLength = param.maxLength, min = param.min, minLength = param.minLength, name = param.name, onChange = param.onChange, onBlur = param.onBlur, placeholder = param.placeholder, readOnly = param.readOnly, required = param.required, showCharCount = param.showCharCount, supportText = param.supportText, type = param.type, value = param.value;
    // Set The Initial State
    var ref = (0,react.useState)(uniqueId()), id = ref[0];
    var ref1 = (0,react.useState)(0), charCount = ref1[0], setCharCount = ref1[1];
    var ref2 = (0,react.useState)(""), describedBy = ref2[0], setDescribedBy = ref2[1];
    // Set the Tool tip on ID Change
    (0,react.useEffect)(function() {
        setDescribedBy(getDescribedBy({
            error: error,
            id: id,
            name: name,
            supportText: supportText
        }));
    }, [
        id,
        error,
        name,
        supportText
    ]);
    /**
   * Sets the character count
   */ (0,react.useEffect)(function() {
        if (showCharCount) {
            setCharCount(characterCount(value));
        }
    }, [
        showCharCount,
        value
    ]);
    // Render the component.
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: id,
                className: "relative flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: id,
                        type: type,
                        name: name,
                        onChange: onChange.bind(Input_this),
                        onBlur: onBlur.bind(Input_this),
                        "aria-invalid": error ? true : false,
                        "aria-describedby": describedBy,
                        max: max,
                        maxLength: maxLength,
                        min: min,
                        minLength: minLength,
                        required: required,
                        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label,
                        readOnly: readOnly,
                        disabled: disabled,
                        autoComplete: autoComplete,
                        autoFocus: autoFocus,
                        value: value ? value : "",
                        inputMode: inputMode ? inputMode : "text",
                        className: "peer h-9 border-b bg-transparent placeholder-transparent outline-0 outline-transparent ".concat(error && "focus:outline-none focus:ring-red", " block w-full pr-10 ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute top-1/2 block w-full -translate-y-8 text-xs transition-all peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-small peer-focus:-translate-y-8 peer-focus:text-xs lg:peer-placeholder-shown:text-base lg:peer-focus:text-xs",
                        children: label
                    })
                ]
            }),
            showCharCount || error || supportText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 flex w-full flex-row flex-wrap items-start",
                children: [
                    error || supportText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        className: "text-xs ".concat(error && "text-secondary"),
                        id: "".concat(id, "_").concat(name, "-help"),
                        "data-character-count": maxLength,
                        children: !error ? supportText : error
                    }) : null,
                    showCharCount && maxLength ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                        className: "ml-auto text-right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "sr-only",
                                "aria-live": "polite",
                                "aria-atomic": "true",
                                children: [
                                    "You have ",
                                    maxLength - charCount,
                                    " characters remaining."
                                ]
                            }),
                            charCount,
                            "/",
                            maxLength
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(4853);
;// CONCATENATED MODULE: ./src/components/Molecules/Forms/ReCaptcha/ReCaptcha.tsx
/* Dependencies */ 


/**
 * ReCaptcha Component
 * @param props - Required component props.
 */ var ReCaptcha = function(param) {
    var onChange = param.onChange, onError = param.onError, onExpire = param.onExpire, error = param.error;
    // Render the component.
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-wrap items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                sitekey: "6LcDQ_siAAAAAOMGMV6kf2Zsx4JBdkkTun2ZaKLP",
                onChange: function(value) {
                    onChange(value);
                },
                onErrored: function() {
                    onError();
                    onChange(null);
                },
                onExpired: function() {
                    onExpire();
                },
                onReset: function() {
                    onError();
                }
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 flex w-full flex-row flex-wrap items-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    className: "text-small ".concat(error && "text-primary"),
                    children: error
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/QuestionList/QuestionList.tsx



var QuestionList = function(param) {
    var questions = param.questions, values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleFieldError = param.handleFieldError;
    if (questions.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: questions.map(function(param, index) {
            var question = param.question, required = param.required;
            return question && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    label: question,
                    name: "formQuestion".concat(index),
                    value: values["formQuestion".concat(index)],
                    onChange: handleChange,
                    onBlur: handleBlur,
                    error: handleFieldError(errors, touched, "formQuestion".concat(index)),
                    required: required,
                    inputMode: "text",
                    type: "text"
                })
            }, index);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./src/components/Organisms/Forms/EmailNewsletterForm/EmailNewsletterForm.model.ts
/* Dependencies */ 
var EmailNewsletterFormSchema = function(questions) {
    var schemaFields = {
        source: es/* string */.Z_().required("Field is required"),
        firstName: es/* string */.Z_().required("Field is required"),
        lastName: es/* string */.Z_().required("Field is required"),
        jobTitle: es/* string */.Z_().required("Field is required"),
        email: es/* string */.Z_().email("Invalid email").required("Field is required"),
        company: es/* string */.Z_().required("Field is required"),
        recaptcha: es/* string */.Z_().required("Field is required"),
        terms: es/* boolean */.O7().isTrue("Field is required").required("Field is required")
    };
    questions.forEach(function(param, index) {
        var question = param.question, required = param.required;
        if (question) {
            var validator = es/* string */.Z_();
            validator = required ? validator.required("Field is required") : validator.optional();
            schemaFields["formQuestion".concat(index)] = validator;
        }
    });
    return es/* object */.Ry().shape(schemaFields);
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/EmailNewsletterForm/EmailNewsletterForm.tsx
/* Dependencies */ 






// Helpers


// Components







// Models

/**
 * Email Newsletter Form
 * @param EmailNewsletterForm
 * @returns
 */ var EmailNewsletterForm = function(param) {
    var formid = param.formid, source = param.source, callToAction = param.callToAction, questions = param.questions;
    var ref = (0,react.useState)(false), showSuccessMessage = ref[0], setShowSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), showErrorMessage = ref1[0], setShowErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var initialValues = {
        source: source,
        firstName: "",
        lastName: "",
        jobTitle: "",
        email: "",
        company: "",
        recaptcha: "",
        terms: false,
        formQuestion0: "",
        formQuestion1: "",
        formQuestion2: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            initialValues: initialValues,
            validationSchema: EmailNewsletterFormSchema(questions),
            onSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                    var resetForm, formData, url, target;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                resetForm = param.resetForm;
                                if (!isSubmitting) {
                                    _ctx.next = 3;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 3:
                                formData = {
                                    source: values.source,
                                    firstName: values.firstName,
                                    lastName: values.lastName,
                                    jobTitle: values.jobTitle,
                                    email: values.email,
                                    company: values.company,
                                    recaptcha: values.recaptcha,
                                    terms: values.terms,
                                    questions: questions.map(function(question, index) {
                                        return {
                                            question: question.question,
                                            answer: values["formQuestion".concat(index)]
                                        };
                                    })
                                };
                                // Set Submission State
                                setIsSubmitting(true);
                                _ctx.next = 7;
                                return axios/* default.post */.ZP.post("/api/emailform", (0,_object_spread/* default */.Z)({
                                    formType: "EmailNewsletter",
                                    formid: formid
                                }, formData)).then(function() {
                                    setShowErrorMessage(false);
                                    setShowSuccessMessage(true);
                                    // Reset the form
                                    resetForm();
                                }).catch(function() {
                                    setShowSuccessMessage(false);
                                    setShowErrorMessage(true);
                                });
                            case 7:
                                // Optional Link / Download
                                if (callToAction) {
                                    url = (0,getLinkUrl/* getLinkUrl */.U)(callToAction);
                                    target = callToAction.fields.openInNewTab ? "_blank" : "_self";
                                    if (url) {
                                        setTimeout(function() {
                                            window.open(url, target);
                                        }, 500);
                                    }
                                }
                                // Set Submission State
                                setIsSubmitting(false);
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(values, _) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(param) {
                var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, isSubmitting = param.isSubmitting, setFieldTouched = param.setFieldTouched, setFieldError = param.setFieldError, setFieldValue = param.setFieldValue;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    action: "POST",
                    onSubmit: handleSubmit,
                    className: "space-y-5 lg:space-y-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid w-full grid-cols-1 gap-5 md:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "First Name",
                                    name: "firstName",
                                    type: "text",
                                    value: values.firstName,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "firstName"),
                                    inputMode: "text",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Last Name",
                                    name: "lastName",
                                    type: "text",
                                    value: values.lastName,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "lastName"),
                                    inputMode: "text",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "Email",
                                name: "email",
                                type: "email",
                                value: values.email,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "email"),
                                inputMode: "email",
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid w-full grid-cols-1 gap-5 md:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Job Title",
                                    name: "jobTitle",
                                    type: "text",
                                    value: values.jobTitle,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "jobTitle"),
                                    inputMode: "text",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Company",
                                    name: "company",
                                    type: "text",
                                    value: values.company,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "company"),
                                    inputMode: "text",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList, {
                            questions: questions,
                            values: values,
                            handleChange: handleChange,
                            handleBlur: handleBlur,
                            handleFieldError: handleFieldError,
                            errors: errors,
                            touched: touched
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha, {
                                onError: function() {
                                    setFieldTouched("recaptcha", true);
                                    setFieldValue("recaptcha", "");
                                    setFieldError("recaptcha", "Captcha invalid, please try again.");
                                },
                                onExpire: function() {
                                    setFieldTouched("recaptcha", true);
                                    setFieldValue("recaptcha", "", true);
                                },
                                onChange: function(code) {
                                    setFieldTouched("recaptcha", true);
                                    setFieldValue("recaptcha", code, true);
                                },
                                error: handleFieldError(errors, touched, "recaptcha")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col items-baseline space-y-7 md:flex-row md:space-y-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:order-2 md:pt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                "By clicking “Submit” you agree to receive communications from MMT. You can unsubscribe at any time. MMT is committed to protecting your privacy and we'll only use your personal information in line with our\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                    to: "/privacy-policy",
                                                    title: "Main Logo",
                                                    openInNewTab: false,
                                                    variant: "none",
                                                    children: "Privacy Policy"
                                                })
                                            ]
                                        }),
                                        name: "terms",
                                        value: "terms",
                                        checked: values.terms,
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        error: handleFieldError(errors, touched, "terms"),
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full md:order-1 md:mr-5 md:w-auto md:basis-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* ActionButton */.K, {
                                        variant: "secondary",
                                        onClick: handleSubmit,
                                        children: "Submit"
                                    })
                                })
                            ]
                        }),
                        showSuccessMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 block w-full border border-primary p-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                children: "Success. Your message has been sent."
                            })
                        }),
                        showErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 block w-full border border-primary p-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                children: "Your message has not been sent. Please try again."
                            })
                        })
                    ]
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Molecules/Forms/TextArea/TextArea.tsx
/* Dependencies */ var TextArea_this = undefined;


// Helpers



/**
 * Input Component
 */ var TextArea = function(param) {
    var autoFocus = param.autoFocus, autoComplete = param.autoComplete, disabled = param.disabled, error = param.error, label = param.label, maxLength = param.maxLength, minLength = param.minLength, name = param.name, onChange = param.onChange, onBlur = param.onBlur, placeholder = param.placeholder, readOnly = param.readOnly, required = param.required, showCharCount = param.showCharCount, supportText = param.supportText, value = param.value;
    // Set The Initial State
    var ref = (0,react.useState)(uniqueId()), id = ref[0];
    var ref1 = (0,react.useState)(0), charCount = ref1[0], setCharCount = ref1[1];
    var ref2 = (0,react.useState)(""), describedBy = ref2[0], setDescribedBy = ref2[1];
    // Set The Initial ID
    (0,react.useEffect)(function() {
        if (showCharCount) {
            setCharCount(characterCount(value));
        }
    }, [
        showCharCount,
        value
    ]);
    // Set the Tool tip on ID Change
    (0,react.useEffect)(function() {
        setDescribedBy(getDescribedBy({
            error: error,
            id: id,
            name: name,
            supportText: supportText
        }));
    }, [
        id,
        error,
        name,
        supportText
    ]);
    /**
   * Sets the character count.
   */ (0,react.useEffect)(function() {
        if (showCharCount) {
            setCharCount(characterCount(value));
        }
    }, [
        showCharCount,
        value
    ]);
    // Render the component.
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                className: "block font-display-s text-base font-medium",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mt-1 rounded-md border shadow-sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                    id: id,
                    name: name,
                    onChange: onChange.bind(TextArea_this),
                    onBlur: onBlur.bind(TextArea_this),
                    "aria-invalid": error ? true : false,
                    "aria-describedby": describedBy,
                    maxLength: maxLength,
                    minLength: minLength,
                    required: required,
                    placeholder: placeholder,
                    readOnly: readOnly,
                    disabled: disabled,
                    autoComplete: autoComplete,
                    autoFocus: autoFocus,
                    value: value ? value : "",
                    inputMode: "text",
                    className: "min-h-150 resize-none border bg-transparent p-3 ".concat(error && "border-secondary text-red placeholder-red focus:border-red focus:outline-none focus:ring-red", " block w-full rounded-md pr-10")
                })
            }),
            showCharCount || error || supportText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-1 flex w-full flex-row flex-wrap items-start",
                children: [
                    error || supportText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        className: "".concat(error && "text-red"),
                        id: "".concat(id, "_").concat(name, "-help"),
                        "data-character-count": maxLength,
                        children: !error ? supportText : error
                    }) : null,
                    showCharCount && maxLength ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                        className: "ml-auto text-right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "sr-only",
                                "aria-live": "polite",
                                "aria-atomic": "true",
                                children: [
                                    "You have ",
                                    maxLength - charCount,
                                    " characters remaining."
                                ]
                            }),
                            charCount,
                            "/",
                            maxLength
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Molecules/Forms/Select/Select.tsx
/* Dependencies */ var Select_this = undefined;


// Helpers


/**
 * Input Component
 */ var Select = function(param) {
    var autoFocus = param.autoFocus, autoComplete = param.autoComplete, disabled = param.disabled, error = param.error, label = param.label, name = param.name, onChange = param.onChange, onBlur = param.onBlur, options = param.options, placeholder = param.placeholder, required = param.required, supportText = param.supportText, value = param.value;
    // Set The Initial State
    var ref = (0,react.useState)(uniqueId()), id = ref[0];
    var ref1 = (0,react.useState)(""), describedBy = ref1[0], setDescribedBy = ref1[1];
    // Set the Tool tip on ID Change
    (0,react.useEffect)(function() {
        setDescribedBy(getDescribedBy({
            error: error,
            id: id,
            name: name,
            supportText: supportText
        }));
    }, [
        id,
        error,
        name,
        supportText
    ]);
    // Render the component.
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                className: "block font-display-s text-base",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mt-1 rounded-md shadow-sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                    id: id,
                    name: name,
                    onChange: onChange.bind(Select_this),
                    onBlur: onBlur.bind(Select_this),
                    "aria-invalid": error ? true : false,
                    "aria-describedby": describedBy,
                    required: required,
                    placeholder: placeholder,
                    disabled: disabled,
                    autoComplete: autoComplete,
                    autoFocus: autoFocus,
                    value: value ? value : "",
                    className: "h-9 border-b bg-transparent text-small outline-0 lg:text-base ".concat(error && "border-red text-red placeholder-red focus:border-red focus:outline-none focus:ring-red ", " block w-full"),
                    children: [
                        placeholder ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            disabled: true,
                            children: placeholder
                        }) : null,
                        options.map(function(option) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                defaultChecked: option.selected,
                                value: option.key,
                                children: option.value
                            }, option.key);
                        })
                    ]
                })
            }),
            error || supportText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 flex w-full flex-row flex-wrap items-start",
                children: error || supportText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    className: "text-sm ".concat(error && "text-red"),
                    id: "".concat(id, "_").concat(name, "-help"),
                    children: !error ? supportText : error
                }) : null
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/ContactUsForm/ContactUsForm.model.ts
/* Dependencies */ 
var enquiryTypes = [
    {
        key: "general",
        value: "General"
    },
    {
        key: "business",
        value: "New Business"
    },
    {
        key: "partnerships",
        value: "Partnerships"
    },
    {
        key: "other",
        value: "Other"
    }, 
];
var ContactUsFormSchema = function(questions) {
    var schemaFields = {
        source: es/* string */.Z_().required("Field is required"),
        firstName: es/* string */.Z_().required("Field is required"),
        lastName: es/* string */.Z_().required("Field is required"),
        email: es/* string */.Z_().email("Invalid email").required("Field is required"),
        phone: es/* string */.Z_().optional(),
        enquiryType: es/* string */.Z_().required("Field is required"),
        message: es/* string */.Z_().required("Field is required"),
        recaptcha: es/* string */.Z_().required("Field is required"),
        terms: es/* boolean */.O7().isTrue("Field is required").required("Field is required")
    };
    questions.forEach(function(param, index) {
        var question = param.question, required = param.required;
        if (question) {
            var validator = es/* string */.Z_();
            validator = required ? validator.required("Field is required") : validator.optional();
            schemaFields["formQuestion".concat(index)] = validator;
        }
    });
    return es/* object */.Ry().shape(schemaFields);
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/ContactUsForm/ContactUsForm.tsx
/* Dependencies */ 






// Helpers


// Components









// Models

/**
 * Contact Us Form
 * @param ContactUsFormProps
 * @returns
 */ var ContactUsForm = function(param) {
    var formid = param.formid, source = param.source, questions = param.questions, callToAction = param.callToAction;
    var ref = (0,react.useState)(false), showSuccessMessage = ref[0], setShowSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), showErrorMessage = ref1[0], setShowErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var initialValues = {
        source: source,
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        enquiryType: enquiryTypes[0].key,
        message: "",
        recaptcha: "",
        terms: false,
        formQuestion0: "",
        formQuestion1: "",
        formQuestion2: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            initialValues: initialValues,
            validationSchema: ContactUsFormSchema(questions),
            onSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                    var resetForm, setSubmitting, formData, url, target;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                resetForm = param.resetForm, setSubmitting = param.setSubmitting;
                                if (!isSubmitting) {
                                    _ctx.next = 4;
                                    break;
                                }
                                console.log("Already submitting, please wait...");
                                return _ctx.abrupt("return");
                            case 4:
                                formData = {
                                    source: values.source,
                                    firstName: values.firstName,
                                    lastName: values.lastName,
                                    email: values.email,
                                    phone: values.phone,
                                    enquiryType: values.enquiryType,
                                    message: values.message,
                                    recaptcha: values.recaptcha,
                                    terms: values.terms,
                                    questions: questions.map(function(question, index) {
                                        return {
                                            question: question.question,
                                            answer: values["formQuestion".concat(index)]
                                        };
                                    })
                                };
                                // Set Submission State
                                setIsSubmitting(true);
                                _ctx.next = 8;
                                return axios/* default.post */.ZP.post("/api/emailform", (0,_object_spread/* default */.Z)({
                                    formType: "ContactUs",
                                    formid: formid
                                }, formData)).then(function() {
                                    setShowErrorMessage(false);
                                    setShowSuccessMessage(true);
                                    // Reset the form
                                    resetForm();
                                }).catch(function() {
                                    setShowSuccessMessage(false);
                                    setShowErrorMessage(true);
                                });
                            case 8:
                                // Optional Link / Download
                                if (callToAction) {
                                    url = (0,getLinkUrl/* getLinkUrl */.U)(callToAction);
                                    target = callToAction.fields.openInNewTab ? "_blank" : "_self";
                                    if (url) {
                                        setTimeout(function() {
                                            window.open(url, target);
                                        }, 500);
                                    }
                                }
                                // Set Submission State
                                setIsSubmitting(false);
                            case 10:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(values, _) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(param) {
                var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, isSubmitting = param.isSubmitting, setFieldValue = param.setFieldValue, setFieldError = param.setFieldError, setFieldTouched = param.setFieldTouched;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    action: "POST",
                    onSubmit: handleSubmit,
                    className: "space-y-5 lg:space-y-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid w-full grid-cols-1 gap-y-8 md:grid-cols-2 md:gap-x-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "First Name",
                                    name: "firstName",
                                    type: "text",
                                    value: values.firstName,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "firstName"),
                                    inputMode: "text",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Last Name",
                                    name: "lastName",
                                    type: "text",
                                    value: values.lastName,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "lastName"),
                                    inputMode: "text",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid w-full grid-cols-1 gap-y-6 md:grid-cols-2 md:gap-x-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Email",
                                    name: "email",
                                    type: "email",
                                    value: values.email,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "email"),
                                    inputMode: "email",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Phone",
                                    name: "phone",
                                    type: "tel",
                                    value: values.phone,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "phone"),
                                    inputMode: "tel",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                                label: "Enquiry Type",
                                name: "enquiryType",
                                value: values.enquiryType,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "enquiryType"),
                                options: enquiryTypes,
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, {
                                label: "Message",
                                name: "message",
                                value: values.message,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "message"),
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList, {
                            questions: questions,
                            values: values,
                            handleChange: handleChange,
                            handleBlur: handleBlur,
                            handleFieldError: handleFieldError,
                            errors: errors,
                            touched: touched
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha, {
                                onError: function() {
                                    setFieldTouched("recaptcha", true);
                                    setFieldValue("recaptcha", "");
                                    setFieldError("recaptcha", "Captcha invalid, please try again.");
                                },
                                onExpire: function() {
                                    setFieldTouched("recaptcha", true);
                                    setFieldValue("recaptcha", "", true);
                                },
                                onChange: function(code) {
                                    setFieldTouched("recaptcha", true);
                                    setFieldValue("recaptcha", code, true);
                                },
                                error: handleFieldError(errors, touched, "recaptcha")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col items-baseline space-y-7 md:flex-row md:space-y-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:order-2 md:pt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                "By clicking “Submit” you agree to receive communications from MMT. You can unsubscribe at any time. MMT is committed to protecting your privacy and we'll only use your personal information in line with our\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                    to: "/privacy-policy",
                                                    title: "Main Logo",
                                                    openInNewTab: false,
                                                    variant: "none",
                                                    children: "Privacy Policy"
                                                })
                                            ]
                                        }),
                                        name: "terms",
                                        value: "terms",
                                        checked: values.terms,
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        error: handleFieldError(errors, touched, "terms"),
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full md:order-1 md:mr-5 md:w-auto md:basis-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* ActionButton */.K, {
                                        variant: "secondary",
                                        onClick: handleSubmit,
                                        children: "Submit"
                                    })
                                })
                            ]
                        }),
                        showSuccessMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 block w-full border border-primary p-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                children: "Success. Your message has been sent."
                            })
                        }),
                        showErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 block w-full border border-primary p-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                                children: "Your message has not been sent. Please try again."
                            })
                        })
                    ]
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/EbookForm/EbookForm.model.ts
/* Dependencies */ 
var EbookFormSchema = function(questions) {
    var schemaFields = {
        source: es/* string */.Z_().required("Field is required"),
        firstName: es/* string */.Z_().required("Field is required"),
        lastName: es/* string */.Z_().required("Field is required"),
        jobTitle: es/* string */.Z_().required("Field is required"),
        email: es/* string */.Z_().email("Invalid email").required("Field is required"),
        phone: es/* string */.Z_().optional(),
        company: es/* string */.Z_().required("Field is required"),
        utm_source: es/* string */.Z_().optional(),
        recaptcha: es/* string */.Z_().required("Field is required"),
        terms: es/* boolean */.O7().isTrue("Field is required").required("Field is required")
    };
    questions.forEach(function(param, index) {
        var question = param.question, required = param.required;
        if (question) {
            var validator = es/* string */.Z_();
            validator = required ? validator.required("Field is required") : validator.optional();
            schemaFields["formQuestion".concat(index)] = validator;
        }
    });
    return es/* object */.Ry().shape(schemaFields);
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/Organisms/Forms/EbookForm/EbookForm.tsx
/* eslint-disable react-hooks/exhaustive-deps */ /* Dependencies */ 






// Helpers


// Components







// Models


/**
 * Email Newsletter Form
 * @param EbookFormProps
 * @returns
 */ var EbookForm = function(param) {
    var formid = param.formid, source = param.source, questions = param.questions, callToAction = param.callToAction;
    var ref = (0,react.useState)(false), showSuccessMessage = ref[0], setShowSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), showErrorMessage = ref1[0], setShowErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var ref3 = (0,react.useState)(""), utmSource = ref3[0], setUtmSource = ref3[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (typeof router.query.utm_source === "string") {
            setUtmSource(router.query.utm_source);
        } else if (Array.isArray(router.query.utm_source)) {
            var ref;
            setUtmSource((ref = router.query.utm_source[0]) === null || ref === void 0 ? void 0 : ref.toString());
        }
    }, [
        router.isReady
    ]);
    var initialValues = {
        source: source,
        firstName: "",
        lastName: "",
        jobTitle: "",
        email: "",
        phone: "",
        company: "",
        utm_source: "",
        recaptcha: "",
        terms: false,
        formQuestion0: "",
        formQuestion1: "",
        formQuestion2: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: initialValues,
        validationSchema: EbookFormSchema(questions),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var resetForm, formData, url, target;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetForm = param.resetForm;
                            if (!isSubmitting) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            formData = {
                                source: values.source,
                                firstName: values.firstName,
                                lastName: values.lastName,
                                jobTitle: values.jobTitle,
                                email: values.email,
                                phone: values.phone,
                                company: values.company,
                                recaptcha: values.recaptcha,
                                terms: values.terms,
                                questions: questions.map(function(question, index) {
                                    return {
                                        question: question.question,
                                        answer: values["formQuestion".concat(index)]
                                    };
                                })
                            };
                            // Set Submission State
                            setIsSubmitting(true);
                            values.utm_source = utmSource;
                            _ctx.next = 8;
                            return axios/* default.post */.ZP.post("/api/emailform", (0,_object_spread/* default */.Z)({
                                formType: "Ebook",
                                formid: formid
                            }, formData)).then(function() {
                                setShowErrorMessage(false);
                                setShowSuccessMessage(true);
                                // Reset the form
                                resetForm();
                            }).catch(function() {
                                setShowSuccessMessage(false);
                                setShowErrorMessage(true);
                            });
                        case 8:
                            // Optional Link / Download
                            if (callToAction) {
                                url = (0,getLinkUrl/* getLinkUrl */.U)(callToAction);
                                target = callToAction.fields.openInNewTab ? "_blank" : "_self";
                                if (url) {
                                    setTimeout(function() {
                                        window.open(url, target);
                                    }, 500);
                                }
                            }
                            // Set Submission State
                            setIsSubmitting(false);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, isSubmitting = param.isSubmitting, setFieldError = param.setFieldError, setFieldTouched = param.setFieldTouched, setFieldValue = param.setFieldValue;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                action: "POST",
                onSubmit: handleSubmit,
                className: "space-y-5 lg:space-y-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid w-full grid-cols-1 gap-5 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "First Name",
                                name: "firstName",
                                type: "text",
                                value: values.firstName,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "firstName"),
                                inputMode: "text",
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "Last Name",
                                name: "lastName",
                                type: "text",
                                value: values.lastName,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "lastName"),
                                inputMode: "text",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            label: "Job Title",
                            name: "jobTitle",
                            type: "text",
                            value: values.jobTitle,
                            onChange: handleChange,
                            onBlur: handleBlur,
                            error: handleFieldError(errors, touched, "jobTitle"),
                            inputMode: "text",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid w-full grid-cols-1 gap-5 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "Company",
                                name: "company",
                                type: "text",
                                value: values.company,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "company"),
                                inputMode: "text",
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "Phone",
                                name: "phone",
                                type: "tel",
                                value: values.phone,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "phone"),
                                inputMode: "tel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            label: "Email",
                            name: "email",
                            type: "email",
                            value: values.email,
                            onChange: handleChange,
                            onBlur: handleBlur,
                            error: handleFieldError(errors, touched, "email"),
                            inputMode: "email",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList, {
                        questions: questions,
                        values: values,
                        handleChange: handleChange,
                        handleBlur: handleBlur,
                        handleFieldError: handleFieldError,
                        errors: errors,
                        touched: touched
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha, {
                            onError: function() {
                                setFieldTouched("recaptcha", true);
                                setFieldValue("recaptcha", "");
                                setFieldError("recaptcha", "Captcha invalid, please try again.");
                            },
                            onExpire: function() {
                                setFieldTouched("recaptcha", true);
                                setFieldValue("recaptcha", "", true);
                            },
                            onChange: function(code) {
                                setFieldTouched("recaptcha", true);
                                setFieldValue("recaptcha", code, true);
                            },
                            error: handleFieldError(errors, touched, "recaptcha")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col items-baseline space-y-7 md:flex-row md:space-y-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:order-2 md:pt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "By clicking “Submit” you agree to receive communications from MMT. You can unsubscribe at any time. MMT is committed to protecting your privacy and we'll only use your personal information in line with our\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                to: "/privacy-policy",
                                                title: "Main Logo",
                                                openInNewTab: false,
                                                variant: "none",
                                                children: "Privacy Policy"
                                            })
                                        ]
                                    }),
                                    name: "terms",
                                    value: "terms",
                                    checked: values.terms,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "terms"),
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:order-1 md:mr-5 md:w-auto md:basis-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* ActionButton */.K, {
                                    variant: "tertiary",
                                    onClick: handleSubmit,
                                    children: "Submit"
                                })
                            })
                        ]
                    }),
                    showSuccessMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 block w-full border border-primary p-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            children: "Success. Your message has been sent."
                        })
                    }),
                    showErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 block w-full border border-primary p-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            children: "Your message has not been sent. Please try again."
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/EventForm/EventForm.model.ts
/* Dependencies */ 
var EventFormSchema = function(questions) {
    var schemaFields = {
        source: es/* string */.Z_().required("Field is required"),
        firstName: es/* string */.Z_().required("Field is required"),
        lastName: es/* string */.Z_().required("Field is required"),
        jobTitle: es/* string */.Z_().required("Field is required"),
        email: es/* string */.Z_().email("Invalid email").required("Field is required"),
        phone: es/* string */.Z_().optional(),
        company: es/* string */.Z_().required("Field is required"),
        utm_source: es/* string */.Z_().optional(),
        recaptcha: es/* string */.Z_().required("Field is required"),
        terms: es/* boolean */.O7().isTrue("Field is required").required("Field is required")
    };
    questions.forEach(function(param, index) {
        var question = param.question, required = param.required;
        if (question) {
            var validator = es/* string */.Z_();
            validator = required ? validator.required("Field is required") : validator.optional();
            schemaFields["formQuestion".concat(index)] = validator;
        }
    });
    return es/* object */.Ry().shape(schemaFields);
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/EventForm/EventForm.tsx
/* eslint-disable react-hooks/exhaustive-deps */ /* Dependencies */ 







// Helpers


// Components







// Models

/**
 * Email Newsletter Form
 * @param EventFormProps
 * @returns
 */ var EventForm = function(param) {
    var formid = param.formid, source = param.source, questions = param.questions, callToAction = param.callToAction;
    var ref = (0,react.useState)(false), showSuccessMessage = ref[0], setShowSuccessMessage = ref[1];
    var ref1 = (0,react.useState)(false), showErrorMessage = ref1[0], setShowErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var ref3 = (0,react.useState)(""), utmSource = ref3[0], setUtmSource = ref3[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (typeof router.query.utm_source === "string") {
            setUtmSource(router.query.utm_source);
        } else if (Array.isArray(router.query.utm_source)) {
            var ref;
            setUtmSource((ref = router.query.utm_source[0]) === null || ref === void 0 ? void 0 : ref.toString());
        }
    }, [
        router.isReady
    ]);
    var initialValues = {
        source: source,
        firstName: "",
        lastName: "",
        jobTitle: "",
        email: "",
        phone: "",
        company: "",
        utm_source: "",
        recaptcha: "",
        terms: false,
        formQuestion0: "",
        formQuestion1: "",
        formQuestion2: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: initialValues,
        validationSchema: EventFormSchema(questions),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var resetForm, formData, url, target;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetForm = param.resetForm;
                            if (!isSubmitting) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            formData = {
                                source: values.source,
                                firstName: values.firstName,
                                lastName: values.lastName,
                                jobTitle: values.jobTitle,
                                email: values.email,
                                phone: values.phone,
                                company: values.company,
                                utm_source: values.utm_source,
                                recaptcha: values.recaptcha,
                                terms: values.terms,
                                questions: questions.map(function(question, index) {
                                    return {
                                        question: question.question,
                                        answer: values["formQuestion".concat(index)]
                                    };
                                })
                            };
                            // Set Submission State
                            setIsSubmitting(true);
                            values.utm_source = utmSource;
                            _ctx.next = 8;
                            return axios/* default.post */.ZP.post("/api/emailform", (0,_object_spread/* default */.Z)({
                                formType: "Event",
                                formid: formid
                            }, formData)).then(function() {
                                setShowErrorMessage(false);
                                setShowSuccessMessage(true);
                                // Reset the form
                                resetForm();
                            }).catch(function() {
                                setShowSuccessMessage(false);
                                setShowErrorMessage(true);
                            });
                        case 8:
                            // Optional Link / Download
                            if (callToAction) {
                                url = (0,getLinkUrl/* getLinkUrl */.U)(callToAction);
                                target = callToAction.fields.openInNewTab ? "_blank" : "_self";
                                if (url) {
                                    setTimeout(function() {
                                        window.open(url, target);
                                    }, 500);
                                }
                            }
                            // Set Submission State
                            setIsSubmitting(false);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, isSubmitting = param.isSubmitting, setFieldError = param.setFieldError, setFieldTouched = param.setFieldTouched, setFieldValue = param.setFieldValue;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                action: "POST",
                onSubmit: handleSubmit,
                className: "space-y-5 lg:space-y-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid w-full grid-cols-1 gap-5 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "First Name",
                                name: "firstName",
                                type: "text",
                                value: values.firstName,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "firstName"),
                                inputMode: "text",
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "Last Name",
                                name: "lastName",
                                type: "text",
                                value: values.lastName,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "lastName"),
                                inputMode: "text",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            label: "Job Title",
                            name: "jobTitle",
                            type: "text",
                            value: values.jobTitle,
                            onChange: handleChange,
                            onBlur: handleBlur,
                            error: handleFieldError(errors, touched, "jobTitle"),
                            inputMode: "text",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid w-full grid-cols-1 gap-5 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "Company",
                                name: "company",
                                type: "text",
                                value: values.company,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "company"),
                                inputMode: "text",
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                label: "Phone",
                                name: "phone",
                                type: "tel",
                                value: values.phone,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                error: handleFieldError(errors, touched, "phone"),
                                inputMode: "tel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            label: "Email",
                            name: "email",
                            type: "email",
                            value: values.email,
                            onChange: handleChange,
                            onBlur: handleBlur,
                            error: handleFieldError(errors, touched, "email"),
                            inputMode: "email",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList, {
                        questions: questions,
                        values: values,
                        handleChange: handleChange,
                        handleBlur: handleBlur,
                        handleFieldError: handleFieldError,
                        errors: errors,
                        touched: touched
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha, {
                            onError: function() {
                                setFieldTouched("recaptcha", true);
                                setFieldValue("recaptcha", "");
                                setFieldError("recaptcha", "Captcha invalid, please try again.");
                            },
                            onExpire: function() {
                                setFieldTouched("recaptcha", true);
                                setFieldValue("recaptcha", "", true);
                            },
                            onChange: function(code) {
                                setFieldTouched("recaptcha", true);
                                setFieldValue("recaptcha", code, true);
                            },
                            error: handleFieldError(errors, touched, "recaptcha")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col items-baseline space-y-7 md:flex-row md:space-y-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:order-2 md:pt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "By clicking “Submit” you agree to receive communications from MMT and the event partners. You can unsubscribe at any time. MMT is committed to protecting your privacy and we'll only use your personal information in line with our\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                to: "/privacy-policy",
                                                title: "Main Logo",
                                                openInNewTab: false,
                                                variant: "none",
                                                children: "Privacy Policy"
                                            })
                                        ]
                                    }),
                                    name: "terms",
                                    value: "terms",
                                    checked: values.terms,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: handleFieldError(errors, touched, "terms"),
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:order-1 md:mr-5 md:w-auto md:basis-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* ActionButton */.K, {
                                    variant: "tertiary",
                                    onClick: handleSubmit,
                                    children: "Submit"
                                })
                            })
                        ]
                    }),
                    showSuccessMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 block w-full border border-primary p-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            children: "Success. Your message has been sent."
                        })
                    }),
                    showErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 block w-full border border-primary p-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                            children: "Your message has not been sent. Please try again."
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Organisms/Forms/RenderForm/RenderForm.tsx
/* Dependencies */ 
// Components




/**
 * Render Form
 * @param TypeForm
 * @returns
 */ var RenderForm = function(param) {
    var _form = param.form, id = _form.sys.id, _fields = _form.fields, sourceIdentifier = _fields.sourceIdentifier, formType = _fields.formType, formQuestion1 = _fields.formQuestion1, formQuestion2 = _fields.formQuestion2, formQuestion3 = _fields.formQuestion3, formQuestion1Required = _fields.formQuestion1Required, formQuestion2Required = _fields.formQuestion2Required, formQuestion3Required = _fields.formQuestion3Required, onSubmitAction = _fields.onSubmitAction;
    var questions = [
        formQuestion1 && {
            question: formQuestion1,
            required: Boolean(formQuestion1Required)
        },
        formQuestion2 && {
            question: formQuestion2,
            required: Boolean(formQuestion2Required)
        },
        formQuestion3 && {
            question: formQuestion3,
            required: Boolean(formQuestion3Required)
        }, 
    ].filter(Boolean);
    switch(formType){
        case "Email Newsletter":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailNewsletterForm, {
                    formid: id,
                    source: sourceIdentifier,
                    callToAction: onSubmitAction,
                    questions: questions
                });
            }
        case "Contact Us":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsForm, {
                    formid: id,
                    source: sourceIdentifier,
                    callToAction: onSubmitAction,
                    questions: questions
                });
            }
        case "Ebook":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EbookForm, {
                    formid: id,
                    source: sourceIdentifier,
                    callToAction: onSubmitAction,
                    questions: questions
                });
            }
        case "Event":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventForm, {
                    formid: id,
                    source: sourceIdentifier,
                    callToAction: onSubmitAction,
                    questions: questions
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            }
    }
};


/***/ }),

/***/ 9616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ Hb01; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/Molecules/ComponentWrapper/ComponentWrapper.tsx + 1 modules
var ComponentWrapper = __webpack_require__(6175);
// EXTERNAL MODULE: ./src/components/Molecules/Container/Container.tsx
var Container = __webpack_require__(6320);
// EXTERNAL MODULE: ./src/components/Atoms/PlainRichText/PlainRichText.tsx
var PlainRichText = __webpack_require__(9791);
// EXTERNAL MODULE: ./src/components/Atoms/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(5121);
// EXTERNAL MODULE: ./src/components/Atoms/Paragraph/Paragraph.tsx + 1 modules
var Paragraph = __webpack_require__(4609);
// EXTERNAL MODULE: ./src/components/Molecules/CTATandem/CTATandem.tsx
var CTATandem = __webpack_require__(9697);
;// CONCATENATED MODULE: ./src/components/Organisms/Hb01/Hb01.model.ts
var sizes = Object.freeze({
    Small: "min-h-150 md:min-h-290",
    Medium: "min-h-400",
    Large: "h-[calc(100vh-96px)] min-h-400 md:h-auto lg:min-h-700"
});

;// CONCATENATED MODULE: ./src/components/Organisms/Hb01/Hb01.tsx
/* Dependencies */ 
// Components







/**
 * HERO BANNER TITLE - HB01
 * @param TypeHb01
 * @returns
 */ var Hb01 = function(param) {
    var _fields = param.fields, title = _fields.title, bodyCopy = _fields.bodyCopy, callsToAction = _fields.callsToAction, theme = _fields.theme, _variant = _fields.variant, variant = _variant === void 0 ? "Medium" : _variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper/* ComponentWrapper */.N, {
        backgroundColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.fields.colourScheme),
        className: "flex items-center py-16 ".concat(sizes[variant]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "".concat(variant === "Large" ? "sm:max-w-800" : "sm:max-w-1308"),
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                        level: "h1",
                        font: "".concat(title === null || title === void 0 ? void 0 : title.fields.fontFamily),
                        style: "".concat(title === null || title === void 0 ? void 0 : title.fields.style),
                        className: "".concat(bodyCopy ? "mb-6 lg:mb-8" : "", " ").concat(callsToAction ? "mb-8 lg:mb-16" : "", " break-words text-center text-primary lg:break-normal"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: title === null || title === void 0 ? void 0 : title.fields.content
                        })
                    })
                }),
                bodyCopy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-aos": "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                        variant: "base",
                        className: "mb-6 text-center text-primary lg:mb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainRichText/* PlainRichText */.t, {
                            content: bodyCopy === null || bodyCopy === void 0 ? void 0 : bodyCopy.fields.content
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTATandem/* CTATandem */.t, {
                    callsToAction: callsToAction
                })
            ]
        })
    });
};


/***/ }),

/***/ 7707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PreviewModeOverlay; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8264);
/* Dependencies */ 

/**
 * Preview Mode Overlay Component
 */ var PreviewModeOverlay = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed bottom-2 left-1/2 z-50 w-full max-w-500 -translate-x-1/2 rounded-md border-2 border-indigo-800 bg-white p-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "h-5 w-5 text-indigo-700",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-3 flex-1 items-center md:flex md:justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm text-indigo-700",
                            children: "Preview Mode is Enabled."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-3 text-sm md:mt-0 md:ml-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: function() {
                                    window.location.href = "/api/clear-preview?redirect=".concat(encodeURIComponent(window.location.pathname));
                                },
                                className: "whitespace-nowrap font-medium text-indigo-700 hover:text-indigo-900",
                                children: [
                                    "Deactivate Preview",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "→"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 3032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PageContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* Dependencies */ 
var PageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageTitle: ""
});
PageContext.displayName = "PageContext";


/***/ }),

/***/ 5247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ generateOgImages; }
/* harmony export */ });
/* Dependencies */ /**
 * Generates an array of Open Graph image objects from the given SEO details.
 *
 * @param {Contentful.Entry<TypeSeoDetailsFields> | undefined} seo - The SEO details entry from Contentful.
 * @returns {Array<{ url: string; width: number; height: number; alt: string; type: string }> | undefined} - An array of Open Graph image objects or undefined if no image is present.
 */ var generateOgImages = function(seo) {
    if (seo && seo.fields && seo.fields.image) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return [
            {
                url: (ref = seo.fields.image) === null || ref === void 0 ? void 0 : ref.fields.file.url,
                width: ((ref1 = seo.fields.image) === null || ref1 === void 0 ? void 0 : ref1.fields.file.details.image) ? (ref2 = seo.fields.image) === null || ref2 === void 0 ? void 0 : ref2.fields.file.details.image.width : 0,
                height: ((ref3 = seo.fields.image) === null || ref3 === void 0 ? void 0 : ref3.fields.file.details.image) ? (ref4 = seo.fields.image) === null || ref4 === void 0 ? void 0 : ref4.fields.file.details.image.height : 0,
                alt: (ref5 = seo.fields.image) === null || ref5 === void 0 ? void 0 : ref5.fields.title,
                type: (ref6 = seo.fields.image) === null || ref6 === void 0 ? void 0 : ref6.fields.file.contentType
            }, 
        ];
    }
    return undefined;
};


/***/ }),

/***/ 2282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "e1": function() { return /* binding */ getFormattedDateTime; },
/* harmony export */   "xz": function() { return /* binding */ getFormattedTime; }
/* harmony export */ });
/**
 * Get expected format date
 * @param date - Insight date.
 * @returns Formatted Date - DD/MM/YY
 */ var getFormattedDate = function(date) {
    if (!date) return undefined;
    return new Date(String(date)).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit"
    });
};
/**
 * Get time formatted
 * @param date - Event date.
 * @returns Formatted Time - HH:MM in 24 hour format
 */ var getFormattedTime = function(date) {
    if (!date) return undefined;
    return new Date(String(date)).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit"
    });
};
/**
 * Get date and time formatted
 * @param date - Event date.
 * @returns Formatted Date and Time - DD/MM/YY HH:MM in 24 hour format
 */ var getFormattedDateTime = function(date) {
    if (!date) date = new Date(Date.now()).toString();
    var datePortion = new Date(String(date)).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit"
    });
    var timePortion = new Date(String(date)).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit"
    });
    return datePortion + " " + timePortion;
};


/***/ })

}]);